/* eslint-disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  JSONObject: any;
};

export type Account = {
  __typename?: 'Account';
  admin?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  customer_bcc_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  keys?: Maybe<Array<Maybe<Key>>>;
  response_status?: Maybe<ResponseStatus>;
  updated?: Maybe<Scalars['String']>;
};

export type AccountResponse = {
  __typename?: 'AccountResponse';
  admin?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  token?: Maybe<Scalars['String']>;
};

export type AccountRole = {
  __typename?: 'AccountRole';
  account_id?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  updated?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type AccountRoleRequest = {
  Role?: InputMaybe<Scalars['String']>;
  UserID?: InputMaybe<Scalars['Int']>;
};

export type ActiveOptions = {
  __typename?: 'ActiveOptions';
  cancel_policy?: Maybe<Scalars['String']>;
  instant_book?: Maybe<Scalars['Boolean']>;
  minimum_nights?: Maybe<Scalars['Int']>;
  use_day_pricing?: Maybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: Maybe<Scalars['Boolean']>;
};

export type ActivePrice = {
  __typename?: 'ActivePrice';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  week?: Maybe<Scalars['Int']>;
};

export type ActivePriceInput = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  week?: InputMaybe<Scalars['Int']>;
};

export type ActivitiesResult = {
  __typename?: 'ActivitiesResult';
  activities?: Maybe<Array<Activity>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Activity = {
  __typename?: 'Activity';
  acting_user_id?: Maybe<Scalars['Int']>;
  actor_info?: Maybe<ActivityActorInfo>;
  booking_info?: Maybe<ActivityBookingInfo>;
  conversation_info?: Maybe<ActivityConversationInfo>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  meta?: Maybe<Scalars['JSON']>;
  read?: Maybe<Scalars['Boolean']>;
  receiver_info?: Maybe<ActivityReceiverInfo>;
  rental_info?: Maybe<ActivityRentalInfo>;
  response_status?: Maybe<ResponseStatus>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type ActivityActorInfo = {
  __typename?: 'ActivityActorInfo';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
};

export type ActivityBookingInfo = {
  __typename?: 'ActivityBookingInfo';
  id?: Maybe<Scalars['Int']>;
};

export type ActivityConversationInfo = {
  __typename?: 'ActivityConversationInfo';
  id?: Maybe<Scalars['Int']>;
};

export type ActivityReceiverInfo = {
  __typename?: 'ActivityReceiverInfo';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
};

export type ActivityRentalInfo = {
  __typename?: 'ActivityRentalInfo';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  primary_image_url?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_etc?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_etc?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AlgoliaKey = {
  __typename?: 'AlgoliaKey';
  algolia_index?: Maybe<Scalars['String']>;
  algolia_token?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
};

export type AmenitiesResult = {
  __typename?: 'AmenitiesResult';
  groups?: Maybe<Array<AmenityGroup>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Amenity = {
  __typename?: 'Amenity';
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSON']>;
  position?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

export type AmenityGroup = {
  __typename?: 'AmenityGroup';
  amenities?: Maybe<Array<Amenity>>;
  group?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  fileType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AttributesActiveOptions = {
  __typename?: 'AttributesActiveOptions';
  cancel_policy?: Maybe<Scalars['String']>;
  cancel_policy_combo_bookings?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  instant_book?: Maybe<Scalars['Boolean']>;
  minimum_days?: Maybe<Scalars['Int']>;
  monthly_discount_percentage?: Maybe<Scalars['Float']>;
  monthly_rate_per_day?: Maybe<Scalars['Int']>;
  price_per_day?: Maybe<Scalars['Int']>;
  price_per_month?: Maybe<Scalars['Int']>;
  price_per_week?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  use_day_pricing?: Maybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: Maybe<Scalars['Boolean']>;
  weekly_discount_percentage?: Maybe<Scalars['Float']>;
  weekly_rate_per_day?: Maybe<Scalars['Int']>;
};

export type AttributesActiveOptionsInput = {
  cancel_policy?: InputMaybe<Scalars['String']>;
  cancel_policy_combo_bookings?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  instant_book?: InputMaybe<Scalars['Boolean']>;
  minimum_days?: InputMaybe<Scalars['Int']>;
  monthly_discount_percentage?: InputMaybe<Scalars['Float']>;
  monthly_rate_per_day?: InputMaybe<Scalars['Int']>;
  price_per_day?: InputMaybe<Scalars['Int']>;
  price_per_month?: InputMaybe<Scalars['Int']>;
  price_per_week?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['Int']>;
  use_day_pricing?: InputMaybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: InputMaybe<Scalars['Boolean']>;
  weekly_discount_percentage?: InputMaybe<Scalars['Float']>;
  weekly_rate_per_day?: InputMaybe<Scalars['Int']>;
};

export type AttributesAverageRatings = {
  __typename?: 'AttributesAverageRatings';
  cleanliness_score?: Maybe<Scalars['Float']>;
  cleanliness_score_percentage?: Maybe<Scalars['Float']>;
  communication_score?: Maybe<Scalars['Float']>;
  communication_score_percentage?: Maybe<Scalars['Float']>;
  listing_score?: Maybe<Scalars['Float']>;
  listing_score_percentage?: Maybe<Scalars['Float']>;
  mechanical_score?: Maybe<Scalars['Float']>;
  mechanical_score_percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  score_percentage?: Maybe<Scalars['Float']>;
  value_score?: Maybe<Scalars['Float']>;
  value_score_percentage?: Maybe<Scalars['Float']>;
};

export type AttributesAverageRatingsInput = {
  cleanliness_score?: InputMaybe<Scalars['Float']>;
  cleanliness_score_percentage?: InputMaybe<Scalars['Float']>;
  communication_score?: InputMaybe<Scalars['Float']>;
  communication_score_percentage?: InputMaybe<Scalars['Float']>;
  listing_score?: InputMaybe<Scalars['Float']>;
  listing_score_percentage?: InputMaybe<Scalars['Float']>;
  mechanical_score?: InputMaybe<Scalars['Float']>;
  mechanical_score_percentage?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  score_percentage?: InputMaybe<Scalars['Float']>;
  value_score?: InputMaybe<Scalars['Float']>;
  value_score_percentage?: InputMaybe<Scalars['Float']>;
};

export type AttributesAverageReviews = {
  __typename?: 'AttributesAverageReviews';
  owner?: Maybe<Array<Maybe<AverageInfo>>>;
  rental?: Maybe<Array<Maybe<AverageInfo>>>;
  score?: Maybe<Scalars['Float']>;
};

export type AttributesAverageReviewsInput = {
  owner?: InputMaybe<Array<InputMaybe<AverageInfoInput>>>;
  rental?: InputMaybe<Array<InputMaybe<AverageInfoInput>>>;
  score?: InputMaybe<Scalars['Float']>;
};

export type AttributesTag = {
  __typename?: 'AttributesTag';
  count?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type AttributesTagInput = {
  count?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type AutoClaimAnimalIncidentDetail = {
  __typename?: 'AutoClaimAnimalIncidentDetail';
  animalType?: Maybe<Scalars['String']>;
  incidentComments?: Maybe<Scalars['String']>;
};

export type AutoClaimCollisionIncidentDetails = {
  __typename?: 'AutoClaimCollisionIncidentDetails';
  causeOfAccident?: Maybe<Scalars['String']>;
  incidentComments?: Maybe<Scalars['String']>;
  lightConditions?: Maybe<Scalars['String']>;
  numberOfPassengersInInsuredVehicle?: Maybe<Scalars['Int']>;
  numberOfPassengersInOtherVehicles?: Maybe<Scalars['Int']>;
  numberOfVehiclesInvolved?: Maybe<Scalars['String']>;
  roadMarkings?: Maybe<Scalars['String']>;
  roadType?: Maybe<Scalars['String']>;
  speedLimit?: Maybe<Scalars['String']>;
  totalNumberOfPassengersInAllVehicles?: Maybe<Scalars['Int']>;
  weatherConditions?: Maybe<Scalars['String']>;
};

export type AutoClaimFireIncidentDetail = {
  __typename?: 'AutoClaimFireIncidentDetail';
  cctvPresent?: Maybe<Scalars['Boolean']>;
  lastActivityWithVehicle?: Maybe<Scalars['String']>;
  lastDrivenBy?: Maybe<Scalars['String']>;
  lastServicedAt?: Maybe<Scalars['String']>;
  lastServicedBy?: Maybe<Scalars['String']>;
  vehicleLocationType?: Maybe<Scalars['String']>;
  whyWasVehicleAtLocation?: Maybe<Scalars['String']>;
};

export type AutoClaimGlassIncidentDetail = {
  __typename?: 'AutoClaimGlassIncidentDetail';
  isGlassRepairable?: Maybe<Scalars['Boolean']>;
};

export type AutoClaimRiotOrCivilUnrestIncidentDetail = {
  __typename?: 'AutoClaimRiotOrCivilUnrestIncidentDetail';
  estimatedValueOfBelongings?: Maybe<Scalars['String']>;
  glassOnlyDamage?: Maybe<Scalars['Boolean']>;
  numberOfKeysOwned?: Maybe<Scalars['Int']>;
  personalBelongingsComments?: Maybe<Scalars['String']>;
  personalBelongingsInVehicle?: Maybe<Scalars['Boolean']>;
  wasVehicleLocked?: Maybe<Scalars['String']>;
  wereKeysInVehicle?: Maybe<Scalars['String']>;
};

export type AutoClaimTheftOfPartsIncidentDetail = {
  __typename?: 'AutoClaimTheftOfPartsIncidentDetail';
  estimatedValueOfBelongings?: Maybe<Scalars['String']>;
  numberOfKeysOwned?: Maybe<Scalars['Int']>;
  personalBelongingsComments?: Maybe<Scalars['String']>;
  personalBelongingsInVehicle?: Maybe<Scalars['Boolean']>;
  wasVehicleLocked?: Maybe<Scalars['String']>;
  wereKeysInVehicle?: Maybe<Scalars['String']>;
};

export type AutoClaimTheftOfVehicleIncidentDetail = {
  __typename?: 'AutoClaimTheftOfVehicleIncidentDetail';
  estimatedValueOfBelongings?: Maybe<Scalars['String']>;
  glassOrDebrisAtLocation?: Maybe<Scalars['Boolean']>;
  howWasVehicleDiscoveredStolen?: Maybe<Scalars['String']>;
  howWasVehicleStolen?: Maybe<Scalars['String']>;
  lastActivityWithVehicle?: Maybe<Scalars['String']>;
  lastDrivenBy?: Maybe<Scalars['String']>;
  numberOfKeysOwned?: Maybe<Scalars['Int']>;
  personalBelongingsComments?: Maybe<Scalars['String']>;
  personalBelongingsInVehicle?: Maybe<Scalars['Boolean']>;
  vehicleHasBeenRecovered?: Maybe<Scalars['Boolean']>;
  vehicleLocationType?: Maybe<Scalars['String']>;
  wasVehicleLocked?: Maybe<Scalars['String']>;
  wereKeysInVehicle?: Maybe<Scalars['String']>;
};

export type AutoClaimTowOrBreakdownIncidentDetail = {
  __typename?: 'AutoClaimTowOrBreakdownIncidentDetail';
  type?: Maybe<Scalars['String']>;
};

export type AutoClaimVandalismIncidentDetail = {
  __typename?: 'AutoClaimVandalismIncidentDetail';
  estimatedValueOfBelongings?: Maybe<Scalars['String']>;
  glassOnlyDamage?: Maybe<Scalars['Boolean']>;
  numberOfKeysOwned?: Maybe<Scalars['Int']>;
  personalBelongingsComments?: Maybe<Scalars['String']>;
  personalBelongingsInVehicle?: Maybe<Scalars['Boolean']>;
  wasVehicleLocked?: Maybe<Scalars['String']>;
  wereKeysInVehicle?: Maybe<Scalars['String']>;
};

export type Availability = {
  __typename?: 'Availability';
  from?: Maybe<Scalars['String']>;
  next_available?: Maybe<Scalars['String']>;
  rental_id?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['String']>;
  turnaround_days?: Maybe<Scalars['Int']>;
};

export type AvailabilityResponse = {
  __typename?: 'AvailabilityResponse';
  availability?: Maybe<Array<Maybe<Availability>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type AverageInfo = {
  __typename?: 'AverageInfo';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['String']>;
};

export type AverageInfoInput = {
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['String']>;
};

export type Bui = {
  __typename?: 'BUI';
  bui?: Maybe<Scalars['JSON']>;
  response_status?: Maybe<ResponseStatus>;
};

export type BasePrice = {
  __typename?: 'BasePrice';
  attributes?: Maybe<BasePriceAttributes>;
  id?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  type?: Maybe<Scalars['String']>;
};

export type BasePriceAttributes = {
  __typename?: 'BasePriceAttributes';
  price?: Maybe<Scalars['Int']>;
};

export type BasePriceAttributesInput = {
  price?: InputMaybe<Scalars['Int']>;
};

export type BasePriceInput = {
  attributes?: InputMaybe<BasePriceAttributesInput>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Bid = {
  __typename?: 'Bid';
  bid_matches?: Maybe<Array<Maybe<BidMatch>>>;
  close_reason?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['String']>;
  closed_by_booking_id?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  created_by_booking_id?: Maybe<Scalars['Int']>;
  dest_lat?: Maybe<Scalars['Float']>;
  dest_lng?: Maybe<Scalars['Float']>;
  destination?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip_lookup?: Maybe<Scalars['Boolean']>;
  make?: Maybe<Scalars['String']>;
  max_budget?: Maybe<Scalars['Int']>;
  max_day_price?: Maybe<Scalars['Int']>;
  min_budget?: Maybe<Scalars['Int']>;
  min_day_price?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  open?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  pet_friendly?: Maybe<Scalars['Boolean']>;
  pickup_lat?: Maybe<Scalars['Float']>;
  pickup_lng?: Maybe<Scalars['Float']>;
  price_per_day?: Maybe<Scalars['Int']>;
  quality?: Maybe<Scalars['Float']>;
  rental_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  sent?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['String']>;
  travelers?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type BidInput = {
  close_reason?: InputMaybe<Scalars['String']>;
  closed?: InputMaybe<Scalars['String']>;
  closed_by_booking_id?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  created_by_booking_id?: InputMaybe<Scalars['Int']>;
  dest_lat?: InputMaybe<Scalars['Float']>;
  dest_lng?: InputMaybe<Scalars['Float']>;
  destination?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip_lookup?: InputMaybe<Scalars['Boolean']>;
  make?: InputMaybe<Scalars['String']>;
  max_budget?: InputMaybe<Scalars['Int']>;
  max_day_price?: InputMaybe<Scalars['Int']>;
  min_budget?: InputMaybe<Scalars['Int']>;
  min_day_price?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['Boolean']>;
  pet_friendly?: InputMaybe<Scalars['Boolean']>;
  pickup_lat?: InputMaybe<Scalars['Float']>;
  pickup_lng?: InputMaybe<Scalars['Float']>;
  price_per_day?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  sent?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['String']>;
  travelers?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type BidMatch = {
  __typename?: 'BidMatch';
  bid?: Maybe<Bid>;
  bid_id?: Maybe<Scalars['Int']>;
  booking?: Maybe<Booking>;
  booking_id?: Maybe<Scalars['Int']>;
  conversation?: Maybe<Conversation>;
  conversation_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  rental?: Maybe<Rental>;
  rental_id?: Maybe<Scalars['Int']>;
  renter?: Maybe<User>;
  renter_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type BidsResponse = {
  __typename?: 'BidsResponse';
  bids?: Maybe<Array<Bid>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Bio = {
  __typename?: 'Bio';
  description: Scalars['String'];
  experience: Scalars['String'];
  years_owned: Scalars['Int'];
  years_rving: Scalars['Int'];
};

export type BioInput = {
  description: Scalars['String'];
  experience: Scalars['String'];
  years_owned: Scalars['Int'];
  years_rving: Scalars['Int'];
};

export type Booking = {
  __typename?: 'Booking';
  abandoned?: Maybe<Scalars['Boolean']>;
  addons?: Maybe<Array<Maybe<BookingItem>>>;
  affirm_total?: Maybe<Scalars['Int']>;
  auto_assign_group?: Maybe<Scalars['Boolean']>;
  bid_id?: Maybe<Scalars['Int']>;
  booked?: Maybe<Scalars['String']>;
  booking_agent?: Maybe<Scalars['String']>;
  booking_token?: Maybe<Scalars['String']>;
  bundle_id?: Maybe<Scalars['String']>;
  calculated_day_price?: Maybe<Scalars['Int']>;
  campground_booking_url?: Maybe<Scalars['String']>;
  can_apply_credits?: Maybe<Scalars['Boolean']>;
  can_manage_security_deposit?: Maybe<Scalars['Boolean']>;
  can_renter_review?: Maybe<Scalars['Boolean']>;
  can_renter_review_until?: Maybe<Scalars['String']>;
  can_see_contract?: Maybe<Scalars['Boolean']>;
  cancel_policy?: Maybe<Scalars['String']>;
  canceled?: Maybe<Scalars['String']>;
  checkout_questions?: Maybe<Array<Maybe<CheckoutQuestion>>>;
  checkout_steps?: Maybe<CheckoutSteps>;
  checkout_steps_id?: Maybe<Scalars['Int']>;
  conversation_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_stamp?: Maybe<Scalars['String']>;
  custom_insurance_text?: Maybe<Scalars['String']>;
  default_insurance_coverage?: Maybe<Scalars['String']>;
  delivery?: Maybe<Delivery>;
  delivery_item?: Maybe<BookingItem>;
  delivery_usage_item?: Maybe<UsageBasedItem>;
  delivery_usage_item_id?: Maybe<Scalars['String']>;
  deposit_percentage?: Maybe<Scalars['Int']>;
  destination?: Maybe<Scalars['String']>;
  destination_lat?: Maybe<Scalars['Int']>;
  destination_lng?: Maybe<Scalars['Int']>;
  details?: Maybe<Details>;
  device_id?: Maybe<Scalars['String']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_code_amount?: Maybe<Scalars['Int']>;
  discount_code_applied_to?: Maybe<Scalars['String']>;
  discount_code_message?: Maybe<Scalars['String']>;
  display_insurance?: Maybe<Scalars['String']>;
  display_source?: Maybe<Scalars['String']>;
  display_status?: Maybe<Scalars['String']>;
  dropoff?: Maybe<Dropoff>;
  duration?: Maybe<Scalars['Int']>;
  express_checkout_id?: Maybe<Scalars['Int']>;
  external?: Maybe<Scalars['Boolean']>;
  fees_locked?: Maybe<Scalars['Boolean']>;
  final_payment_due_days?: Maybe<Scalars['Int']>;
  followup_archived?: Maybe<Scalars['Boolean']>;
  from?: Maybe<Scalars['String']>;
  from_time?: Maybe<Scalars['Int']>;
  fx_fee_paid?: Maybe<Scalars['Int']>;
  generator?: Maybe<Generator>;
  generator_usage_item?: Maybe<UsageBasedItem>;
  generator_usage_item_id?: Maybe<Scalars['Int']>;
  has_setup_intent_enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  include_coachnet?: Maybe<Scalars['Boolean']>;
  initial_duration?: Maybe<Scalars['Int']>;
  instamatch?: Maybe<Scalars['String']>;
  instant_book?: Maybe<Scalars['Boolean']>;
  insurance?: Maybe<Scalars['String']>;
  insurance_approved?: Maybe<Scalars['Boolean']>;
  insurance_bundle?: Maybe<BookingBundle>;
  insurance_claim_filed?: Maybe<Scalars['Boolean']>;
  insurance_coverage?: Maybe<Scalars['String']>;
  insurance_plan_id?: Maybe<InsurancePlanId>;
  insurance_renter_adjustable?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<BookingItem>>;
  locale?: Maybe<Locale>;
  location_id?: Maybe<Scalars['Int']>;
  mileage?: Maybe<Mileage>;
  mileage_usage_item?: Maybe<UsageBasedItem>;
  mileage_usage_item_id?: Maybe<Scalars['Int']>;
  minimum_deposit?: Maybe<Scalars['Int']>;
  missing_data?: Maybe<Array<Maybe<Scalars['String']>>>;
  non_refundable_total?: Maybe<Scalars['Int']>;
  offer_affirm?: Maybe<Scalars['Boolean']>;
  offer_insurance?: Maybe<Scalars['Boolean']>;
  offer_paypal_pay_later?: Maybe<Scalars['Boolean']>;
  offer_roadside?: Maybe<Scalars['Boolean']>;
  original_day_price?: Maybe<Scalars['Int']>;
  original_service_fee?: Maybe<Scalars['Int']>;
  outdoorsy_fee?: Maybe<Scalars['Int']>;
  owner?: Maybe<User>;
  owner_approved?: Maybe<Scalars['Boolean']>;
  owner_approved_at?: Maybe<Scalars['String']>;
  owner_did_review?: Maybe<Scalars['Boolean']>;
  owner_fees?: Maybe<Array<BookingItem>>;
  owner_id?: Maybe<Scalars['Int']>;
  owner_integrations_fee?: Maybe<Scalars['Int']>;
  owner_read?: Maybe<Scalars['Boolean']>;
  owner_summary?: Maybe<OwnerSummary>;
  partner_app?: Maybe<PartnerApp>;
  pending_transactions?: Maybe<Array<Maybe<PendingTransactions>>>;
  pickup?: Maybe<Pickup>;
  premium_total?: Maybe<Scalars['Int']>;
  presentment_currency?: Maybe<Scalars['String']>;
  processor_name?: Maybe<Scalars['String']>;
  proposals?: Maybe<Array<Maybe<Scalars['String']>>>;
  provide_insurance_binder?: Maybe<Scalars['Boolean']>;
  referred_owner_paid?: Maybe<Scalars['Boolean']>;
  referred_renter_paid?: Maybe<Scalars['Boolean']>;
  remainder_amount?: Maybe<Scalars['Int']>;
  remainder_due_date?: Maybe<Scalars['String']>;
  rental?: Maybe<Rental>;
  rental_amount_item?: Maybe<BookingItem>;
  rental_charge_card_id?: Maybe<Scalars['Int']>;
  rental_id?: Maybe<Scalars['Int']>;
  rental_object?: Maybe<Scalars['Int']>;
  rental_search?: Maybe<RentalSearch>;
  rental_summary?: Maybe<RentalSummary>;
  renter?: Maybe<User>;
  renter_approved?: Maybe<Scalars['Boolean']>;
  renter_approved_at?: Maybe<Scalars['String']>;
  renter_archived?: Maybe<Scalars['Boolean']>;
  renter_can_waive_insurance?: Maybe<Scalars['Boolean']>;
  renter_credits_applied?: Maybe<Scalars['Int']>;
  renter_did_review?: Maybe<Scalars['Boolean']>;
  renter_id?: Maybe<Scalars['Int']>;
  renter_insurance_fee_total?: Maybe<Scalars['Int']>;
  renter_object?: Maybe<Scalars['Int']>;
  renter_read?: Maybe<Scalars['Boolean']>;
  renter_summary?: Maybe<RenterSummary>;
  require_dmv_check?: Maybe<Scalars['Boolean']>;
  require_drivers?: Maybe<Scalars['Boolean']>;
  require_insurance?: Maybe<Scalars['Boolean']>;
  require_renter_id_verification?: Maybe<Scalars['Boolean']>;
  require_roadside?: Maybe<Scalars['Boolean']>;
  reserve_amount?: Maybe<Scalars['Int']>;
  reserve_amount_after_credits?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  security_deposit?: Maybe<Scalars['Int']>;
  security_deposit_card_id?: Maybe<Scalars['Int']>;
  security_deposit_due_date?: Maybe<Scalars['String']>;
  security_deposit_due_days?: Maybe<Scalars['Int']>;
  security_deposit_remaining?: Maybe<Scalars['Int']>;
  security_deposit_reversable?: Maybe<Scalars['Int']>;
  security_deposit_status?: Maybe<Scalars['String']>;
  service_fee?: Maybe<Scalars['Int']>;
  services?: Maybe<Array<Service>>;
  session_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Int']>;
  system_generated?: Maybe<Scalars['Boolean']>;
  tax?: Maybe<Scalars['Int']>;
  tax_rates?: Maybe<Array<Maybe<Scalars['String']>>>;
  to?: Maybe<Scalars['String']>;
  to_time?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  total_after_credits?: Maybe<Scalars['Int']>;
  total_paid?: Maybe<Scalars['Int']>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
  traveler_type?: Maybe<Scalars['String']>;
  travelers?: Maybe<Scalars['Int']>;
  trip_credits_disabled?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
  updated_stamp?: Maybe<Scalars['String']>;
  use_day_pricing?: Maybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: Maybe<Scalars['Boolean']>;
  use_tint_check?: Maybe<Scalars['Boolean']>;
  user_role?: Maybe<Scalars['String']>;
  waived_insurance_text?: Maybe<Scalars['String']>;
  waiver_summary?: Maybe<WaiverSummary>;
};

export type BookingBundle = {
  __typename?: 'BookingBundle';
  bundle_features?: Maybe<Array<BundleFeatureTransfer>>;
  dealer_owned_renter?: Maybe<Scalars['Boolean']>;
  deductible?: Maybe<Scalars['Int']>;
  default_selection?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insurance_protection?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  offer_individual_service_types?: Maybe<Array<Scalars['String']>>;
  owner_id?: Maybe<Scalars['Int']>;
  price_per_day?: Maybe<Scalars['Int']>;
  property_damage?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['String']>;
  supported_types?: Maybe<Array<Scalars['String']>>;
  tier?: Maybe<Scalars['Int']>;
  total_price?: Maybe<Scalars['Int']>;
};

export type BookingBundleInput = {
  bundle_features?: InputMaybe<Array<BundleFeatureTransferInput>>;
  dealer_owned_renter?: InputMaybe<Scalars['Boolean']>;
  deductible?: InputMaybe<Scalars['Int']>;
  default_selection?: InputMaybe<Scalars['Boolean']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  insurance_protection?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  offer_individual_service_types?: InputMaybe<Array<Scalars['String']>>;
  owner_id?: InputMaybe<Scalars['Int']>;
  price_per_day?: InputMaybe<Scalars['Int']>;
  property_damage?: InputMaybe<Scalars['String']>;
  subtext?: InputMaybe<Scalars['String']>;
  supported_types?: InputMaybe<Array<Scalars['String']>>;
  tier?: InputMaybe<Scalars['Int']>;
  total_price?: InputMaybe<Scalars['Int']>;
};

export type BookingDeliveryProposal = {
  __typename?: 'BookingDeliveryProposal';
  action?: Maybe<BookingDeliveryProposalAction>;
  booking_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  daily_changes?: Maybe<Array<Maybe<DailyChange>>>;
  details?: Maybe<BookingDeliveryProposalDetails>;
  dry_create?: Maybe<Scalars['Boolean']>;
  future_booking?: Maybe<FutureBooking>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  object_type?: Maybe<Scalars['String']>;
  owner_acknowledged?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  renter_acknowledged?: Maybe<Scalars['String']>;
  renter_dismissed?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  status?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export enum BookingDeliveryProposalAction {
  AddDelivery = 'add_delivery',
  RemoveDelivery = 'remove_delivery'
}

export type BookingDeliveryProposalDetails = {
  __typename?: 'BookingDeliveryProposalDetails';
  delivery_amount?: Maybe<Scalars['Float']>;
  estimated_distance?: Maybe<Scalars['Float']>;
  insurance_price_difference?: Maybe<Scalars['Float']>;
  location?: Maybe<BookingDeliveryProposalDetailsLocation>;
  rental_home?: Maybe<BookingDeliveryProposalDetailsRentalHome>;
  stationary?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Float']>;
};

export type BookingDeliveryProposalDetailsLocation = {
  __typename?: 'BookingDeliveryProposalDetailsLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  place_id?: Maybe<Scalars['String']>;
  short_city?: Maybe<Scalars['String']>;
  short_country?: Maybe<Scalars['String']>;
  short_county?: Maybe<Scalars['String']>;
  short_state?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type BookingDeliveryProposalDetailsRentalHome = {
  __typename?: 'BookingDeliveryProposalDetailsRentalHome';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type BookingInput = {
  abandoned?: InputMaybe<Scalars['Boolean']>;
  addons?: InputMaybe<Array<InputMaybe<BookingItemInput>>>;
  affirm_total?: InputMaybe<Scalars['Int']>;
  auto_assign_group?: InputMaybe<Scalars['Boolean']>;
  bid_id?: InputMaybe<Scalars['Int']>;
  booked?: InputMaybe<Scalars['String']>;
  booking_agent?: InputMaybe<Scalars['String']>;
  booking_token?: InputMaybe<Scalars['String']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  calculated_day_price?: InputMaybe<Scalars['Int']>;
  campground_booking_url?: InputMaybe<Scalars['String']>;
  can_manage_security_deposit?: InputMaybe<Scalars['Boolean']>;
  can_renter_review?: InputMaybe<Scalars['Boolean']>;
  can_renter_review_until?: InputMaybe<Scalars['String']>;
  can_see_contract?: InputMaybe<Scalars['Boolean']>;
  cancel_policy?: InputMaybe<Scalars['String']>;
  canceled?: InputMaybe<Scalars['String']>;
  checkout_questions?: InputMaybe<Array<InputMaybe<CheckoutQuestionInput>>>;
  checkout_steps?: InputMaybe<CheckoutStepsInput>;
  checkout_steps_id?: InputMaybe<Scalars['Int']>;
  conversation_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_stamp?: InputMaybe<Scalars['String']>;
  custom_insurance_text?: InputMaybe<Scalars['String']>;
  default_insurance_coverage?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<DeliveryInput>;
  delivery_item?: InputMaybe<BookingItemInput>;
  delivery_usage_item?: InputMaybe<UsageBasedItemInput>;
  delivery_usage_item_id?: InputMaybe<Scalars['String']>;
  deposit_percentage?: InputMaybe<Scalars['Int']>;
  destination?: InputMaybe<Scalars['String']>;
  destination_lat?: InputMaybe<Scalars['Int']>;
  destination_lng?: InputMaybe<Scalars['Int']>;
  details?: InputMaybe<DetailsInput>;
  device_id?: InputMaybe<Scalars['String']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_code_amount?: InputMaybe<Scalars['Int']>;
  discount_code_applied_to?: InputMaybe<Scalars['String']>;
  discount_code_message?: InputMaybe<Scalars['String']>;
  display_insurance?: InputMaybe<Scalars['String']>;
  display_source?: InputMaybe<Scalars['String']>;
  display_status?: InputMaybe<Scalars['String']>;
  dropoff?: InputMaybe<DropoffInput>;
  duration?: InputMaybe<Scalars['Int']>;
  express_checkout_id?: InputMaybe<Scalars['Int']>;
  external?: InputMaybe<Scalars['Boolean']>;
  fees_locked?: InputMaybe<Scalars['Boolean']>;
  final_payment_due_days?: InputMaybe<Scalars['Int']>;
  followup_archived?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['String']>;
  from_time?: InputMaybe<Scalars['Int']>;
  fx_fee_paid?: InputMaybe<Scalars['Int']>;
  generator?: InputMaybe<GeneratorInput>;
  generator_usage_item?: InputMaybe<UsageBasedItemInput>;
  generator_usage_item_id?: InputMaybe<Scalars['Int']>;
  has_setup_intent_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  include_coachnet?: InputMaybe<Scalars['Boolean']>;
  initial_duration?: InputMaybe<Scalars['Int']>;
  instamatch?: InputMaybe<Scalars['String']>;
  instant_book?: InputMaybe<Scalars['Boolean']>;
  insurance?: InputMaybe<Scalars['String']>;
  insurance_approved?: InputMaybe<Scalars['Boolean']>;
  insurance_bundle?: InputMaybe<BookingBundleInput>;
  insurance_claim_filed?: InputMaybe<Scalars['Boolean']>;
  insurance_coverage?: InputMaybe<Scalars['String']>;
  insurance_plan_id?: InputMaybe<InsurancePlanIdInput>;
  insurance_renter_adjustable?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<BookingItemInput>>;
  locale?: InputMaybe<LocaleInput>;
  location_id?: InputMaybe<Scalars['Int']>;
  mileage?: InputMaybe<MileageInput>;
  mileage_usage_item?: InputMaybe<UsageBasedItemInput>;
  mileage_usage_item_id?: InputMaybe<Scalars['Int']>;
  minimum_deposit?: InputMaybe<Scalars['Int']>;
  missing_data?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  non_refundable_total?: InputMaybe<Scalars['Int']>;
  offer_affirm?: InputMaybe<Scalars['Boolean']>;
  offer_insurance?: InputMaybe<Scalars['Boolean']>;
  offer_paypal_pay_later?: InputMaybe<Scalars['Boolean']>;
  offer_roadside?: InputMaybe<Scalars['Boolean']>;
  original_day_price?: InputMaybe<Scalars['Int']>;
  original_service_fee?: InputMaybe<Scalars['Int']>;
  outdoorsy_fee?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<UserInput>;
  owner_approved?: InputMaybe<Scalars['Boolean']>;
  owner_approved_at?: InputMaybe<Scalars['String']>;
  owner_did_review?: InputMaybe<Scalars['Boolean']>;
  owner_fees?: InputMaybe<Array<BookingItemInput>>;
  owner_id?: InputMaybe<Scalars['Int']>;
  owner_integrations_fee?: InputMaybe<Scalars['Int']>;
  owner_read?: InputMaybe<Scalars['Boolean']>;
  owner_summary?: InputMaybe<OwnerSummaryInput>;
  partner_app?: InputMaybe<PartnerAppInput>;
  pending_transactions?: InputMaybe<Array<InputMaybe<PendingTransactionsInput>>>;
  pickup?: InputMaybe<PickupInput>;
  premium_total?: InputMaybe<Scalars['Int']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  processor_name?: InputMaybe<Scalars['String']>;
  proposals?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provide_insurance_binder?: InputMaybe<Scalars['Boolean']>;
  referred_owner_paid?: InputMaybe<Scalars['Boolean']>;
  referred_renter_paid?: InputMaybe<Scalars['Boolean']>;
  remainder_amount?: InputMaybe<Scalars['Int']>;
  remainder_due_date?: InputMaybe<Scalars['String']>;
  rental?: InputMaybe<RentalInput>;
  rental_amount_item?: InputMaybe<BookingItemInput>;
  rental_charge_card_id?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  rental_object?: InputMaybe<Scalars['Int']>;
  rental_search?: InputMaybe<RentalSearchInput>;
  rental_summary?: InputMaybe<RentalSummaryInput>;
  renter?: InputMaybe<UserInput>;
  renter_approved?: InputMaybe<Scalars['Boolean']>;
  renter_approved_at?: InputMaybe<Scalars['String']>;
  renter_archived?: InputMaybe<Scalars['Boolean']>;
  renter_can_waive_insurance?: InputMaybe<Scalars['Boolean']>;
  renter_credits_applied?: InputMaybe<Scalars['Int']>;
  renter_did_review?: InputMaybe<Scalars['Boolean']>;
  renter_id?: InputMaybe<Scalars['Int']>;
  renter_insurance_fee_total?: InputMaybe<Scalars['Int']>;
  renter_object?: InputMaybe<Scalars['Int']>;
  renter_read?: InputMaybe<Scalars['Boolean']>;
  renter_summary?: InputMaybe<RenterSummaryInput>;
  require_dmv_check?: InputMaybe<Scalars['Boolean']>;
  require_drivers?: InputMaybe<Scalars['Boolean']>;
  require_insurance?: InputMaybe<Scalars['Boolean']>;
  require_renter_id_verification?: InputMaybe<Scalars['Boolean']>;
  require_roadside?: InputMaybe<Scalars['Boolean']>;
  reserve_amount?: InputMaybe<Scalars['Int']>;
  security_deposit?: InputMaybe<Scalars['Int']>;
  security_deposit_card_id?: InputMaybe<Scalars['Int']>;
  security_deposit_due_date?: InputMaybe<Scalars['String']>;
  security_deposit_due_days?: InputMaybe<Scalars['Int']>;
  security_deposit_remaining?: InputMaybe<Scalars['Int']>;
  security_deposit_reversable?: InputMaybe<Scalars['Int']>;
  security_deposit_status?: InputMaybe<Scalars['String']>;
  service_fee?: InputMaybe<Scalars['Int']>;
  services?: InputMaybe<Array<ServiceInput>>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  system_generated?: InputMaybe<Scalars['Boolean']>;
  tax?: InputMaybe<Scalars['Int']>;
  tax_rates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to?: InputMaybe<Scalars['String']>;
  to_time?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
  total_paid?: InputMaybe<Scalars['Int']>;
  transactions?: InputMaybe<Array<InputMaybe<TransactionsInput>>>;
  traveler_type?: InputMaybe<Scalars['String']>;
  travelers?: InputMaybe<Scalars['Int']>;
  trip_credits_disabled?: InputMaybe<Scalars['Boolean']>;
  updated?: InputMaybe<Scalars['String']>;
  updated_stamp?: InputMaybe<Scalars['String']>;
  use_day_pricing?: InputMaybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: InputMaybe<Scalars['Boolean']>;
  use_tint_check?: InputMaybe<Scalars['Boolean']>;
  user_role?: InputMaybe<Scalars['String']>;
  waived_insurance_text?: InputMaybe<Scalars['String']>;
  waiver_summary?: InputMaybe<WaiverSummaryInput>;
};

export type BookingItem = {
  __typename?: 'BookingItem';
  booking_id?: Maybe<Scalars['Int']>;
  coachnet_item?: Maybe<Scalars['Boolean']>;
  consigned_pay_amount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  daily?: Maybe<Scalars['Boolean']>;
  deferred?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  discount_amount?: Maybe<Scalars['Int']>;
  generator?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  maximum_price?: Maybe<Scalars['Int']>;
  mileage?: Maybe<Scalars['Boolean']>;
  minimum_price?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  original_consigned_pay_pct?: Maybe<Scalars['Float']>;
  original_tax_rate_id?: Maybe<Scalars['Int']>;
  other_claim?: Maybe<Scalars['Boolean']>;
  outdoorsy_item?: Maybe<Scalars['Boolean']>;
  parent_item_id?: Maybe<Scalars['Int']>;
  parent_item_type?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
  percent_type?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  premium_amount?: Maybe<Scalars['Int']>;
  premium_total?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  rental_amount?: Maybe<Scalars['Boolean']>;
  required?: Maybe<Scalars['Boolean']>;
  response_status?: Maybe<ResponseStatus>;
  tax_amount?: Maybe<Scalars['Int']>;
  tax_description?: Maybe<Scalars['String']>;
  tax_name?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['Float']>;
  tax_rates?: Maybe<Array<Maybe<BookingTaxRate>>>;
  total?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type BookingItemInput = {
  coachnet_item?: InputMaybe<Scalars['Boolean']>;
  consigned_pay_amount?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  deferred?: InputMaybe<Scalars['Boolean']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  discount_amount?: InputMaybe<Scalars['Int']>;
  generator?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  maximum_price?: InputMaybe<Scalars['Int']>;
  mileage?: InputMaybe<Scalars['Boolean']>;
  minimum_price?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  original_consigned_pay_pct?: InputMaybe<Scalars['Float']>;
  original_tax_rate_id?: InputMaybe<Scalars['Int']>;
  other_claim?: InputMaybe<Scalars['Boolean']>;
  outdoorsy_item?: InputMaybe<Scalars['Boolean']>;
  parent_item_id?: InputMaybe<Scalars['Int']>;
  parent_item_type?: InputMaybe<Scalars['String']>;
  percent?: InputMaybe<Scalars['Float']>;
  percent_type?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  premium_amount?: InputMaybe<Scalars['Int']>;
  premium_total?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  rental_amount?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  tax_amount?: InputMaybe<Scalars['Int']>;
  tax_description?: InputMaybe<Scalars['String']>;
  tax_name?: InputMaybe<Scalars['String']>;
  tax_rate?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Int']>;
  total_with_taxes?: InputMaybe<Scalars['Int']>;
};

export type BookingItemsResponse = {
  __typename?: 'BookingItemsResponse';
  booking_items?: Maybe<Array<BookingItem>>;
  response_status?: Maybe<ResponseStatus>;
};

export type BookingOptions = {
  __typename?: 'BookingOptions';
  allow_insurance_for_external_lead?: Maybe<Scalars['Boolean']>;
  bid_quality_preference?: Maybe<Scalars['Float']>;
  coachnet_premium?: Maybe<Scalars['Int']>;
  custom_insurance_text?: Maybe<Scalars['String']>;
  default_insurance_bundle_tier?: Maybe<Scalars['Int']>;
  deposit_percentage?: Maybe<Scalars['Int']>;
  disable_coachnet?: Maybe<Scalars['Boolean']>;
  disable_instamatch?: Maybe<Scalars['Boolean']>;
  final_payment_due_days?: Maybe<Scalars['Int']>;
  from_time?: Maybe<Scalars['Int']>;
  instant_book?: Maybe<Scalars['Boolean']>;
  instant_book_leeway?: Maybe<Scalars['Int']>;
  insurance_coverage?: Maybe<Scalars['String']>;
  insurance_renter_adjustable?: Maybe<Scalars['Boolean']>;
  minimum_days?: Maybe<Scalars['Int']>;
  minimum_deposit?: Maybe<Scalars['Int']>;
  require_driver_checks?: Maybe<Scalars['Boolean']>;
  require_insurance?: Maybe<Scalars['Boolean']>;
  security_deposit_due_days?: Maybe<Scalars['Int']>;
  tax_rate_id?: Maybe<Scalars['Int']>;
  tax_rate_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  to_time?: Maybe<Scalars['Int']>;
  turnaround_days_after?: Maybe<Scalars['Int']>;
  use_day_pricing?: Maybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: Maybe<Scalars['Boolean']>;
  variable_fees_upfront?: Maybe<Scalars['Boolean']>;
};

export type BookingOptionsInput = {
  allow_insurance_for_external_lead?: InputMaybe<Scalars['Boolean']>;
  bid_quality_preference?: InputMaybe<Scalars['Float']>;
  coachnet_premium?: InputMaybe<Scalars['Int']>;
  custom_insurance_text?: InputMaybe<Scalars['String']>;
  default_insurance_bundle_tier?: InputMaybe<Scalars['Int']>;
  deposit_percentage?: InputMaybe<Scalars['Int']>;
  disable_coachnet?: InputMaybe<Scalars['Boolean']>;
  disable_instamatch?: InputMaybe<Scalars['Boolean']>;
  final_payment_due_days?: InputMaybe<Scalars['Int']>;
  from_time?: InputMaybe<Scalars['Int']>;
  instant_book?: InputMaybe<Scalars['Boolean']>;
  instant_book_leeway?: InputMaybe<Scalars['Int']>;
  insurance_coverage?: InputMaybe<Scalars['String']>;
  insurance_renter_adjustable?: InputMaybe<Scalars['Boolean']>;
  minimum_days?: InputMaybe<Scalars['Int']>;
  minimum_deposit?: InputMaybe<Scalars['Int']>;
  require_driver_checks?: InputMaybe<Scalars['Boolean']>;
  require_insurance?: InputMaybe<Scalars['Boolean']>;
  security_deposit_due_days?: InputMaybe<Scalars['Int']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to_time?: InputMaybe<Scalars['Int']>;
  turnaround_days_after?: InputMaybe<Scalars['Int']>;
  use_day_pricing?: InputMaybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: InputMaybe<Scalars['Boolean']>;
  variable_fees_upfront?: InputMaybe<Scalars['Boolean']>;
};

export type BookingRestrictions = {
  __typename?: 'BookingRestrictions';
  instant_book_cancellation_threshold?: Maybe<Scalars['Int']>;
  instant_book_cancellations_six_months?: Maybe<Scalars['Int']>;
  is_instant_book_banned?: Maybe<Scalars['Boolean']>;
  standard_booking_cancellation_threshold?: Maybe<Scalars['Int']>;
  standard_booking_cancellations_six_months?: Maybe<Scalars['Int']>;
};

export type BookingRestrictionsInput = {
  instant_book_cancellation_threshold?: InputMaybe<Scalars['Int']>;
  instant_book_cancellations_six_months?: InputMaybe<Scalars['Int']>;
  is_instant_book_banned?: InputMaybe<Scalars['Boolean']>;
  standard_booking_cancellation_threshold?: InputMaybe<Scalars['Int']>;
  standard_booking_cancellations_six_months?: InputMaybe<Scalars['Int']>;
};

export type BookingSummary = {
  __typename?: 'BookingSummary';
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['String']>;
};

export type BookingTaxRate = {
  __typename?: 'BookingTaxRate';
  booking_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  object_type?: Maybe<Scalars['String']>;
  payable_to?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['Int']>;
  tax_description?: Maybe<Scalars['String']>;
  tax_name?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['Float']>;
  tax_rate_id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type BookingTaxRateInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  object_type?: InputMaybe<Scalars['String']>;
  payable_to?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tax_amount?: InputMaybe<Scalars['Int']>;
  tax_description?: InputMaybe<Scalars['String']>;
  tax_name?: InputMaybe<Scalars['String']>;
  tax_rate?: InputMaybe<Scalars['Float']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

export type BookingsResult = {
  __typename?: 'BookingsResult';
  bookings?: Maybe<Array<Maybe<Booking>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Bundle = {
  __typename?: 'Bundle';
  active?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  dealer_owned_renter?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<BundleFeature>>>;
  id?: Maybe<Scalars['String']>;
  internal_description?: Maybe<Scalars['String']>;
  line_item_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  percent_uptake_drivable?: Maybe<Scalars['Float']>;
  percent_uptake_towable?: Maybe<Scalars['Float']>;
  response_status?: Maybe<ResponseStatus>;
  rules?: Maybe<Array<Maybe<BundleRule>>>;
  tier?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type BundleFeature = {
  __typename?: 'BundleFeature';
  bundle_id?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  response_status?: Maybe<ResponseStatus>;
  service_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type BundleFeatureInput = {
  category?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  service_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type BundleFeatureItem = {
  __typename?: 'BundleFeatureItem';
  details?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  service_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type BundleFeatureItemInput = {
  details?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  service_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type BundleFeatureTransfer = {
  __typename?: 'BundleFeatureTransfer';
  category?: Maybe<Scalars['String']>;
  items?: Maybe<Array<BundleFeatureItem>>;
};

export type BundleFeatureTransferInput = {
  category?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<BundleFeatureItemInput>>;
};

export type BundleInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  dealer_owned_renter?: InputMaybe<Scalars['Boolean']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<BundleFeatureInput>>>;
  internal_description?: InputMaybe<Scalars['String']>;
  line_item_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  percent_uptake_drivable?: InputMaybe<Scalars['Float']>;
  percent_uptake_towable?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Array<InputMaybe<BundleRuleInput>>>;
  tier?: InputMaybe<Scalars['Int']>;
};

export type BundleRule = {
  __typename?: 'BundleRule';
  bundle_id?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  rule?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type BundleRuleInput = {
  rule?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<Scalars['String']>;
};

export type BundlesResponse = {
  __typename?: 'BundlesResponse';
  bundles?: Maybe<Array<Maybe<Bundle>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Business = {
  __typename?: 'Business';
  cancel_policy: Scalars['String'];
  cancel_policy_combo_bookings: Scalars['String'];
  cancel_text: Scalars['String'];
  consigned_keep_pct_addon_fee?: Maybe<Scalars['Float']>;
  consigned_keep_pct_cc_fee?: Maybe<Scalars['Float']>;
  consigned_keep_pct_insurance_fee?: Maybe<Scalars['Float']>;
  consigned_pay_pct?: Maybe<Scalars['Float']>;
  consigned_pay_pct_generator?: Maybe<Scalars['Float']>;
  consigned_pay_pct_mileage?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  fax: Scalars['String'];
  google_analytics_id?: Maybe<Scalars['String']>;
  google_tag_manager_id?: Maybe<Scalars['String']>;
  hide_rentals: Scalars['Boolean'];
  house_rules: Scalars['String'];
  localized_languages?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  outdoorsy_display_name: Scalars['String'];
  phone: Scalars['String'];
  segment_token: Scalars['String'];
  terms_of_service: Scalars['String'];
  website: Scalars['String'];
};

export type BusinessInput = {
  cancel_policy: Scalars['String'];
  cancel_policy_combo_bookings: Scalars['String'];
  cancel_text: Scalars['String'];
  consigned_keep_pct_addon_fee?: InputMaybe<Scalars['Float']>;
  consigned_keep_pct_cc_fee?: InputMaybe<Scalars['Float']>;
  consigned_keep_pct_insurance_fee?: InputMaybe<Scalars['Float']>;
  consigned_pay_pct?: InputMaybe<Scalars['Float']>;
  consigned_pay_pct_generator?: InputMaybe<Scalars['Float']>;
  consigned_pay_pct_mileage?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  fax: Scalars['String'];
  google_analytics_id?: InputMaybe<Scalars['String']>;
  google_tag_manager_id?: InputMaybe<Scalars['String']>;
  hide_rentals: Scalars['Boolean'];
  house_rules: Scalars['String'];
  localized_languages?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  outdoorsy_display_name: Scalars['String'];
  phone: Scalars['String'];
  segment_token: Scalars['String'];
  terms_of_service: Scalars['String'];
  website: Scalars['String'];
};

export type CancelContent = {
  __typename?: 'CancelContent';
  list_items?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export enum CancelPolicy {
  Custom = 'CUSTOM',
  Easygoing = 'EASYGOING',
  Flexible = 'FLEXIBLE',
  Fullyflexible = 'FULLYFLEXIBLE',
  Moderate = 'MODERATE',
  Odnhc = 'ODNHC',
  Strict = 'STRICT'
}

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  payment_policy?: Maybe<PaymentPolicy>;
  policy?: Maybe<PolicyV1>;
  policy_v2?: Maybe<CancellationPolicyV2>;
  response_status?: Maybe<ResponseStatus>;
};

export type CancellationPolicyInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  free_period?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  owner_edit_listing?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
  policy?: InputMaybe<Scalars['String']>;
  refund?: InputMaybe<Scalars['Boolean']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  v?: InputMaybe<Scalars['Int']>;
};

export type CancellationPolicyV2 = {
  __typename?: 'CancellationPolicyV2';
  markdown?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Capabilities = {
  __typename?: 'Capabilities';
  card_payments?: Maybe<Scalars['String']>;
  transfers?: Maybe<Scalars['String']>;
};

export type CapabilitiesInput = {
  card_payments?: InputMaybe<Scalars['String']>;
  transfers?: InputMaybe<Scalars['String']>;
};

export type CardsResponse = {
  __typename?: 'CardsResponse';
  cards?: Maybe<Array<Maybe<UserCard>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type ChangeBookingStatusInput = {
  as_credits?: InputMaybe<Scalars['Boolean']>;
  cancel_reason?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  decline_reason?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  no_send_email?: InputMaybe<Scalars['Boolean']>;
  paypal_charge_info?: InputMaybe<PaypalChargeInfo>;
  refund_amount?: InputMaybe<Scalars['Int']>;
  refund_type?: InputMaybe<Scalars['String']>;
  rental_charge?: InputMaybe<Charge>;
  save_card_token?: InputMaybe<Scalars['String']>;
  security_deposit_charge?: InputMaybe<Charge>;
  status: Scalars['String'];
  to?: InputMaybe<Scalars['String']>;
  trip_credits_disabled?: InputMaybe<Scalars['Boolean']>;
};

export type Charge = {
  card_id?: InputMaybe<Scalars['Int']>;
  card_token?: InputMaybe<Scalars['String']>;
  full?: InputMaybe<Scalars['Boolean']>;
  method: Scalars['String'];
  payment_intent_id?: InputMaybe<Scalars['String']>;
};

export type ChargesResponse = {
  __typename?: 'ChargesResponse';
  charges?: Maybe<Array<Maybe<SubCharge>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type CheckoutQuestion = {
  __typename?: 'CheckoutQuestion';
  choices?: Maybe<Array<Choice>>;
  help?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  label?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  style?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type CheckoutQuestionInput = {
  choices?: InputMaybe<Array<ChoiceInput>>;
  help?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  label?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  style?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type CheckoutStep = {
  __typename?: 'CheckoutStep';
  name: Scalars['String'];
  order: Scalars['Int'];
  status: Scalars['String'];
};

export type CheckoutStepInput = {
  name: Scalars['String'];
  order: Scalars['Int'];
  status: Scalars['String'];
};

export type CheckoutSteps = {
  __typename?: 'CheckoutSteps';
  id?: Maybe<Scalars['Int']>;
  imminent_departure?: Maybe<Scalars['Boolean']>;
  readonly_insurance?: Maybe<Scalars['Boolean']>;
  response_status?: Maybe<ResponseStatus>;
  route?: Maybe<Scalars['String']>;
  steps?: Maybe<Array<CheckoutStep>>;
};

export type CheckoutStepsInput = {
  id?: InputMaybe<Scalars['Int']>;
  imminent_departure?: InputMaybe<Scalars['Boolean']>;
  readonly_insurance?: InputMaybe<Scalars['Boolean']>;
  route?: InputMaybe<Scalars['String']>;
  steps?: InputMaybe<Array<CheckoutStepInput>>;
};

export type Choice = {
  __typename?: 'Choice';
  value: Scalars['String'];
};

export type ChoiceInput = {
  value: Scalars['String'];
};

export type Claim = {
  __typename?: 'Claim';
  booking_id?: Maybe<Scalars['Int']>;
  claim_data?: Maybe<Scalars['JSON']>;
  claim_history_id?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSON']>;
  estimate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  processor?: Maybe<Scalars['String']>;
  processor_id?: Maybe<Scalars['String']>;
  processor_url?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  status?: Maybe<Scalars['String']>;
  status_details?: Maybe<Scalars['JSON']>;
  submitter_id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type ClaimAddress = {
  __typename?: 'ClaimAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type ClaimIncidentDetails = {
  __typename?: 'ClaimIncidentDetails';
  autoClaimAnimalIncidentDetail?: Maybe<AutoClaimAnimalIncidentDetail>;
  autoClaimCollisionOtherIncidentDetail?: Maybe<AutoClaimCollisionIncidentDetails>;
  autoClaimCollisionWithBicycleIncidentDetail?: Maybe<AutoClaimCollisionIncidentDetails>;
  autoClaimCollisionWithBusOrTrainIncidentDetail?: Maybe<AutoClaimCollisionIncidentDetails>;
  autoClaimCollisionWithFixedObjectIncidentDetail?: Maybe<AutoClaimCollisionIncidentDetails>;
  autoClaimCollisionWithMotorVehicleIncidentDetail?: Maybe<AutoClaimCollisionIncidentDetails>;
  autoClaimCollisionWithPedestrianIncidentDetail?: Maybe<AutoClaimCollisionIncidentDetails>;
  autoClaimFireIncidentDetail?: Maybe<AutoClaimFireIncidentDetail>;
  autoClaimGlassIncidentDetail?: Maybe<AutoClaimGlassIncidentDetail>;
  autoClaimRiotOrCivilUnrestIncidentDetail?: Maybe<AutoClaimRiotOrCivilUnrestIncidentDetail>;
  autoClaimTheftOfPartsIncidentDetail?: Maybe<AutoClaimTheftOfPartsIncidentDetail>;
  autoClaimTheftOfVehicleIncidentDetail?: Maybe<AutoClaimTheftOfVehicleIncidentDetail>;
  autoClaimTowOrBreakdownIncidentDetail?: Maybe<AutoClaimTowOrBreakdownIncidentDetail>;
  autoClaimVandalismIncidentDetail?: Maybe<AutoClaimVandalismIncidentDetail>;
  incidentLocationAddress?: Maybe<ClaimAddress>;
  incidentLocationDescription?: Maybe<Scalars['String']>;
  incidentLocationType?: Maybe<Scalars['String']>;
};

export type ClaimParty = {
  __typename?: 'ClaimParty';
  address?: Maybe<ClaimAddress>;
  canContact?: Maybe<Scalars['Boolean']>;
  claim_party_type?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  contactMethods?: Maybe<Array<Maybe<ContactMethod>>>;
  dateOfBirth?: Maybe<Scalars['String']>;
  dpaCheck?: Maybe<Scalars['Boolean']>;
  externalReferenceNumber?: Maybe<Scalars['String']>;
  fatalInjury?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasOtherInsurance?: Maybe<Scalars['Boolean']>;
  hasPersonalIdentificationNumber?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  injured?: Maybe<Scalars['Boolean']>;
  injuryDescription?: Maybe<Scalars['String']>;
  injuryType?: Maybe<Scalars['String']>;
  insured?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  otherInsuranceCompany?: Maybe<Scalars['String']>;
  otherInsurancePolicyNumber?: Maybe<Scalars['String']>;
  party_type?: Maybe<Scalars['String']>;
  personalIdentificationNumber?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  relationToInsured?: Maybe<Scalars['String']>;
  seatbeltWorn?: Maybe<Scalars['Boolean']>;
  seriousInjury?: Maybe<Scalars['Boolean']>;
  statement?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  vehicleDriverDetail?: Maybe<DriverDetail>;
  vehiclePassengerDetail?: Maybe<PassengerDetail>;
};

export type ClaimPartyRef = {
  __typename?: 'ClaimPartyRef';
  claimPartyId?: Maybe<Scalars['String']>;
};

export type ClaimTag = {
  __typename?: 'ClaimTag';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ClaimVehicle = {
  __typename?: 'ClaimVehicle';
  damageDescription?: Maybe<Scalars['String']>;
  drivable?: Maybe<Scalars['Boolean']>;
  driver?: Maybe<ClaimPartyRef>;
  engineSize?: Maybe<Scalars['String']>;
  exteriorDamage?: Maybe<Scalars['Boolean']>;
  financeProvider?: Maybe<Scalars['String']>;
  hailDamage?: Maybe<Scalars['Boolean']>;
  hasDamage?: Maybe<Scalars['Boolean']>;
  hasDriver?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  interiorDamage?: Maybe<Scalars['Boolean']>;
  isFinanced?: Maybe<Scalars['Boolean']>;
  locationType?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mechanicalDamage?: Maybe<Scalars['Boolean']>;
  mileage?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['String']>;
  owner?: Maybe<ClaimPartyRef>;
  passengers?: Maybe<Array<Maybe<ClaimPartyRef>>>;
  registrationNumber?: Maybe<Scalars['String']>;
  vehicleDamages?: Maybe<Array<Maybe<Damage>>>;
  vehicleLocationAddress?: Maybe<ClaimAddress>;
  vinNumber?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type ClientTokenInput = {
  customerId?: InputMaybe<Scalars['ID']>;
  merchantAccountId?: InputMaybe<Scalars['ID']>;
};

export type CoachnetSubscription = {
  __typename?: 'CoachnetSubscription';
  cancel_reason?: Maybe<Scalars['String']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  coachnet_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiration_date?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  last_payment_date?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Float']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  next_payment_date?: Maybe<Scalars['String']>;
  order_details?: Maybe<Scalars['JSON']>;
  phone?: Maybe<Scalars['String']>;
  rental?: Maybe<Rental>;
  rental_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  start_date?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_etc?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle_type?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type CoachnetSubscriptionInput = {
  rental_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CoachnetSubscriptionsResponse = {
  __typename?: 'CoachnetSubscriptionsResponse';
  response_status?: Maybe<ResponseStatus>;
  subscriptions?: Maybe<Array<Maybe<CoachnetSubscription>>>;
};

export type CommLog = {
  __typename?: 'CommLog';
  booking?: Maybe<Booking>;
  booking_id?: Maybe<Scalars['Int']>;
  clicked?: Maybe<Scalars['String']>;
  conversation?: Maybe<Conversation>;
  conversation_id?: Maybe<Scalars['Int']>;
  delivered?: Maybe<Scalars['String']>;
  email_data?: Maybe<Scalars['JSON']>;
  error?: Maybe<Scalars['String']>;
  error_occurred?: Maybe<Scalars['String']>;
  latest_status?: Maybe<Scalars['String']>;
  latest_status_time?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  message_id?: Maybe<Message>;
  metadata?: Maybe<Scalars['JSON']>;
  opened?: Maybe<Scalars['String']>;
  receiver?: Maybe<User>;
  receiver_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  sender?: Maybe<User>;
  sender_id?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['String']>;
  service_id?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['String']>;
  version_name?: Maybe<Scalars['String']>;
};

export type CommLogsResponse = {
  __typename?: 'CommLogsResponse';
  logs?: Maybe<Array<Maybe<CommLog>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type ConsignedPayAmount = {
  consigned_pay_amount?: InputMaybe<Scalars['Int']>;
};

export type ConsignedPayout = {
  __typename?: 'ConsignedPayout';
  bookings?: Maybe<Array<Maybe<Scalars['Int']>>>;
  bookings_objects?: Maybe<Array<Maybe<Booking>>>;
  consigned_owner?: Maybe<User>;
  consigned_owner_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<Scalars['Int']>>>;
  items_objects?: Maybe<Array<Maybe<ConsignedPayoutItem>>>;
  message?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  paid_date?: Maybe<Scalars['String']>;
  rental?: Maybe<Rental>;
  rental_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  status?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type ConsignedPayoutInput = {
  bookings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  consigned_owner_id?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  message?: InputMaybe<Scalars['String']>;
  paid_date?: InputMaybe<Scalars['String']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type ConsignedPayoutItem = {
  __typename?: 'ConsignedPayoutItem';
  consigned_payout?: Maybe<ConsignedPayout>;
  consigned_payout_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  total?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type ConsignedPayoutItemInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type ConsignedPayoutItemsResponse = {
  __typename?: 'ConsignedPayoutItemsResponse';
  consignedPayoutItems?: Maybe<Array<Maybe<ConsignedPayoutItem>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type ConsignedPayoutsResponse = {
  __typename?: 'ConsignedPayoutsResponse';
  consignedPayouts?: Maybe<Array<Maybe<ConsignedPayout>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type ContactInfoInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ContactMethod = {
  __typename?: 'ContactMethod';
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  preferredMethod?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  all_statuses?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  created?: Maybe<Scalars['String']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last_location_id?: Maybe<Scalars['Int']>;
  messages?: Maybe<Array<Maybe<Message>>>;
  num_messages?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['Int']>;
  owner_object?: Maybe<Scalars['Int']>;
  owner_sms_proxy_id?: Maybe<Scalars['Int']>;
  owner_summary?: Maybe<OwnerSummary>;
  renter_summary?: Maybe<RenterSummary>;
  response_status?: Maybe<ResponseStatus>;
};

export type ConversationInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ConversationsResponse = {
  __typename?: 'ConversationsResponse';
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type ConvertCurrencyResponse = {
  __typename?: 'ConvertCurrencyResponse';
  amount?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
};

export type CopyDefaultRulesInput = {
  owner_id?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
};

export type CountriesResponse = {
  __typename?: 'CountriesResponse';
  countries?: Maybe<Array<Country>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  name: Scalars['String'];
  supports: Array<Maybe<Scalars['String']>>;
};

export type CreateBookingDeliveryProposalDetailsInput = {
  location: LatLngInput;
  stationary: Scalars['Boolean'];
};

export type CreateBookingDeliveryProposalInput = {
  booking_id: Scalars['Int'];
  details: CreateBookingDeliveryProposalDetailsInput;
  dry_create?: InputMaybe<Scalars['Boolean']>;
  object_id: Scalars['Int'];
};

export type CreateBookingDetails = {
  hasPets?: InputMaybe<Scalars['Boolean']>;
  isFestivalTravel?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};

export type CreateBookingInput = {
  details?: InputMaybe<CreateBookingDetails>;
  discount_code?: InputMaybe<Scalars['String']>;
  free_cancellation_period?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  quote_id: Scalars['String'];
  rental_id: Scalars['Int'];
  renter?: InputMaybe<CreateBookingRenterInfo>;
  status: Scalars['String'];
  to: Scalars['String'];
};

export type CreateBookingRenterInfo = {
  birthdate?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  disable_sms?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  signup_source?: InputMaybe<Scalars['String']>;
};

export type CreateClientTokenPayload = {
  __typename?: 'CreateClientTokenPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  clientToken?: Maybe<Scalars['String']>;
};

export type CreateFileInput = {
  actor_id?: InputMaybe<Scalars['Int']>;
  auto_include?: InputMaybe<Scalars['Boolean']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  exif_created?: InputMaybe<Scalars['String']>;
  exif_data?: InputMaybe<Scalars['JSON']>;
  format?: InputMaybe<Scalars['String']>;
  guid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  include_esign?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  out_of_date?: InputMaybe<Scalars['Boolean']>;
  public_id?: InputMaybe<Scalars['String']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  shared?: InputMaybe<Scalars['Boolean']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  signers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  signing_canceled?: InputMaybe<Scalars['Boolean']>;
  signing_complete?: InputMaybe<Scalars['Boolean']>;
  signing_service_id?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type CreateKeyRequest = {
  name?: InputMaybe<Scalars['String']>;
};

export type CreateMessageResponse = {
  __typename?: 'CreateMessageResponse';
  actor_id?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  clicked?: Maybe<Scalars['String']>;
  conversation_id: Scalars['Int'];
  files?: Maybe<Array<Maybe<Scalars['Int']>>>;
  flagged?: Maybe<Scalars['Boolean']>;
  flagged_text?: Maybe<Scalars['String']>;
  from_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  latest_status?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  proxy_interaction_id?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  receiver_id?: Maybe<Scalars['Int']>;
  ref_booking_id?: Maybe<Scalars['Int']>;
  ref_rental_id?: Maybe<Scalars['Int']>;
  sender_id?: Maybe<Scalars['Int']>;
  sentiment?: Maybe<Scalars['String']>;
  sentiment_confidence?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export type CreateRentalReviewInput = {
  apply_credit?: InputMaybe<Scalars['Boolean']>;
  booking_id: Scalars['Int'];
  cleanliness_score?: InputMaybe<Scalars['Float']>;
  communication_score?: InputMaybe<Scalars['Float']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  listing_score?: InputMaybe<Scalars['Float']>;
  mechanical_score?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<InputMaybe<UpdateReviewTagInput>>>;
  text?: InputMaybe<Scalars['String']>;
  user_recommend?: InputMaybe<Scalars['Boolean']>;
  value_score?: InputMaybe<Scalars['Float']>;
};

export type CreditStats = {
  __typename?: 'CreditStats';
  adjustments_total?: Maybe<Scalars['Int']>;
  available?: Maybe<Scalars['Int']>;
  credited_total?: Maybe<Scalars['Int']>;
  debited_total?: Maybe<Scalars['Int']>;
  expired_total?: Maybe<Scalars['Int']>;
  gift_cards_total?: Maybe<Scalars['Int']>;
  other_total?: Maybe<Scalars['Int']>;
  referrals_total?: Maybe<Scalars['Int']>;
  refunds_total?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  spent_on_services_total?: Maybe<Scalars['Int']>;
};

export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ggp = 'GGP',
  Ghc = 'GHC',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Imp = 'IMP',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jep = 'JEP',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rur = 'RUR',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Skk = 'SKK',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Trl = 'TRL',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwd = 'ZWD'
}

export type CurrencyAmount = {
  currency: Scalars['String'];
  value: Scalars['String'];
};

export type CurrentDatum = {
  __typename?: 'CurrentDatum';
  phone?: Maybe<Scalars['String']>;
};

export type CustomEmail = {
  __typename?: 'CustomEmail';
  body?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Scalars['String']>;
  footer?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  localized_languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  subject?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type CustomEmailInput = {
  body?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  event?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Int']>;
  localized_languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

export type CustomEmailsResponse = {
  __typename?: 'CustomEmailsResponse';
  customEmails?: Maybe<Array<Maybe<CustomEmail>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type CustomTestEmail = {
  __typename?: 'CustomTestEmail';
  body?: Maybe<Scalars['String']>;
  footer?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  send_to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
};

export type CustomTestEmailInput = {
  body?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  send_to?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

export type DailyChange = {
  __typename?: 'DailyChange';
  date?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  rules?: Maybe<Array<Maybe<DailyChangeRule>>>;
};

export type DailyChangeRule = {
  __typename?: 'DailyChangeRule';
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  rule_description?: Maybe<Scalars['String']>;
  rule_id?: Maybe<Scalars['Int']>;
};

export type Damage = {
  __typename?: 'Damage';
  area?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
};

export type DamageLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_etc?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type DamageTypeDetailInput = {
  areaOfDamage?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type DeleteConversationResponse = {
  __typename?: 'DeleteConversationResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type DeleteFavoriteResponse = {
  __typename?: 'DeleteFavoriteResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type DeleteFileResponse = {
  __typename?: 'DeleteFileResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type DeleteLocationResponse = {
  __typename?: 'DeleteLocationResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type DeleteRentalItemResponse = {
  __typename?: 'DeleteRentalItemResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type Delivery = {
  __typename?: 'Delivery';
  actual?: Maybe<Scalars['Int']>;
  departure?: Maybe<Scalars['Int']>;
  estimated?: Maybe<Scalars['Int']>;
  estimated_fee?: Maybe<Scalars['Int']>;
  renter_comment?: Maybe<Scalars['String']>;
  return?: Maybe<Scalars['Int']>;
  stationary?: Maybe<Scalars['Boolean']>;
  suggested_fee?: Maybe<Scalars['Int']>;
};

export type DeliveryInput = {
  actual?: InputMaybe<Scalars['Int']>;
  departure?: InputMaybe<Scalars['Int']>;
  estimated?: InputMaybe<Scalars['Int']>;
  estimated_fee?: InputMaybe<Scalars['Int']>;
  renter_comment?: InputMaybe<Scalars['String']>;
  return?: InputMaybe<Scalars['Int']>;
  stationary?: InputMaybe<Scalars['Boolean']>;
  suggested_fee?: InputMaybe<Scalars['Int']>;
};

export type Details = {
  __typename?: 'Details';
  has_pets?: Maybe<Scalars['Boolean']>;
  is_festival_travel?: Maybe<Scalars['Boolean']>;
  tiger_flow?: Maybe<Scalars['Boolean']>;
};

export type DetailsInput = {
  has_pets?: InputMaybe<Scalars['Boolean']>;
  is_festival_travel?: InputMaybe<Scalars['Boolean']>;
  tiger_flow?: InputMaybe<Scalars['Boolean']>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  active?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Int']>;
  amount_type?: Maybe<Scalars['String']>;
  apply_to_field?: Maybe<Scalars['String']>;
  apply_type?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  automatically_apply?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  date_applied?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  length_of_stay?: Maybe<Scalars['Int']>;
  redeemable?: Maybe<Scalars['Int']>;
  redeemable_per_person?: Maybe<Scalars['Int']>;
  redeemed?: Maybe<Scalars['Int']>;
  rental_owner?: Maybe<User>;
  rental_owner_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  to?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type DiscountCodeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  amount_type?: InputMaybe<Scalars['String']>;
  apply_to_field?: InputMaybe<Scalars['String']>;
  apply_type?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  automatically_apply?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_applied?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  length_of_stay?: InputMaybe<Scalars['Int']>;
  redeemable?: InputMaybe<Scalars['Int']>;
  redeemable_per_person?: InputMaybe<Scalars['Int']>;
  redeemed?: InputMaybe<Scalars['Int']>;
  rental_owner_id?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
};

export type DiscountCodesResponse = {
  __typename?: 'DiscountCodesResponse';
  discountCodes?: Maybe<Array<Maybe<DiscountCode>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type DriverDetail = {
  __typename?: 'DriverDetail';
  hasPenaltyPoints?: Maybe<Scalars['Boolean']>;
  licenseCategory?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<Scalars['String']>;
  penaltyPoints?: Maybe<Scalars['String']>;
  penaltyPointsDescription?: Maybe<Scalars['String']>;
  seatbeltWorn?: Maybe<Scalars['Boolean']>;
};

export type Drivers = {
  __typename?: 'Drivers';
  approved_by_admin_id?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  birthdate?: Maybe<Scalars['String']>;
  candidate_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  display_status?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_old_enough?: Maybe<Scalars['Boolean']>;
  last_mvr?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  license_number?: Maybe<Scalars['String']>;
  license_state?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated: Scalars['String'];
  user_id?: Maybe<Scalars['Int']>;
  verification_upload_link?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
  zendesk_ticket_id?: Maybe<Scalars['Int']>;
};

export type DriversInput = {
  approved_by_admin_id?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  birthdate?: InputMaybe<Scalars['String']>;
  candidate_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created: Scalars['String'];
  display_status?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  is_old_enough?: InputMaybe<Scalars['Boolean']>;
  last_mvr?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  license_number?: InputMaybe<Scalars['String']>;
  license_state?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated: Scalars['String'];
  user_id?: InputMaybe<Scalars['Int']>;
  verification_upload_link?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  zendesk_ticket_id?: InputMaybe<Scalars['Int']>;
};

export type Dropoff = {
  __typename?: 'Dropoff';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_etc?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DropoffInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_etc?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type EarnedCredit = {
  __typename?: 'EarnedCredit';
  amount?: Maybe<Scalars['Int']>;
  booking?: Maybe<Booking>;
  booking_id?: Maybe<Scalars['Int']>;
  can_delete?: Maybe<Scalars['Boolean']>;
  can_edit?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Scalars['JSON']>;
  parent_id?: Maybe<Scalars['Int']>;
  referred_by_user?: Maybe<User>;
  referred_by_user_id?: Maybe<Scalars['Int']>;
  referred_user?: Maybe<User>;
  referred_user_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  source?: Maybe<Scalars['String']>;
  system_action?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']>;
};

export type EarnedCreditInput = {
  amount?: InputMaybe<Scalars['Int']>;
  booking?: InputMaybe<BookingInput>;
  booking_id?: InputMaybe<Scalars['Int']>;
  can_delete?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<UserInput>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<MetadataInput>;
  parent_id?: InputMaybe<Scalars['Int']>;
  referred_by_user?: InputMaybe<UserInput>;
  referred_by_user_id?: InputMaybe<Scalars['Int']>;
  referred_user?: InputMaybe<UserInput>;
  referred_user_id?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  system_action?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type EarnedCreditsResponse = {
  __typename?: 'EarnedCreditsResponse';
  earnedCredits?: Maybe<Array<Maybe<EarnedCredit>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type EmergencyServicesDetail = {
  __typename?: 'EmergencyServicesDetail';
  ambulanceAttended?: Maybe<Scalars['Boolean']>;
  ambulanceComments?: Maybe<Scalars['String']>;
  ambulanceHospitalized?: Maybe<Scalars['Boolean']>;
  ambulanceTreated?: Maybe<Scalars['Boolean']>;
  fireAttended?: Maybe<Scalars['Boolean']>;
  fireCleanedSpillage?: Maybe<Scalars['Boolean']>;
  fireComments?: Maybe<Scalars['String']>;
  fireCutOutOfVehicle?: Maybe<Scalars['Boolean']>;
  fireCutOutOfVehicleDetails?: Maybe<Scalars['String']>;
  fireExtinguished?: Maybe<Scalars['Boolean']>;
  policeArrestDetails?: Maybe<Scalars['String']>;
  policeArrested?: Maybe<Scalars['Boolean']>;
  policeAttended?: Maybe<Scalars['Boolean']>;
  policeBadgeNumber?: Maybe<Scalars['String']>;
  policeBreathalysed?: Maybe<Scalars['Boolean']>;
  policeBreathalysedDetails?: Maybe<Scalars['String']>;
  policeCautioned?: Maybe<Scalars['Boolean']>;
  policeCautionedDetails?: Maybe<Scalars['String']>;
  policeComments?: Maybe<Scalars['String']>;
  policeCounty?: Maybe<Scalars['String']>;
  policeName?: Maybe<Scalars['String']>;
  policeNotified?: Maybe<Scalars['Boolean']>;
  policeNotifiedDate?: Maybe<Scalars['String']>;
  policeNotifiedInsuredOfIncident?: Maybe<Scalars['JSON']>;
  policeNotifiedTime?: Maybe<Scalars['String']>;
  policePulseId?: Maybe<Scalars['String']>;
  policeReport?: Maybe<Scalars['Boolean']>;
  policeReportNumber?: Maybe<Scalars['String']>;
  policeStatementGiven?: Maybe<Scalars['Boolean']>;
  policeStatementGivenBy?: Maybe<Scalars['String']>;
  policeStation?: Maybe<Scalars['String']>;
};

export type EventBooking = {
  __typename?: 'EventBooking';
  end_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  owner_payout?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type EventDataItem = {
  __typename?: 'EventDataItem';
  booking?: Maybe<EventBooking>;
  conversation_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  event_subtitle?: Maybe<Scalars['String']>;
  event_title?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  rental?: Maybe<EventRental>;
  sender?: Maybe<EventSender>;
};

export type EventDataItemResult = {
  __typename?: 'EventDataItemResult';
  event_feed?: Maybe<Array<EventDataItem>>;
  response_status?: Maybe<ResponseStatus>;
};

export type EventRental = {
  __typename?: 'EventRental';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  primary_image?: Maybe<Scalars['String']>;
};

export type EventSender = {
  __typename?: 'EventSender';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
};

export type Exposure = {
  __typename?: 'Exposure';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  claimant?: Maybe<ClaimPartyRef>;
  deductibleAmount?: Maybe<Scalars['String']>;
  deductibleApplies?: Maybe<Scalars['String']>;
  estimate?: Maybe<ExposureValue>;
  exposureType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  injuredPerson?: Maybe<InjuredPerson>;
  lossParty?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  supplement?: Maybe<ExposureValue>;
  valuation?: Maybe<ExposureValue>;
  vehicle?: Maybe<VehicleRef>;
};

export type ExposureValue = {
  __typename?: 'ExposureValue';
  amount?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  estimate?: Maybe<Scalars['String']>;
};

export type Extra = {
  __typename?: 'Extra';
  interests?: Maybe<Scalars['String']>;
  kidsPets?: Maybe<Scalars['String']>;
  rvDestinations?: Maybe<Array<Maybe<Scalars['String']>>>;
  rvStyle?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ExtraInput = {
  interests?: InputMaybe<Scalars['String']>;
  kidsPets?: InputMaybe<Scalars['String']>;
  rvDestinations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rvStyle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Favorite = {
  __typename?: 'Favorite';
  added_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  rental_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  user_id?: Maybe<Scalars['Int']>;
};

export type FavoriteInput = {
  rental_id: Scalars['Int'];
};

export type FavoritesResponse = {
  __typename?: 'FavoritesResponse';
  favorites?: Maybe<Array<Maybe<Favorite>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Features = {
  __typename?: 'Features';
  air_conditioner?: Maybe<Scalars['Boolean']>;
  audio_inputs?: Maybe<Scalars['Boolean']>;
  awning?: Maybe<Scalars['Boolean']>;
  backup_camera?: Maybe<Scalars['Boolean']>;
  beds_full?: Maybe<Scalars['Int']>;
  beds_king?: Maybe<Scalars['Int']>;
  beds_queen?: Maybe<Scalars['Int']>;
  beds_twin?: Maybe<Scalars['Int']>;
  bike_rack?: Maybe<Scalars['Boolean']>;
  burning_man_friendly?: Maybe<Scalars['Boolean']>;
  cd_player?: Maybe<Scalars['Boolean']>;
  ceiling_fan?: Maybe<Scalars['Boolean']>;
  dining_table?: Maybe<Scalars['Boolean']>;
  extra_storage?: Maybe<Scalars['Boolean']>;
  fuel_tank?: Maybe<Scalars['Int']>;
  fuel_type?: Maybe<Scalars['String']>;
  generator?: Maybe<Scalars['Boolean']>;
  gray_tank?: Maybe<Scalars['Int']>;
  handicap_accessible?: Maybe<Scalars['Boolean']>;
  heater?: Maybe<Scalars['Boolean']>;
  hitch_weight?: Maybe<Scalars['Int']>;
  hot_water_tank?: Maybe<Scalars['Boolean']>;
  inside_shower?: Maybe<Scalars['Boolean']>;
  inverter?: Maybe<Scalars['Boolean']>;
  kitchen_sink?: Maybe<Scalars['Boolean']>;
  leveling_jacks?: Maybe<Scalars['Boolean']>;
  microwave?: Maybe<Scalars['Boolean']>;
  minimum_age?: Maybe<Scalars['Int']>;
  mpg?: Maybe<Scalars['Int']>;
  one_way_rentals?: Maybe<Scalars['Boolean']>;
  outside_shower?: Maybe<Scalars['Boolean']>;
  oven?: Maybe<Scalars['Boolean']>;
  pet_friendly?: Maybe<Scalars['Boolean']>;
  propane_tank?: Maybe<Scalars['String']>;
  radio?: Maybe<Scalars['Boolean']>;
  refrigerator?: Maybe<Scalars['Boolean']>;
  satellite?: Maybe<Scalars['Boolean']>;
  sewage_tank?: Maybe<Scalars['Int']>;
  skylight?: Maybe<Scalars['Boolean']>;
  slide_outs?: Maybe<Scalars['Int']>;
  smoking_allowed?: Maybe<Scalars['Boolean']>;
  solar?: Maybe<Scalars['Boolean']>;
  stove?: Maybe<Scalars['Boolean']>;
  tailgate_friendly?: Maybe<Scalars['Boolean']>;
  toilet?: Maybe<Scalars['Boolean']>;
  tow_hitch?: Maybe<Scalars['Boolean']>;
  trailer_weight?: Maybe<Scalars['Int']>;
  transmission?: Maybe<Scalars['String']>;
  tv_dvd?: Maybe<Scalars['Boolean']>;
  washer_dryer?: Maybe<Scalars['Boolean']>;
  water_tank?: Maybe<Scalars['Int']>;
  wifi?: Maybe<Scalars['Boolean']>;
};

export type FeaturesDescription = {
  __typename?: 'FeaturesDescription';
  description: Scalars['String'];
};

export type FeaturesInput = {
  air_conditioner?: InputMaybe<Scalars['Boolean']>;
  audio_inputs?: InputMaybe<Scalars['Boolean']>;
  awning?: InputMaybe<Scalars['Boolean']>;
  backup_camera?: InputMaybe<Scalars['Boolean']>;
  beds_full?: InputMaybe<Scalars['Int']>;
  beds_king?: InputMaybe<Scalars['Int']>;
  beds_queen?: InputMaybe<Scalars['Int']>;
  beds_twin?: InputMaybe<Scalars['Int']>;
  bike_rack?: InputMaybe<Scalars['Boolean']>;
  burning_man_friendly?: InputMaybe<Scalars['Boolean']>;
  cd_player?: InputMaybe<Scalars['Boolean']>;
  ceiling_fan?: InputMaybe<Scalars['Boolean']>;
  dining_table?: InputMaybe<Scalars['Boolean']>;
  extra_storage?: InputMaybe<Scalars['Boolean']>;
  fuel_tank?: InputMaybe<Scalars['Int']>;
  fuel_type?: InputMaybe<Scalars['String']>;
  generator?: InputMaybe<Scalars['Boolean']>;
  gray_tank?: InputMaybe<Scalars['Int']>;
  handicap_accessible?: InputMaybe<Scalars['Boolean']>;
  heater?: InputMaybe<Scalars['Boolean']>;
  hitch_weight?: InputMaybe<Scalars['Int']>;
  hot_water_tank?: InputMaybe<Scalars['Boolean']>;
  inside_shower?: InputMaybe<Scalars['Boolean']>;
  inverter?: InputMaybe<Scalars['Boolean']>;
  kitchen_sink?: InputMaybe<Scalars['Boolean']>;
  leveling_jacks?: InputMaybe<Scalars['Boolean']>;
  microwave?: InputMaybe<Scalars['Boolean']>;
  minimum_age?: InputMaybe<Scalars['Int']>;
  mpg?: InputMaybe<Scalars['Int']>;
  one_way_rentals?: InputMaybe<Scalars['Boolean']>;
  outside_shower?: InputMaybe<Scalars['Boolean']>;
  oven?: InputMaybe<Scalars['Boolean']>;
  pet_friendly?: InputMaybe<Scalars['Boolean']>;
  propane_tank?: InputMaybe<Scalars['String']>;
  radio?: InputMaybe<Scalars['Boolean']>;
  refrigerator?: InputMaybe<Scalars['Boolean']>;
  satellite?: InputMaybe<Scalars['Boolean']>;
  sewage_tank?: InputMaybe<Scalars['Int']>;
  skylight?: InputMaybe<Scalars['Boolean']>;
  slide_outs?: InputMaybe<Scalars['Int']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']>;
  solar?: InputMaybe<Scalars['Boolean']>;
  stove?: InputMaybe<Scalars['Boolean']>;
  tailgate_friendly?: InputMaybe<Scalars['Boolean']>;
  toilet?: InputMaybe<Scalars['Boolean']>;
  tow_hitch?: InputMaybe<Scalars['Boolean']>;
  trailer_weight?: InputMaybe<Scalars['Int']>;
  transmission?: InputMaybe<Scalars['String']>;
  tv_dvd?: InputMaybe<Scalars['Boolean']>;
  washer_dryer?: InputMaybe<Scalars['Boolean']>;
  water_tank?: InputMaybe<Scalars['Int']>;
  wifi?: InputMaybe<Scalars['Boolean']>;
};

export type File = {
  __typename?: 'File';
  actor?: Maybe<User>;
  actor_id?: Maybe<Scalars['Int']>;
  auto_include?: Maybe<Scalars['Boolean']>;
  booking?: Maybe<Booking>;
  booking_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  exif_created?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  guid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  include_esign?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Message>;
  message_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  out_of_date?: Maybe<Scalars['Boolean']>;
  public_id?: Maybe<Scalars['String']>;
  rental?: Maybe<Rental>;
  rental_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  shared?: Maybe<Scalars['Boolean']>;
  signable?: Maybe<Scalars['Boolean']>;
  signers?: Maybe<Array<Maybe<Scalars['String']>>>;
  signing_canceled?: Maybe<Scalars['Boolean']>;
  signing_complete?: Maybe<Scalars['Boolean']>;
  signing_service_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']>;
};

export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  approvedAt?: Maybe<Scalars['String']>;
  financialTransactionType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  paymentItems?: Maybe<Array<Maybe<PaymentItem>>>;
  reserveItems?: Maybe<Array<Maybe<ReserveItem>>>;
  stage?: Maybe<Scalars['String']>;
};

export type FutureBooking = {
  __typename?: 'FutureBooking';
  from?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<BookingItem>>>;
  service_fee?: Maybe<Scalars['Float']>;
  services?: Maybe<Array<Maybe<Service>>>;
  to?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type Generator = {
  __typename?: 'Generator';
  actual?: Maybe<Scalars['Int']>;
  departure?: Maybe<Scalars['Int']>;
  estimated?: Maybe<Scalars['Int']>;
  estimated_fee?: Maybe<Scalars['Int']>;
  return?: Maybe<Scalars['Int']>;
  suggested_fee?: Maybe<Scalars['Int']>;
};

export type GeneratorInput = {
  actual?: InputMaybe<Scalars['Int']>;
  departure?: InputMaybe<Scalars['Int']>;
  estimated?: InputMaybe<Scalars['Int']>;
  estimated_fee?: InputMaybe<Scalars['Int']>;
  return?: InputMaybe<Scalars['Int']>;
  suggested_fee?: InputMaybe<Scalars['Int']>;
};

export type GetClaimResponse = {
  __typename?: 'GetClaimResponse';
  accountCode?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  claimIncidentDetails?: Maybe<ClaimIncidentDetails>;
  claimNumber?: Maybe<Scalars['String']>;
  claimParties?: Maybe<Array<Maybe<ClaimParty>>>;
  claimReferenceNumber?: Maybe<Scalars['Int']>;
  claimType?: Maybe<Scalars['String']>;
  datetimeOfLoss?: Maybe<Scalars['String']>;
  datetimeOfNotification?: Maybe<Scalars['String']>;
  emergencyServicesDetail?: Maybe<EmergencyServicesDetail>;
  exposures?: Maybe<Array<Maybe<Exposure>>>;
  financialTransactions?: Maybe<Array<Maybe<FinancialTransaction>>>;
  lossType?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notificationMethod?: Maybe<Scalars['String']>;
  notifier?: Maybe<ClaimPartyRef>;
  policyNumber?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<ClaimTag>>>;
  vehicles?: Maybe<Array<Maybe<ClaimVehicle>>>;
};

export type Handoff = {
  __typename?: 'Handoff';
  asset_id?: Maybe<Scalars['String']>;
  asset_type?: Maybe<Scalars['String']>;
  booking_id?: Maybe<Scalars['String']>;
  booking_status?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  damage_errors?: Maybe<Array<Maybe<HandoffError>>>;
  damage_files: Array<HandoffFile>;
  departure_complete?: Maybe<Scalars['Boolean']>;
  departure_errors?: Maybe<Array<Maybe<HandoffError>>>;
  departure_files: Array<HandoffFile>;
  id: Scalars['String'];
  owner_acknowledged_departure_form?: Maybe<Scalars['Boolean']>;
  owner_acknowledged_rental_agreement?: Maybe<Scalars['Boolean']>;
  owner_departure_complete?: Maybe<Scalars['Boolean']>;
  owner_departure_eligible?: Maybe<Scalars['Boolean']>;
  owner_departure_started?: Maybe<Scalars['Boolean']>;
  owner_present_on_departure?: Maybe<Scalars['Boolean']>;
  owner_reporting_vehicle_damage?: Maybe<Scalars['Boolean']>;
  owner_return_complete?: Maybe<Scalars['Boolean']>;
  owner_return_eligible?: Maybe<Scalars['Boolean']>;
  owner_return_started?: Maybe<Scalars['Boolean']>;
  renter_acknowledged_departure_form?: Maybe<Scalars['Boolean']>;
  renter_acknowledged_rental_agreement?: Maybe<Scalars['Boolean']>;
  renter_departure_complete?: Maybe<Scalars['Boolean']>;
  renter_departure_eligible?: Maybe<Scalars['Boolean']>;
  renter_departure_started?: Maybe<Scalars['Boolean']>;
  renter_return_complete?: Maybe<Scalars['Boolean']>;
  renter_return_eligible?: Maybe<Scalars['Boolean']>;
  renter_return_started?: Maybe<Scalars['Boolean']>;
  required_photo_count?: Maybe<Scalars['Int']>;
  return_complete?: Maybe<Scalars['Boolean']>;
  return_errors?: Maybe<Array<Maybe<HandoffError>>>;
  return_files: Array<HandoffFile>;
  signatures?: Maybe<HandoffSignatureTypes>;
  suggested_photo_count?: Maybe<Scalars['Int']>;
};

export type HandoffError = {
  __typename?: 'HandoffError';
  message?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
};

export type HandoffFile = {
  __typename?: 'HandoffFile';
  admin_submitted?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  owner_submitted?: Maybe<Scalars['Boolean']>;
  renter_submitted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type HandoffInput = {
  booking_id: Scalars['Int'];
  id: Scalars['String'];
  renter_acknowledged_departure_form?: InputMaybe<Scalars['Boolean']>;
  renter_acknowledged_rental_agreement?: InputMaybe<Scalars['Boolean']>;
  renter_departure_complete?: InputMaybe<Scalars['Boolean']>;
  renter_return_complete?: InputMaybe<Scalars['Boolean']>;
};

export type HandoffResponse = {
  __typename?: 'HandoffResponse';
  handoff?: Maybe<Handoff>;
  response_status?: Maybe<ResponseStatus>;
};

export type HandoffSignature = {
  __typename?: 'HandoffSignature';
  departure?: Maybe<HandoffFile>;
  return?: Maybe<HandoffFile>;
};

export type HandoffSignatureTypes = {
  __typename?: 'HandoffSignatureTypes';
  departure?: Maybe<HandoffFile>;
  return?: Maybe<HandoffFile>;
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  read_db?: Maybe<Scalars['String']>;
  write_db?: Maybe<Scalars['String']>;
};

export type Images = {
  __typename?: 'Images';
  best?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
  skip_enhance?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['Boolean']>;
};

export type ImagesInput = {
  best?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  skip_enhance?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['Boolean']>;
};

export type InjuredPerson = {
  __typename?: 'InjuredPerson';
  description?: Maybe<Scalars['String']>;
  fatallyInjured?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  injuries?: Maybe<Array<Maybe<Injury>>>;
  lostWages?: Maybe<Scalars['Boolean']>;
  lostWagesAmount?: Maybe<Scalars['String']>;
  medicalAssessments?: Maybe<Array<Maybe<MedicalAssessments>>>;
  professionallyTransported?: Maybe<Scalars['Boolean']>;
  receivedTreatment?: Maybe<Scalars['Boolean']>;
  usedSeatbelt?: Maybe<Scalars['Boolean']>;
};

export type Injury = {
  __typename?: 'Injury';
  id?: Maybe<Scalars['String']>;
  injuredPersonId?: Maybe<Scalars['String']>;
  injuryBodyPart?: Maybe<Scalars['String']>;
  injuryCategory?: Maybe<Scalars['String']>;
  injurySeverity?: Maybe<Scalars['String']>;
  injuryType?: Maybe<Scalars['String']>;
};

export type InsurancePlanId = {
  __typename?: 'InsurancePlanId';
  bundle_required?: Maybe<Scalars['Boolean']>;
  claims_number?: Maybe<Scalars['String']>;
  comp_policy_url?: Maybe<Scalars['String']>;
  comprehensive_coverage?: Maybe<Scalars['Boolean']>;
  comprehensive_maximum?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  insurance_address_1?: Maybe<Scalars['String']>;
  insurance_city?: Maybe<Scalars['String']>;
  insurance_end_date?: Maybe<Scalars['String']>;
  insurance_name?: Maybe<Scalars['String']>;
  insurance_plan_override?: Maybe<Scalars['String']>;
  insurance_policy_number?: Maybe<Scalars['String']>;
  insurance_start_date?: Maybe<Scalars['String']>;
  insurance_state?: Maybe<Scalars['String']>;
  insurance_zip?: Maybe<Scalars['String']>;
  insured_address_1?: Maybe<Scalars['String']>;
  insured_city?: Maybe<Scalars['String']>;
  insured_name?: Maybe<Scalars['String']>;
  insured_state?: Maybe<Scalars['String']>;
  insured_zip?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  last_updated_by?: Maybe<Scalars['String']>;
  liability_coverage?: Maybe<Scalars['Boolean']>;
  liability_maximum?: Maybe<Scalars['String']>;
  liability_policy_url?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  owner_body?: Maybe<Scalars['String']>;
  owner_comprehensive_deductible?: Maybe<Scalars['String']>;
  owner_headline?: Maybe<Scalars['String']>;
  owner_liability_deductible?: Maybe<Scalars['String']>;
  owner_liability_maximum?: Maybe<Scalars['String']>;
  renter_body?: Maybe<Scalars['String']>;
  renter_comprehensive_deductible?: Maybe<Scalars['String']>;
  renter_headline?: Maybe<Scalars['String']>;
  renter_liability_deductible?: Maybe<Scalars['String']>;
  renter_liability_maximum?: Maybe<Scalars['String']>;
  requires_driver_verification?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
};

export type InsurancePlanIdInput = {
  bundle_required?: InputMaybe<Scalars['Boolean']>;
  claims_number?: InputMaybe<Scalars['String']>;
  comp_policy_url?: InputMaybe<Scalars['String']>;
  comprehensive_coverage?: InputMaybe<Scalars['Boolean']>;
  comprehensive_maximum?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  insurance_address_1?: InputMaybe<Scalars['String']>;
  insurance_city?: InputMaybe<Scalars['String']>;
  insurance_end_date?: InputMaybe<Scalars['String']>;
  insurance_name?: InputMaybe<Scalars['String']>;
  insurance_plan_override?: InputMaybe<Scalars['String']>;
  insurance_policy_number?: InputMaybe<Scalars['String']>;
  insurance_start_date?: InputMaybe<Scalars['String']>;
  insurance_state?: InputMaybe<Scalars['String']>;
  insurance_zip?: InputMaybe<Scalars['String']>;
  insured_address_1?: InputMaybe<Scalars['String']>;
  insured_city?: InputMaybe<Scalars['String']>;
  insured_name?: InputMaybe<Scalars['String']>;
  insured_state?: InputMaybe<Scalars['String']>;
  insured_zip?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  liability_coverage?: InputMaybe<Scalars['Boolean']>;
  liability_maximum?: InputMaybe<Scalars['String']>;
  liability_policy_url?: InputMaybe<Scalars['String']>;
  locality?: InputMaybe<Scalars['String']>;
  owner_body?: InputMaybe<Scalars['String']>;
  owner_comprehensive_deductible?: InputMaybe<Scalars['String']>;
  owner_headline?: InputMaybe<Scalars['String']>;
  owner_liability_deductible?: InputMaybe<Scalars['String']>;
  owner_liability_maximum?: InputMaybe<Scalars['String']>;
  renter_body?: InputMaybe<Scalars['String']>;
  renter_comprehensive_deductible?: InputMaybe<Scalars['String']>;
  renter_headline?: InputMaybe<Scalars['String']>;
  renter_liability_deductible?: InputMaybe<Scalars['String']>;
  renter_liability_maximum?: InputMaybe<Scalars['String']>;
  requires_driver_verification?: InputMaybe<Scalars['Boolean']>;
  updated?: InputMaybe<Scalars['String']>;
};

export enum InsuranceState {
  Approved = 'APPROVED',
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  Started = 'STARTED'
}

export type ItemRequest = {
  count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  original_tax_rate_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type Key = {
  __typename?: 'Key';
  account?: Maybe<Account>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  updated?: Maybe<Scalars['String']>;
};

export type LastServiceLog = {
  __typename?: 'LastServiceLog';
  attempts?: Maybe<Scalars['Int']>;
  booking_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  rental_id?: Maybe<Scalars['Int']>;
  response?: Maybe<LastServiceLogResponse>;
  revision?: Maybe<Scalars['Int']>;
  service_id?: Maybe<Scalars['Int']>;
  status_code?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type LastServiceLogInput = {
  attempts?: InputMaybe<Scalars['Int']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  response?: InputMaybe<LastServiceLogResponseInput>;
  revision?: InputMaybe<Scalars['Int']>;
  service_id?: InputMaybe<Scalars['Int']>;
  status_code?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type LastServiceLogResponse = {
  __typename?: 'LastServiceLogResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type LastServiceLogResponseInput = {
  success?: InputMaybe<Scalars['Boolean']>;
};

export type LatLngInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LatestReview = {
  __typename?: 'LatestReview';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type LatestReviewInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Locale = {
  __typename?: 'Locale';
  base_currency?: Maybe<Scalars['String']>;
  distance_unit?: Maybe<Scalars['String']>;
};

export type LocaleInput = {
  base_currency?: InputMaybe<Scalars['String']>;
  distance_unit?: InputMaybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  archived?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<LocationAvailability>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  custom_insurance_text?: Maybe<Scalars['String']>;
  eligible_for_system_tax_rates?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  locale?: Maybe<LocationLocale>;
  name?: Maybe<Scalars['String']>;
  opt_out_marketplace_taxes?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  payment_processing_info_id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  special_hours?: Maybe<Array<Maybe<SpecialHours>>>;
  state?: Maybe<Scalars['String']>;
  state_tax_id?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_etc?: Maybe<Scalars['String']>;
  tax_rate_id?: Maybe<Scalars['Int']>;
  tax_rate_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  tax_split_eligible?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
  waived_insurance_text?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LocationAvailability = {
  __typename?: 'LocationAvailability';
  days?: Maybe<LocationAvailabilityDays>;
};

export type LocationAvailabilityDay = {
  __typename?: 'LocationAvailabilityDay';
  dropoff?: Maybe<LocationAvailabilityInterval>;
  pickup?: Maybe<LocationAvailabilityInterval>;
};

export type LocationAvailabilityDays = {
  __typename?: 'LocationAvailabilityDays';
  friday?: Maybe<LocationAvailabilityDay>;
  monday?: Maybe<LocationAvailabilityDay>;
  saturday?: Maybe<LocationAvailabilityDay>;
  sunday?: Maybe<LocationAvailabilityDay>;
  thursday?: Maybe<LocationAvailabilityDay>;
  tuesday?: Maybe<LocationAvailabilityDay>;
  wednesday?: Maybe<LocationAvailabilityDay>;
};

export type LocationAvailabilityDaysInput = {
  friday?: InputMaybe<LocationAvailabilityDaysInput>;
  monday?: InputMaybe<LocationAvailabilityDaysInput>;
  saturday?: InputMaybe<LocationAvailabilityDaysInput>;
  sunday?: InputMaybe<LocationAvailabilityDaysInput>;
  thursday?: InputMaybe<LocationAvailabilityDaysInput>;
  tuesday?: InputMaybe<LocationAvailabilityDaysInput>;
  wednesday?: InputMaybe<LocationAvailabilityDaysInput>;
};

export type LocationAvailabilityInterval = {
  __typename?: 'LocationAvailabilityInterval';
  end_time?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['Int']>;
  unavailable?: Maybe<Scalars['Boolean']>;
};

export type LocationInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  availability?: InputMaybe<Scalars['JSON']>;
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  custom_insurance_text?: InputMaybe<Scalars['String']>;
  eligible_for_system_tax_rates?: InputMaybe<Scalars['Boolean']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  locale?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  opt_out_marketplace_taxes?: InputMaybe<Scalars['Boolean']>;
  payment_processing_info_id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  special_hours?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  state?: InputMaybe<Scalars['String']>;
  state_tax_id?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  street_etc?: InputMaybe<Scalars['String']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tax_split_eligible?: InputMaybe<Scalars['Boolean']>;
  waived_insurance_text?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type LocationLocale = {
  __typename?: 'LocationLocale';
  base_currency: Scalars['String'];
};

export type LocationsResponse = {
  __typename?: 'LocationsResponse';
  locations?: Maybe<Array<Maybe<Location>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type MedicalAssessments = {
  __typename?: 'MedicalAssessments';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  completedDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  injuries?: Maybe<Array<Maybe<Injury>>>;
  scheduledDate?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  actor_id?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  booking_summary?: Maybe<BookingSummary>;
  clicked?: Maybe<Scalars['String']>;
  conversation?: Maybe<Conversation>;
  conversation_id?: Maybe<Scalars['Int']>;
  files?: Maybe<Array<Maybe<Scalars['Int']>>>;
  flagged?: Maybe<Scalars['Boolean']>;
  flagged_text?: Maybe<Scalars['String']>;
  from_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  latest_status?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  proxy_interaction_id?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  receiver_id?: Maybe<Scalars['Int']>;
  ref_booking_id?: Maybe<Scalars['Int']>;
  ref_rental_id?: Maybe<Scalars['Int']>;
  sender_id?: Maybe<Scalars['Int']>;
  sentiment?: Maybe<Scalars['String']>;
  sentiment_confidence?: Maybe<Scalars['Float']>;
  template?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type MessageInput = {
  actor_id?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  clicked?: InputMaybe<Scalars['String']>;
  conversation_id?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  flagged_text?: InputMaybe<Scalars['String']>;
  from_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  latest_status?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  proxy_interaction_id?: InputMaybe<Scalars['String']>;
  read?: InputMaybe<Scalars['Boolean']>;
  receiver_id: Scalars['Int'];
  ref_booking_id?: InputMaybe<Scalars['Int']>;
  ref_rental_id?: InputMaybe<Scalars['Int']>;
  sender_id?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<Scalars['String']>;
  sentiment_confidence?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  has_sent_message_without_phone_verified?: Maybe<Scalars['Boolean']>;
  last_calendar_activity_at?: Maybe<Scalars['String']>;
  localized_languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  nationality?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MetadataInput = {
  has_sent_message_without_phone_verified?: InputMaybe<Scalars['Boolean']>;
  last_calendar_activity_at?: InputMaybe<Scalars['String']>;
  localized_languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nationality?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Mileage = {
  __typename?: 'Mileage';
  actual?: Maybe<Scalars['Int']>;
  departure?: Maybe<Scalars['Int']>;
  estimated?: Maybe<Scalars['Int']>;
  estimated_fee?: Maybe<Scalars['Int']>;
  return?: Maybe<Scalars['Int']>;
  suggested_fee?: Maybe<Scalars['Int']>;
};

export type MileageInput = {
  actual?: InputMaybe<Scalars['Int']>;
  departure?: InputMaybe<Scalars['Int']>;
  estimated?: InputMaybe<Scalars['Int']>;
  estimated_fee?: InputMaybe<Scalars['Int']>;
  return?: InputMaybe<Scalars['Int']>;
  suggested_fee?: InputMaybe<Scalars['Int']>;
};

export type MissingFields = {
  __typename?: 'MissingFields';
  rental?: Maybe<Array<Scalars['String']>>;
  renter?: Maybe<Array<Scalars['String']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminCreateDiscountCode?: Maybe<DiscountCode>;
  adminDeleteCard?: Maybe<MutationCardsResponse>;
  adminSyncCard?: Maybe<UserCard>;
  adminUpdateCoachnetSubscription?: Maybe<CoachnetSubscription>;
  archiveGateway?: Maybe<MutationGatewaysResponse>;
  /** @deprecated Use batchItems instead */
  batch: BookingItemsResponse;
  batchItems: BookingItemsResponse;
  cancelCoachnetSubscription?: Maybe<MutationCoachnetSubscriptionResponse>;
  changeBookingStatus?: Maybe<Booking>;
  connectGateway?: Maybe<UnionResponse>;
  copyDefaultRulesToDealer?: Maybe<MutationBundleResponse>;
  copyItems: BookingItem;
  createAccount?: Maybe<AccountResponse>;
  createBid?: Maybe<Bid>;
  createBooking?: Maybe<Booking>;
  createBookingDeliveryProposal: BookingDeliveryProposal;
  createBookingItem: BookingItem;
  createBundle?: Maybe<Bundle>;
  createCard?: Maybe<UserCard>;
  createClaim?: Maybe<Claim>;
  createClientToken?: Maybe<CreateClientTokenPayload>;
  createCoachnetSubscription?: Maybe<CoachnetSubscription>;
  createConsignedPayout?: Maybe<ConsignedPayout>;
  createConsignedPayoutItem?: Maybe<ConsignedPayoutItem>;
  createConversation?: Maybe<Conversation>;
  createCustomEmail?: Maybe<CustomEmail>;
  createDiscountCode?: Maybe<DiscountCode>;
  createEarnedCredit: EarnedCredit;
  createFavorite: Favorite;
  createFeature?: Maybe<BundleFeature>;
  createFile?: Maybe<File>;
  createFiles: Array<File>;
  createInfoVehicle?: Maybe<VehicleInfo>;
  createKey?: Maybe<Key>;
  createLocation?: Maybe<Location>;
  createMessage?: Maybe<CreateMessageResponse>;
  createQuote?: Maybe<Quote>;
  createRentalItem?: Maybe<RentalItem>;
  createRentalReview?: Maybe<Review>;
  createRenterReview?: Maybe<Review>;
  createRule?: Maybe<BundleRule>;
  createUser?: Maybe<UserAuthResponse>;
  createUserRole?: Maybe<AccountRole>;
  declineBid?: Maybe<MutationBidResponse>;
  deleteBid?: Maybe<MutationBidResponse>;
  deleteBookingItem: MutationBookingItemResponse;
  deleteBundle?: Maybe<MutationBundleResponse>;
  deleteCard?: Maybe<MutationCardsResponse>;
  deleteClaim?: Maybe<MutationClaimsResponse>;
  deleteConsignedPayout?: Maybe<MutationConsignedPayoutsResponse>;
  deleteConsignedPayoutItem?: Maybe<MutationConsignedPayoutItemsResponse>;
  deleteConversation?: Maybe<DeleteConversationResponse>;
  deleteCustomEmail?: Maybe<MutationCustomEmailsResponse>;
  deleteDealerRules?: Maybe<MutationBundleResponse>;
  deleteDiscountCode?: Maybe<MutationDiscountCodesResponse>;
  deleteEarnedCredit?: Maybe<MutationEarnedCreditsResponse>;
  deleteFavoriteById?: Maybe<DeleteFavoriteResponse>;
  deleteFavoritesByRentalId?: Maybe<DeleteFavoriteResponse>;
  deleteFeature?: Maybe<MutationBundleResponse>;
  deleteFile?: Maybe<DeleteFileResponse>;
  deleteInfoVehicle?: Maybe<MutationInfoVehiclesResponse>;
  deleteKey?: Maybe<MutationAccountResponse>;
  deleteLocation?: Maybe<DeleteLocationResponse>;
  deleteRentalItem?: Maybe<DeleteRentalItemResponse>;
  deleteRule?: Maybe<MutationBundleResponse>;
  duplicateBundle?: Maybe<Bundle>;
  patchCard?: Maybe<UserCard>;
  regenerateKey?: Maybe<Key>;
  sendTestEmail?: Maybe<CustomTestEmail>;
  setBundleUptake?: Maybe<MutationBundleResponse>;
  updateAccount?: Maybe<Account>;
  updateActivities?: Maybe<ResponseStatus>;
  updateActivity?: Maybe<Activity>;
  updateBid?: Maybe<Bid>;
  updateBooking?: Maybe<Booking>;
  updateBookingItem: BookingItem;
  updateBundle?: Maybe<Bundle>;
  updateCheckoutSteps?: Maybe<CheckoutSteps>;
  updateConsigned: BookingItem;
  updateConsignedPayout?: Maybe<ConsignedPayout>;
  updateConsignedPayoutItem?: Maybe<ConsignedPayoutItem>;
  updateCustomEmail?: Maybe<CustomEmail>;
  updateDiscountCode?: Maybe<DiscountCode>;
  updateEarnedCredit: EarnedCredit;
  updateFeature?: Maybe<BundleFeature>;
  updateFile?: Maybe<File>;
  updateGateway?: Maybe<MutationGatewaysResponse>;
  updateHandoff?: Maybe<HandoffResponse>;
  updateInfoVehicle?: Maybe<VehicleInfo>;
  updateLocation?: Maybe<Location>;
  updateRentalItem?: Maybe<RentalItem>;
  updateRentalReview?: Maybe<Review>;
  updateRenterReview?: Maybe<Review>;
  updateReviewOwnerResponse?: Maybe<Review>;
  updateRule?: Maybe<BundleRule>;
  updateUser?: Maybe<User>;
  updateUserRole?: Maybe<AccountRole>;
};


export type MutationAdminCreateDiscountCodeArgs = {
  input: DiscountCodeInput;
};


export type MutationAdminDeleteCardArgs = {
  card_id: Scalars['Int'];
  replacement_id?: InputMaybe<Scalars['Int']>;
  user_id: Scalars['Int'];
};


export type MutationAdminSyncCardArgs = {
  card_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type MutationAdminUpdateCoachnetSubscriptionArgs = {
  id: Scalars['Int'];
  input: UpdateSubscriptionInput;
};


export type MutationArchiveGatewayArgs = {
  gateway_id: Scalars['Int'];
};


export type MutationBatchArgs = {
  booking_id: Scalars['Int'];
  input: Array<BookingItemInput>;
};


export type MutationBatchItemsArgs = {
  booking_id: Scalars['Int'];
  input: Array<BookingItemInput>;
};


export type MutationCancelCoachnetSubscriptionArgs = {
  id: Scalars['Int'];
};


export type MutationChangeBookingStatusArgs = {
  booking_id: Scalars['Int'];
  input: ChangeBookingStatusInput;
};


export type MutationConnectGatewayArgs = {
  country: Scalars['String'];
  currency: Scalars['String'];
  input: WriteFundRequest;
};


export type MutationCopyDefaultRulesToDealerArgs = {
  input: CopyDefaultRulesInput;
};


export type MutationCopyItemsArgs = {
  booking_id: Scalars['Int'];
  input: RentalItemCopy;
};


export type MutationCreateBidArgs = {
  input: BidInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateBookingDeliveryProposalArgs = {
  input: CreateBookingDeliveryProposalInput;
};


export type MutationCreateBookingItemArgs = {
  booking_id: Scalars['Int'];
  input: BookingItemInput;
};


export type MutationCreateBundleArgs = {
  input: BundleInput;
};


export type MutationCreateCardArgs = {
  input: UserCardInput;
  user_id: Scalars['Int'];
};


export type MutationCreateClaimArgs = {
  input: NewClaimInput;
};


export type MutationCreateClientTokenArgs = {
  input?: InputMaybe<ClientTokenInput>;
};


export type MutationCreateCoachnetSubscriptionArgs = {
  input: CoachnetSubscriptionInput;
};


export type MutationCreateConsignedPayoutArgs = {
  input: ConsignedPayoutInput;
};


export type MutationCreateConsignedPayoutItemArgs = {
  consigned_payout_id: Scalars['Int'];
  input: ConsignedPayoutItemInput;
};


export type MutationCreateConversationArgs = {
  input?: InputMaybe<ConversationInput>;
};


export type MutationCreateCustomEmailArgs = {
  input: CustomEmailInput;
};


export type MutationCreateDiscountCodeArgs = {
  input: DiscountCodeInput;
};


export type MutationCreateEarnedCreditArgs = {
  input: EarnedCreditInput;
};


export type MutationCreateFavoriteArgs = {
  input: FavoriteInput;
};


export type MutationCreateFeatureArgs = {
  bundle_id: Scalars['String'];
  input: BundleFeatureInput;
};


export type MutationCreateFileArgs = {
  file_input: CreateFileInput;
};


export type MutationCreateFilesArgs = {
  file_inputs: Array<CreateFileInput>;
};


export type MutationCreateInfoVehicleArgs = {
  input: VehicleInfoInput;
};


export type MutationCreateKeyArgs = {
  account_id: Scalars['String'];
  create_key_input: CreateKeyRequest;
};


export type MutationCreateLocationArgs = {
  location_input: LocationInput;
};


export type MutationCreateMessageArgs = {
  input?: InputMaybe<MessageInput>;
};


export type MutationCreateQuoteArgs = {
  quote_request: QuoteRequestInput;
};


export type MutationCreateRentalItemArgs = {
  rental_item_request: RentalItemRequestInput;
};


export type MutationCreateRentalReviewArgs = {
  rental_review_input: CreateRentalReviewInput;
};


export type MutationCreateRenterReviewArgs = {
  renter_review_input: RenterReviewInput;
};


export type MutationCreateRuleArgs = {
  bundle_id: Scalars['String'];
  input: BundleRuleInput;
};


export type MutationCreateUserArgs = {
  account_id: Scalars['String'];
  create_user_input: UserCreateRequest;
};


export type MutationCreateUserRoleArgs = {
  account_id: Scalars['String'];
  create_role_input: AccountRoleRequest;
};


export type MutationDeclineBidArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBidArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBookingItemArgs = {
  booking_id: Scalars['Int'];
  item_id: Scalars['Int'];
};


export type MutationDeleteBundleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCardArgs = {
  card_id: Scalars['Int'];
  replacement_id?: InputMaybe<Scalars['Int']>;
  user_id: Scalars['Int'];
};


export type MutationDeleteClaimArgs = {
  claim_id: Scalars['String'];
};


export type MutationDeleteConsignedPayoutArgs = {
  consigned_payout_id: Scalars['Int'];
};


export type MutationDeleteConsignedPayoutItemArgs = {
  consigned_payout_id: Scalars['Int'];
  consigned_payout_item_id: Scalars['Int'];
};


export type MutationDeleteConversationArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteCustomEmailArgs = {
  custom_email_id: Scalars['Int'];
};


export type MutationDeleteDealerRulesArgs = {
  owner_id: Scalars['Int'];
};


export type MutationDeleteDiscountCodeArgs = {
  discount_code_id: Scalars['Int'];
};


export type MutationDeleteEarnedCreditArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFavoriteByIdArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFavoritesByRentalIdArgs = {
  rental_id: Scalars['Int'];
};


export type MutationDeleteFeatureArgs = {
  bundle_id: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteInfoVehicleArgs = {
  vehicle_id: Scalars['Int'];
};


export type MutationDeleteKeyArgs = {
  account_id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentalItemArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRuleArgs = {
  bundle_id: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDuplicateBundleArgs = {
  id: Scalars['String'];
};


export type MutationPatchCardArgs = {
  card_id: Scalars['Int'];
  input: UserCardInput;
  user_id: Scalars['Int'];
};


export type MutationRegenerateKeyArgs = {
  account_id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationSendTestEmailArgs = {
  input: CustomTestEmailInput;
};


export type MutationSetBundleUptakeArgs = {
  input: SetPercentUptakeInput;
  user_id: Scalars['Int'];
};


export type MutationUpdateAccountArgs = {
  account_id: Scalars['String'];
  update_account_input: UpdateAccountRequest;
};


export type MutationUpdateActivitiesArgs = {
  user_id: Scalars['Int'];
};


export type MutationUpdateActivityArgs = {
  id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type MutationUpdateBidArgs = {
  id: Scalars['Int'];
  input: BidInput;
};


export type MutationUpdateBookingArgs = {
  booking_id: Scalars['Int'];
  input: BookingInput;
};


export type MutationUpdateBookingItemArgs = {
  booking_id: Scalars['Int'];
  input: BookingItemInput;
  item_id: Scalars['Int'];
};


export type MutationUpdateBundleArgs = {
  id: Scalars['String'];
  input: BundleInput;
};


export type MutationUpdateCheckoutStepsArgs = {
  booking_id: Scalars['Int'];
  checkout_steps: CheckoutStepsInput;
};


export type MutationUpdateConsignedArgs = {
  booking_id: Scalars['Int'];
  input: ConsignedPayAmount;
  item_id: Scalars['Int'];
};


export type MutationUpdateConsignedPayoutArgs = {
  consigned_payout_id: Scalars['Int'];
  input: ConsignedPayoutInput;
};


export type MutationUpdateConsignedPayoutItemArgs = {
  consigned_payout_id: Scalars['Int'];
  consigned_payout_item_id: Scalars['Int'];
  input: ConsignedPayoutItemInput;
};


export type MutationUpdateCustomEmailArgs = {
  custom_email_id: Scalars['Int'];
  input: CustomEmailInput;
};


export type MutationUpdateDiscountCodeArgs = {
  discount_code_id: Scalars['Int'];
  input: DiscountCodeInput;
};


export type MutationUpdateEarnedCreditArgs = {
  id: Scalars['Int'];
  input: EarnedCreditInput;
};


export type MutationUpdateFeatureArgs = {
  bundle_id: Scalars['String'];
  id: Scalars['String'];
  input: BundleFeatureInput;
};


export type MutationUpdateFileArgs = {
  file_input: UpdateFileInput;
  id: Scalars['Int'];
};


export type MutationUpdateGatewayArgs = {
  gateway_id: Scalars['Int'];
  input: WriteFundRequest;
};


export type MutationUpdateHandoffArgs = {
  handoff_input: HandoffInput;
};


export type MutationUpdateInfoVehicleArgs = {
  input: VehicleInfoInput;
  vehicle_id: Scalars['Int'];
};


export type MutationUpdateLocationArgs = {
  id: Scalars['Int'];
  location_input: UpdateLocationInput;
};


export type MutationUpdateRentalItemArgs = {
  id: Scalars['Int'];
  rental_item_request: RentalItemRequestInput;
};


export type MutationUpdateRentalReviewArgs = {
  rental_review_input: UpdateRentalReviewInput;
  review_id: Scalars['Int'];
};


export type MutationUpdateRenterReviewArgs = {
  renter_review_input: RenterReviewInput;
  review_id: Scalars['Int'];
};


export type MutationUpdateReviewOwnerResponseArgs = {
  review_id: Scalars['Int'];
  review_response_input: ReviewOwnerResponseInput;
};


export type MutationUpdateRuleArgs = {
  bundle_id: Scalars['String'];
  id: Scalars['String'];
  input: BundleRuleInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
  user_id: Scalars['Int'];
};


export type MutationUpdateUserRoleArgs = {
  account_id: Scalars['String'];
  update_role_input: UpdateRoleRequest;
};

export type MutationAccountResponse = {
  __typename?: 'MutationAccountResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationBidResponse = {
  __typename?: 'MutationBidResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationBookingItemResponse = {
  __typename?: 'MutationBookingItemResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationBundleResponse = {
  __typename?: 'MutationBundleResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationCardsResponse = {
  __typename?: 'MutationCardsResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationClaimsResponse = {
  __typename?: 'MutationClaimsResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationCoachnetSubscriptionResponse = {
  __typename?: 'MutationCoachnetSubscriptionResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationConsignedPayoutItemsResponse = {
  __typename?: 'MutationConsignedPayoutItemsResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationConsignedPayoutsResponse = {
  __typename?: 'MutationConsignedPayoutsResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationCustomEmailsResponse = {
  __typename?: 'MutationCustomEmailsResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationDiscountCodesResponse = {
  __typename?: 'MutationDiscountCodesResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationEarnedCreditsResponse = {
  __typename?: 'MutationEarnedCreditsResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationGatewaysResponse = {
  __typename?: 'MutationGatewaysResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type MutationInfoVehiclesResponse = {
  __typename?: 'MutationInfoVehiclesResponse';
  response_status?: Maybe<ResponseStatus>;
};

export type NamePartyProvidedInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type NewClaimInput = {
  additional_information?: InputMaybe<Scalars['String']>;
  any_injuries?: InputMaybe<Scalars['Boolean']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  cause_of_incident?: InputMaybe<Scalars['String']>;
  claim_contact_email?: InputMaybe<Scalars['String']>;
  claim_party?: InputMaybe<Scalars['String']>;
  claim_phone_number?: InputMaybe<Scalars['String']>;
  damage_description?: InputMaybe<Scalars['String']>;
  damage_estimate?: InputMaybe<Scalars['String']>;
  damage_over_deductible?: InputMaybe<Scalars['String']>;
  damage_type?: InputMaybe<Scalars['String']>;
  damage_type_location?: InputMaybe<Array<InputMaybe<DamageTypeDetailInput>>>;
  date_of_loss?: InputMaybe<Scalars['String']>;
  delivery_driver_name?: InputMaybe<Scalars['String']>;
  facts_of_loss?: InputMaybe<Scalars['String']>;
  hail_damage_during_booking?: InputMaybe<Scalars['String']>;
  has_tire_blowout?: InputMaybe<Scalars['Boolean']>;
  incident_location_type?: InputMaybe<Scalars['String']>;
  injured_contacts?: InputMaybe<Array<InputMaybe<ContactInfoInput>>>;
  insured?: InputMaybe<PersonInfoInput>;
  is_awning_damage?: InputMaybe<Scalars['Boolean']>;
  is_damage_mechanical?: InputMaybe<Scalars['String']>;
  is_vehicle_abandoned?: InputMaybe<Scalars['Boolean']>;
  is_vehicle_drivable?: InputMaybe<Scalars['Boolean']>;
  name_party_provided_keys?: InputMaybe<Scalars['String']>;
  occured_during_pickup_delivery?: InputMaybe<Scalars['Boolean']>;
  party_provided_keys?: InputMaybe<NamePartyProvidedInput>;
  police_agency?: InputMaybe<Scalars['String']>;
  police_notified?: InputMaybe<Scalars['Boolean']>;
  police_report_number?: InputMaybe<Scalars['String']>;
  prior_damage?: InputMaybe<Scalars['String']>;
  processor?: InputMaybe<Scalars['String']>;
  theft_location_type?: InputMaybe<Scalars['String']>;
  third_parties?: InputMaybe<Array<InputMaybe<ContactInfoInput>>>;
  third_party_involved?: InputMaybe<Scalars['Boolean']>;
  type_of_loss?: InputMaybe<Scalars['String']>;
  where_damage_happen?: InputMaybe<Scalars['String']>;
  where_damage_happen_location?: InputMaybe<DamageLocationInput>;
  witnesses?: InputMaybe<Array<InputMaybe<ContactInfoInput>>>;
  witnesses_present?: InputMaybe<Scalars['Boolean']>;
};

export type Note = {
  __typename?: 'Note';
  body?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
};

export enum OnlyFilter {
  Meta = 'META',
  Rentals = 'RENTALS'
}

export type Owner = {
  __typename?: 'Owner';
  accept_percent?: Maybe<Scalars['Float']>;
  accepted_bookings?: Maybe<Scalars['Float']>;
  avatar_url?: Maybe<Scalars['String']>;
  average_response_time?: Maybe<Scalars['Float']>;
  bank_country?: Maybe<Scalars['String']>;
  business_description?: Maybe<Scalars['String']>;
  business_name?: Maybe<Scalars['String']>;
  business_phone?: Maybe<Scalars['String']>;
  business_website?: Maybe<Scalars['String']>;
  cancel_policy?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  dealer?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  disable_phone?: Maybe<Scalars['Boolean']>;
  experience?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Float']>;
  last_name?: Maybe<Scalars['String']>;
  locale_base_currency?: Maybe<Scalars['String']>;
  locale_language?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  mast_image_url?: Maybe<Scalars['String']>;
  owner_reviews_count?: Maybe<Scalars['Float']>;
  owner_score?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  pro?: Maybe<Scalars['Boolean']>;
  response_percent?: Maybe<Scalars['Float']>;
  reviews_count?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  search_metrics_start_date?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  social?: Maybe<Array<Maybe<OwnerSocial>>>;
  time_to_first_action?: Maybe<Scalars['Float']>;
  total_bookings?: Maybe<Scalars['Float']>;
  years_owned?: Maybe<Scalars['Float']>;
  years_rving?: Maybe<Scalars['Float']>;
};

export type OwnerInput = {
  accept_percent?: InputMaybe<Scalars['Float']>;
  accepted_bookings?: InputMaybe<Scalars['Float']>;
  avatar_url?: InputMaybe<Scalars['String']>;
  average_response_time?: InputMaybe<Scalars['Float']>;
  bank_country?: InputMaybe<Scalars['String']>;
  business_description?: InputMaybe<Scalars['String']>;
  business_name?: InputMaybe<Scalars['String']>;
  business_phone?: InputMaybe<Scalars['String']>;
  business_website?: InputMaybe<Scalars['String']>;
  cancel_policy?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  dealer?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  disable_phone?: InputMaybe<Scalars['Boolean']>;
  experience?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  guest?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Float']>;
  last_name?: InputMaybe<Scalars['String']>;
  locale_base_currency?: InputMaybe<Scalars['String']>;
  locale_language?: InputMaybe<Scalars['String']>;
  logo_url?: InputMaybe<Scalars['String']>;
  mast_image_url?: InputMaybe<Scalars['String']>;
  owner_reviews_count?: InputMaybe<Scalars['Float']>;
  owner_score?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  pro?: InputMaybe<Scalars['Boolean']>;
  response_percent?: InputMaybe<Scalars['Float']>;
  reviews_count?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  search_metrics_start_date?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  social?: InputMaybe<Array<InputMaybe<OwnerSocialInput>>>;
  time_to_first_action?: InputMaybe<Scalars['Float']>;
  total_bookings?: InputMaybe<Scalars['Float']>;
  years_owned?: InputMaybe<Scalars['Float']>;
  years_rving?: InputMaybe<Scalars['Float']>;
};

export type OwnerResponse = {
  __typename?: 'OwnerResponse';
  text?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export type OwnerSocial = {
  __typename?: 'OwnerSocial';
  count?: Maybe<Scalars['Float']>;
  link?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  site?: Maybe<Scalars['String']>;
};

export type OwnerSocialInput = {
  count?: InputMaybe<Scalars['Float']>;
  link?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Float']>;
  site?: InputMaybe<Scalars['String']>;
};

export type OwnerSummary = {
  __typename?: 'OwnerSummary';
  avatar_url?: Maybe<Scalars['String']>;
  average_response_time?: Maybe<Scalars['Int']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  created_year?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  score_count?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

export type OwnerSummaryInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  average_response_time?: InputMaybe<Scalars['Int']>;
  business_name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  score_count?: InputMaybe<Scalars['Int']>;
};

export enum OwnerType {
  Dealer = 'DEALER',
  Pro = 'PRO'
}

export type ParkSearchResult = {
  __typename?: 'ParkSearchResult';
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ParksSearch = {
  __typename?: 'ParksSearch';
  parks?: Maybe<Array<Maybe<ParkSearchResult>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Partner = {
  __typename?: 'Partner';
  active?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type PartnerApp = {
  __typename?: 'PartnerApp';
  app_id?: Maybe<Scalars['String']>;
  app_name?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  default_app?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  owner_lead_fee_percentage?: Maybe<Scalars['Int']>;
  owner_lead_only_fee_percentage?: Maybe<Scalars['Int']>;
  partner?: Maybe<Partner>;
  renter_lead_fee_percentage?: Maybe<Scalars['Int']>;
  renter_lead_only_fee_percentage?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type PartnerAppInput = {
  app_id?: InputMaybe<Scalars['String']>;
  app_name?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  default_app?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  owner_lead_fee_percentage?: InputMaybe<Scalars['Int']>;
  owner_lead_only_fee_percentage?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<PartnerInput>;
  renter_lead_fee_percentage?: InputMaybe<Scalars['Int']>;
  renter_lead_only_fee_percentage?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type PartnerInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type PassengerDetail = {
  __typename?: 'PassengerDetail';
  seatbeltWorn?: Maybe<Scalars['Boolean']>;
  whereWasPassengerSitting?: Maybe<Scalars['String']>;
};

export type PayPalAddress = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type PayPalAuthorization = {
  details: PayPalAuthorizationDetails;
  deviceData?: InputMaybe<Scalars['String']>;
  nonce: Scalars['String'];
  type: Scalars['String'];
};

export type PayPalAuthorizationDetails = {
  billingAddress?: InputMaybe<PayPalAddress>;
  countryCode?: InputMaybe<Scalars['String']>;
  creditFinancingOffered?: InputMaybe<PayPalCreditFinancingOptions>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  payerId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<PayPalAddress>;
};

export type PayPalCreditFinancingOptions = {
  cartAmountImmutable: Scalars['Boolean'];
  monthlyPayment: CurrencyAmount;
  payerAcceptance: Scalars['Boolean'];
  term: Scalars['Int'];
  totalCost: CurrencyAmount;
  totalInterest: CurrencyAmount;
};

export type PayPalFinancingPresentment = {
  __typename?: 'PayPalFinancingPresentment';
  messages?: Maybe<Array<Maybe<PayPalFinancingPresentmentMessage>>>;
};

export type PayPalFinancingPresentmentContent = {
  __typename?: 'PayPalFinancingPresentmentContent';
  default?: Maybe<PayPalFinancingPresentmentContentBody>;
  generic?: Maybe<PayPalFinancingPresentmentContentBody>;
};

export type PayPalFinancingPresentmentContentBody = {
  __typename?: 'PayPalFinancingPresentmentContentBody';
  disclaimer?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
};

export type PayPalFinancingPresentmentInput = {
  buyer_country_code?: InputMaybe<Scalars['String']>;
  currency_code?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type PayPalFinancingPresentmentMessage = {
  __typename?: 'PayPalFinancingPresentmentMessage';
  content?: Maybe<PayPalFinancingPresentmentContent>;
  meta?: Maybe<PayPalFinancingPresentmentMeta>;
};

export type PayPalFinancingPresentmentMeta = {
  __typename?: 'PayPalFinancingPresentmentMeta';
  click_url?: Maybe<Scalars['String']>;
  credit_product_group?: Maybe<Scalars['String']>;
  impression_url?: Maybe<Scalars['String']>;
  offer_country_code?: Maybe<Scalars['String']>;
  offer_type?: Maybe<Scalars['String']>;
  variables?: Maybe<PayPalMetaVariables>;
};

export type PayPalMetaVariables = {
  __typename?: 'PayPalMetaVariables';
  apr?: Maybe<Scalars['String']>;
  maximum_amount?: Maybe<PayPalMetaVariablesMaxAmount>;
  minimum_amount?: Maybe<PayPalMetaVariablesMinAmount>;
  periodic_payment?: Maybe<PayPalMetaVariablesPeriodicPayment>;
  qualifying?: Maybe<Scalars['Boolean']>;
  total_cost?: Maybe<PayPalMetaVariablesTotalCost>;
  total_interest?: Maybe<PayPalMetaVariablesTotalInterest>;
  total_payments?: Maybe<Scalars['Int']>;
};

export type PayPalMetaVariablesMaxAmount = {
  __typename?: 'PayPalMetaVariablesMaxAmount';
  currency_code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PayPalMetaVariablesMinAmount = {
  __typename?: 'PayPalMetaVariablesMinAmount';
  currency_code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PayPalMetaVariablesPeriodicPayment = {
  __typename?: 'PayPalMetaVariablesPeriodicPayment';
  currency_code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PayPalMetaVariablesTotalCost = {
  __typename?: 'PayPalMetaVariablesTotalCost';
  currency_code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PayPalMetaVariablesTotalInterest = {
  __typename?: 'PayPalMetaVariablesTotalInterest';
  currency_code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PaymentItem = {
  __typename?: 'PaymentItem';
  amount?: Maybe<Scalars['String']>;
  costCategory?: Maybe<Scalars['String']>;
  costType?: Maybe<Scalars['String']>;
  exposureId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Note>;
  paymentType?: Maybe<Scalars['String']>;
};

export type PaymentPolicy = {
  __typename?: 'PaymentPolicy';
  details?: Maybe<CancelContent>;
  name?: Maybe<Scalars['String']>;
  refundable_message?: Maybe<Scalars['String']>;
  refundable_note?: Maybe<Scalars['String']>;
};

export type PaymentProcessingInfo = {
  __typename?: 'PaymentProcessingInfo';
  address?: Maybe<Address>;
  archived?: Maybe<Scalars['Boolean']>;
  bank_last_four?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  base_currency?: Maybe<Scalars['String']>;
  can_accept_payments?: Maybe<Scalars['Boolean']>;
  can_archive_bank?: Maybe<Scalars['Boolean']>;
  can_send_payments?: Maybe<Scalars['Boolean']>;
  capabilities?: Maybe<Capabilities>;
  created?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  deposits_disabled?: Maybe<Scalars['Boolean']>;
  form?: Maybe<Scalars['JSON']>;
  fund_id?: Maybe<Scalars['String']>;
  gateway_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  managed_account_id?: Maybe<Scalars['String']>;
  missing_fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  needs_migration?: Maybe<Scalars['Boolean']>;
  nickname?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  payment_processor?: Maybe<PaymentProcessor>;
  response_status?: Maybe<ResponseStatus>;
  status?: Maybe<Scalars['String']>;
  support_phone?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type PaymentProcessingInfoInput = {
  address?: InputMaybe<AddressInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  bank_last_four?: InputMaybe<Scalars['String']>;
  bank_name?: InputMaybe<Scalars['String']>;
  base_currency?: InputMaybe<Scalars['String']>;
  can_accept_payments?: InputMaybe<Scalars['Boolean']>;
  can_archive_bank?: InputMaybe<Scalars['Boolean']>;
  can_send_payments?: InputMaybe<Scalars['Boolean']>;
  capabilities?: InputMaybe<CapabilitiesInput>;
  created?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  deposits_disabled?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Scalars['JSON']>;
  fund_id?: InputMaybe<Scalars['String']>;
  gateway_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  managed_account_id?: InputMaybe<Scalars['String']>;
  missing_fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  needs_migration?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UserInput>;
  owner_id?: InputMaybe<Scalars['Int']>;
  payment_processor?: InputMaybe<PaymentProcessorInput>;
  status?: InputMaybe<Scalars['String']>;
  support_phone?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type PaymentProcessor = {
  __typename?: 'PaymentProcessor';
  country?: Maybe<Scalars['String']>;
  external_processor_name?: Maybe<Scalars['String']>;
  external_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentProcessorInput = {
  country?: InputMaybe<Scalars['String']>;
  external_processor_name?: InputMaybe<Scalars['String']>;
  external_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PaymentProcessorWithId = {
  __typename?: 'PaymentProcessorWithId';
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentProcessorWithIdInput = {
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PaypalChargeInfo = {
  details: PayPalAuthorization;
  payer_id: Scalars['String'];
  token: Scalars['String'];
};

export type PendingRentals = {
  __typename?: 'PendingRentals';
  id: Scalars['Int'];
  insurance_state: Scalars['String'];
  name: Scalars['String'];
};

export type PendingRentalsInput = {
  id: Scalars['Int'];
  insurance_state: Scalars['String'];
  name: Scalars['String'];
};

export type PendingTransactions = {
  __typename?: 'PendingTransactions';
  amount?: Maybe<Scalars['Int']>;
  attempts?: Maybe<Scalars['Int']>;
  booking_id?: Maybe<Scalars['Int']>;
  brand?: Maybe<Scalars['String']>;
  card_id?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  due?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_four?: Maybe<Scalars['String']>;
  original_charge_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PendingTransactionsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  attempts?: InputMaybe<Scalars['Int']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  brand?: InputMaybe<Scalars['String']>;
  card_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_four?: InputMaybe<Scalars['String']>;
  original_charge_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PersonInfoInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Pickup = {
  __typename?: 'Pickup';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_etc?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PickupInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_etc?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type PlainLanguage = {
  __typename?: 'PlainLanguage';
  details?: Maybe<PlainLanguageDetails>;
  documents?: Maybe<PlainLanguageDocuments>;
  main?: Maybe<PlainLanguageMain>;
};

export type PlainLanguageDetails = {
  __typename?: 'PlainLanguageDetails';
  suggested_price?: Maybe<Scalars['String']>;
  suggested_price_total?: Maybe<Scalars['String']>;
  summary_body?: Maybe<Scalars['String']>;
  summary_tiers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PlainLanguageDocument = {
  __typename?: 'PlainLanguageDocument';
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PlainLanguageDocuments = {
  __typename?: 'PlainLanguageDocuments';
  privacy_policy?: Maybe<PlainLanguageDocument>;
  terms_conditions?: Maybe<PlainLanguageDocument>;
};

export type PlainLanguageMain = {
  __typename?: 'PlainLanguageMain';
  body?: Maybe<Scalars['String']>;
};

export type PolicyBusiness = {
  __typename?: 'PolicyBusiness';
  address?: Maybe<ClaimAddress>;
  contactMethods?: Maybe<Array<Maybe<PolicyContactMethod>>>;
  name?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  providerSubjectId?: Maybe<Scalars['String']>;
};

export type PolicyContactMethod = {
  __typename?: 'PolicyContactMethod';
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  preferredMethod?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PolicyCoverage = {
  __typename?: 'PolicyCoverage';
  coverageCode?: Maybe<Scalars['String']>;
  limits?: Maybe<Array<Maybe<PolicyLimit>>>;
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
};

export type PolicyEndorsement = {
  __typename?: 'PolicyEndorsement';
  clause?: Maybe<Scalars['String']>;
  clauseType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  effectiveAt?: Maybe<Scalars['String']>;
  endorsementNumber?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  terminationAt?: Maybe<Scalars['String']>;
};

export type PolicyLimit = {
  __typename?: 'PolicyLimit';
  amount?: Maybe<Scalars['Int']>;
  coverageLimitCode?: Maybe<Scalars['String']>;
  coverageLimitType?: Maybe<Scalars['String']>;
  deductible?: Maybe<Scalars['Int']>;
  excess?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PolicyNote = {
  __typename?: 'PolicyNote';
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type PolicyPerson = {
  __typename?: 'PolicyPerson';
  address?: Maybe<ClaimAddress>;
  contactMethods?: Maybe<Array<Maybe<PolicyContactMethod>>>;
  dateOfBirth?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  providerSubjectId?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  temporary?: Maybe<Scalars['Boolean']>;
};

export type PolicyResponse = {
  __typename?: 'PolicyResponse';
  businesses?: Maybe<Array<Maybe<PolicyBusiness>>>;
  cancelledAt?: Maybe<Scalars['String']>;
  cancelledReason?: Maybe<Scalars['String']>;
  coverages?: Maybe<Array<Maybe<PolicyCoverage>>>;
  effectiveAt?: Maybe<Scalars['String']>;
  endorsements?: Maybe<Array<Maybe<PolicyEndorsement>>>;
  expirationAt?: Maybe<Scalars['String']>;
  inceptionAt?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<PolicyNote>>>;
  people?: Maybe<Array<Maybe<PolicyPerson>>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyType?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  response_status?: Maybe<ResponseStatus>;
  risks?: Maybe<Array<Maybe<PolicyRisk>>>;
  status?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PolicyRisk = {
  __typename?: 'PolicyRisk';
  address?: Maybe<ClaimAddress>;
  code?: Maybe<Scalars['String']>;
  codeDescription?: Maybe<Scalars['String']>;
  coverages?: Maybe<Array<Maybe<PolicyCoverage>>>;
  drivers?: Maybe<Array<Maybe<RiskDriver>>>;
  endorsements?: Maybe<Array<Maybe<PolicyEndorsement>>>;
  externalLocationIdentifier?: Maybe<Scalars['String']>;
  externalRiskIdentifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vehicle?: Maybe<RiskVehicle>;
  vehicleLocations?: Maybe<Array<Maybe<RiskVehicleLocation>>>;
};

export type PolicyV1 = {
  __typename?: 'PolicyV1';
  canceled_after?: Maybe<CancelContent>;
  canceled_more_than?: Maybe<CancelContent>;
  canceled_on_or_before?: Maybe<CancelContent>;
  canceled_within?: Maybe<CancelContent>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  details?: Maybe<PolicyV1Details>;
  free_cancel_message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PolicyV1Details = {
  __typename?: 'PolicyV1Details';
  link: Scalars['String'];
  title: Scalars['String'];
};

export type PremiumServicesResponse = {
  __typename?: 'PremiumServicesResponse';
  response_status?: Maybe<ResponseStatus>;
  services?: Maybe<Array<ServiceIntegration>>;
};

export type Price = {
  __typename?: 'Price';
  day?: Maybe<Scalars['Int']>;
  minimum_security_deposit?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  security_deposit?: Maybe<Scalars['Int']>;
  week?: Maybe<Scalars['Int']>;
};

export type PriceInput = {
  day?: InputMaybe<Scalars['Int']>;
  minimum_security_deposit?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  security_deposit?: InputMaybe<Scalars['Int']>;
  week?: InputMaybe<Scalars['Int']>;
};

export type ProStatus = {
  __typename?: 'ProStatus';
  approval_rate: Scalars['Float'];
  bank_account: Scalars['Boolean'];
  completed_points: Scalars['Int'];
  description: Scalars['Boolean'];
  eligible_insurance: Scalars['Boolean'];
  pending_rentals?: Maybe<Array<PendingRentals>>;
  pro: Scalars['Boolean'];
  profile_percent_complete: Scalars['Int'];
  rating: Scalars['Float'];
  response_time: Scalars['Int'];
  response_time_rank: Scalars['Int'];
  total_points: Scalars['Int'];
  verified_phone: Scalars['Boolean'];
};

export type ProStatusInput = {
  approval_rate: Scalars['Float'];
  bank_account: Scalars['Boolean'];
  completed_points: Scalars['Int'];
  description: Scalars['Boolean'];
  eligible_insurance: Scalars['Boolean'];
  pending_rentals?: InputMaybe<Array<PendingRentalsInput>>;
  pro: Scalars['Boolean'];
  profile_percent_complete: Scalars['Int'];
  rating: Scalars['Float'];
  response_time: Scalars['Int'];
  response_time_rank: Scalars['Int'];
  total_points: Scalars['Int'];
  verified_phone: Scalars['Boolean'];
};

export type Product = {
  __typename?: 'Product';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  address?: Maybe<Address>;
  affiliate_description: Scalars['String'];
  anonymized_by: Scalars['Int'];
  anonymized_on: Scalars['String'];
  avatar_url: Scalars['String'];
  bio?: Maybe<Bio>;
  birthdate?: Maybe<Scalars['String']>;
  booking_options?: Maybe<BookingOptions>;
  booking_restrictions?: Maybe<BookingRestrictions>;
  business: Business;
  coaching_completed?: Maybe<Scalars['Boolean']>;
  coaching_completed_on_date?: Maybe<Scalars['String']>;
  coaching_dismissed_count?: Maybe<Scalars['Int']>;
  dealer_locations?: Maybe<Array<Maybe<Location>>>;
  disable_phone?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  employee_locations?: Maybe<Array<Maybe<Location>>>;
  exclude_locations?: Maybe<Array<Scalars['String']>>;
  extra: Extra;
  first_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  google_place_id: Scalars['String'];
  last_name: Scalars['String'];
  listing_coach_dismiss_flag?: Maybe<Scalars['Boolean']>;
  locale: UserLocale;
  logo_url: Scalars['String'];
  mast_image_url: Scalars['String'];
  nationality: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  sms_exclude_locations?: Maybe<Array<Scalars['Int']>>;
  social: Array<Social>;
  title: Scalars['String'];
  user_type: Scalars['String'];
};

export type ProfileInput = {
  address?: InputMaybe<AddressInput>;
  affiliate_description: Scalars['String'];
  anonymized_by: Scalars['Int'];
  anonymized_on: Scalars['String'];
  avatar_url: Scalars['String'];
  bio?: InputMaybe<BioInput>;
  birthdate?: InputMaybe<Scalars['String']>;
  booking_options?: InputMaybe<BookingOptionsInput>;
  booking_restrictions?: InputMaybe<BookingRestrictionsInput>;
  business: BusinessInput;
  coaching_completed?: InputMaybe<Scalars['Boolean']>;
  coaching_completed_on_date?: InputMaybe<Scalars['String']>;
  coaching_dismissed_count?: InputMaybe<Scalars['Int']>;
  dealer_locations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  disable_phone?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  employee_locations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  exclude_locations?: InputMaybe<Array<Scalars['String']>>;
  extra: ExtraInput;
  first_name: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  google_place_id: Scalars['String'];
  last_name: Scalars['String'];
  listing_coach_dismiss_flag?: InputMaybe<Scalars['Boolean']>;
  locale: UserLocaleInput;
  logo_url: Scalars['String'];
  mast_image_url: Scalars['String'];
  nationality: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  sms_exclude_locations?: InputMaybe<Array<Scalars['Int']>>;
  social: Array<SocialInput>;
  title: Scalars['String'];
  user_type: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activity?: Maybe<Activity>;
  adminGetUserCards?: Maybe<CardsResponse>;
  adminReadManyDiscountCodes?: Maybe<DiscountCodesResponse>;
  allBookings?: Maybe<BookingsResult>;
  availableBids?: Maybe<BidsResponse>;
  booking?: Maybe<Booking>;
  bookingFiles?: Maybe<SignData>;
  convertCurrency?: Maybe<ConvertCurrencyResponse>;
  file?: Maybe<File>;
  files?: Maybe<Array<Maybe<File>>>;
  financeAPIHealthCheck: HealthCheck;
  getAccount?: Maybe<Account>;
  getActivities?: Maybe<ActivitiesResult>;
  getActivitiesAsAdmin?: Maybe<ActivitiesResult>;
  getAlgoliaKey?: Maybe<AlgoliaKey>;
  getAmenities?: Maybe<AmenitiesResult>;
  getAvailability?: Maybe<AvailabilityResponse>;
  getBasePrice?: Maybe<BasePrice>;
  getBidById?: Maybe<Bid>;
  getBids?: Maybe<BidsResponse>;
  getBookingItem?: Maybe<BookingItem>;
  getBookingServices: PremiumServicesResponse;
  getBundleById?: Maybe<Bundle>;
  getBundleFeature?: Maybe<BundleFeature>;
  getBundleRule?: Maybe<BundleRule>;
  getCancellationPolicy?: Maybe<CancellationPolicy>;
  getCheckoutSteps?: Maybe<CheckoutSteps>;
  getClaimByClaimId?: Maybe<Claim>;
  getCoachnetSubscriptionById?: Maybe<CoachnetSubscription>;
  getCoachnetSubscriptionPayments?: Maybe<ChargesResponse>;
  getCommLogByServiceId?: Maybe<CommLog>;
  getConsignedPayoutById?: Maybe<ConsignedPayout>;
  getConsignedPayoutItemById?: Maybe<ConsignedPayoutItem>;
  getConversation?: Maybe<Conversation>;
  getConversations?: Maybe<ConversationsResponse>;
  getCountries?: Maybe<CountriesResponse>;
  getCreditStatsForUser?: Maybe<CreditStats>;
  getCustomEmailById?: Maybe<CustomEmail>;
  getDiscountCodeById?: Maybe<DiscountCode>;
  getEarnedCreditById?: Maybe<EarnedCredit>;
  getEventFeed?: Maybe<EventDataItemResult>;
  getFavorites?: Maybe<FavoritesResponse>;
  getFundCreationForm?: Maybe<Bui>;
  getGatewaysListOptions?: Maybe<Bui>;
  getHandoffByBookingId?: Maybe<HandoffResponse>;
  getInfoVehicleById?: Maybe<VehicleInfo>;
  getLocationById?: Maybe<Location>;
  getLocations?: Maybe<LocationsResponse>;
  getQuoteById?: Maybe<Quote>;
  getQuoteServices: PremiumServicesResponse;
  getRegions?: Maybe<RegionsResponse>;
  getRentalById?: Maybe<RentalSearch>;
  getRentalClaims?: Maybe<RentalClaimsResponse>;
  getRentalInsuranceBundles?: Maybe<RentalBundlesResponse>;
  getRentalItemById?: Maybe<RentalItem>;
  getRentalServices: PremiumServicesResponse;
  getReviews?: Maybe<ReviewsSearch>;
  getSnapsheetPolicy?: Maybe<PolicyResponse>;
  getSoonestTripId?: Maybe<SoonestTripId>;
  getUserBundles?: Maybe<BundlesResponse>;
  getUserById?: Maybe<UserSearch>;
  getUserBySlug?: Maybe<UserSearch>;
  getUserCards?: Maybe<CardsResponse>;
  getUserRole?: Maybe<AccountRole>;
  getVehicleData?: Maybe<VehicleInfoDetailsResponse>;
  getVehicleMakes?: Maybe<VehicleInfoDetailsResponse>;
  getVehicleModels?: Maybe<VehicleInfoDetailsResponse>;
  getVehicleTrims?: Maybe<VehicleInfoDetailsResponse>;
  me?: Maybe<User>;
  messageById?: Maybe<Message>;
  messages?: Maybe<Array<Maybe<Message>>>;
  payPalFinancingPresentment?: Maybe<PayPalFinancingPresentment>;
  payPalFinancingPresentmentJSON?: Maybe<Scalars['JSON']>;
  ping: Scalars['String'];
  readFundIDForCardID?: Maybe<ReadFundIdForCardIdResponse>;
  readManyBundles?: Maybe<BundlesResponse>;
  readManyCards?: Maybe<CardsResponse>;
  readManyClaims?: Maybe<RentalClaimsResponse>;
  readManyCoachnetSubscription?: Maybe<CoachnetSubscriptionsResponse>;
  readManyCommLogs?: Maybe<CommLogsResponse>;
  readManyConsignedPayoutItems?: Maybe<ConsignedPayoutItemsResponse>;
  readManyConsignedPayouts?: Maybe<ConsignedPayoutsResponse>;
  readManyCustomEmails?: Maybe<CustomEmailsResponse>;
  readManyDiscountCodes?: Maybe<DiscountCodesResponse>;
  readManyEarnedCredits?: Maybe<EarnedCreditsResponse>;
  readManyInfoVehicles?: Maybe<VehiclesResponse>;
  readManyRentalItems?: Maybe<RentalItemsResponse>;
  readManyUserGateways?: Maybe<ReadManyGatewaysResponse>;
  retrieveFromSnapsheet?: Maybe<GetClaimResponse>;
  retrieveManyFromSnapsheet?: Maybe<ReadManyClaimResponse>;
  review?: Maybe<Review>;
  searchParks?: Maybe<ParksSearch>;
  searchPopularParks?: Maybe<ParksSearch>;
  searchRentals?: Maybe<RentalsSearch>;
  searchSimilarToRental?: Maybe<RentalsSearch>;
  user?: Maybe<User>;
};


export type QueryActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminGetUserCardsArgs = {
  country?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  processor?: InputMaybe<Scalars['String']>;
  user_id: Scalars['Int'];
};


export type QueryAdminReadManyDiscountCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount_gte?: InputMaybe<Scalars['Float']>;
  amount_lte?: InputMaybe<Scalars['Float']>;
  amount_type?: InputMaybe<Scalars['String']>;
  apply_to_field?: InputMaybe<Scalars['String']>;
  apply_type?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  automatically_apply?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_applied?: InputMaybe<Scalars['String']>;
  from_gte?: InputMaybe<Scalars['String']>;
  from_lte?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  length_of_stay?: InputMaybe<Scalars['Int']>;
  length_of_stay_gte?: InputMaybe<Scalars['Int']>;
  length_of_stay_lte?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  to_gte?: InputMaybe<Scalars['String']>;
  to_lte?: InputMaybe<Scalars['String']>;
};


export type QueryAllBookingsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  renter_id?: InputMaybe<Scalars['Int']>;
};


export type QueryAvailableBidsArgs = {
  bid_match_owner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  locations_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  open?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
};


export type QueryBookingArgs = {
  id: Scalars['Int'];
};


export type QueryBookingFilesArgs = {
  booking_id: Scalars['Int'];
  file_id: Scalars['Int'];
};


export type QueryConvertCurrencyArgs = {
  amount: Scalars['Int'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type QueryFileArgs = {
  id?: InputMaybe<Scalars['Int']>;
  json?: InputMaybe<Scalars['Boolean']>;
  update_url?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFilesArgs = {
  account_only?: InputMaybe<Scalars['Boolean']>;
  auto_include?: InputMaybe<Scalars['Boolean']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  include_esign?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAccountArgs = {
  account_id: Scalars['String'];
};


export type QueryGetActivitiesArgs = {
  actor_id?: InputMaybe<Scalars['Int']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  conversation_id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  is_admin_request?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  read?: InputMaybe<Scalars['Boolean']>;
  receiver_id?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  renter_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivitiesAsAdminArgs = {
  actor_id?: InputMaybe<Scalars['Int']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  conversation_id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  is_admin_request?: InputMaybe<Scalars['Boolean']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  read?: InputMaybe<Scalars['Boolean']>;
  receiver_id?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  renter_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAvailabilityArgs = {
  booking_id?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  include_children?: InputMaybe<Scalars['Boolean']>;
  override_protections?: InputMaybe<Scalars['Boolean']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  rental_id: Scalars['Int'];
  to: Scalars['String'];
};


export type QueryGetBasePriceArgs = {
  rentalId: Scalars['Int'];
};


export type QueryGetBidByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetBidsArgs = {
  bid_match_owner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  locations_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  open?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBookingItemArgs = {
  booking_id: Scalars['Int'];
  item_id: Scalars['Int'];
};


export type QueryGetBookingServicesArgs = {
  booking_id: Scalars['Int'];
};


export type QueryGetBundleByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetBundleFeatureArgs = {
  bundle_id: Scalars['String'];
  id: Scalars['String'];
};


export type QueryGetBundleRuleArgs = {
  bundle_id: Scalars['String'];
  id: Scalars['String'];
};


export type QueryGetCancellationPolicyArgs = {
  input?: InputMaybe<CancellationPolicyInput>;
};


export type QueryGetCheckoutStepsArgs = {
  booking_id: Scalars['Int'];
};


export type QueryGetClaimByClaimIdArgs = {
  claim_id: Scalars['String'];
};


export type QueryGetCoachnetSubscriptionByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetCoachnetSubscriptionPaymentsArgs = {
  id: Scalars['Int'];
};


export type QueryGetCommLogByServiceIdArgs = {
  service_id: Scalars['String'];
};


export type QueryGetConsignedPayoutByIdArgs = {
  consigned_payout_id: Scalars['Int'];
};


export type QueryGetConsignedPayoutItemByIdArgs = {
  consigned_payout_id: Scalars['Int'];
  consigned_payout_item_id: Scalars['Int'];
};


export type QueryGetConversationArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetConversationsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  booking_status?: InputMaybe<Scalars['String']>;
  has_messages?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  location_ids?: InputMaybe<Scalars['String']>;
  new?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  renter_id?: InputMaybe<Scalars['Int']>;
  single?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCustomEmailByIdArgs = {
  custom_email_id: Scalars['Int'];
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetDiscountCodeByIdArgs = {
  discount_code_id: Scalars['Int'];
};


export type QueryGetEarnedCreditByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetEventFeedArgs = {
  booking_id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFundCreationFormArgs = {
  auth_mode?: InputMaybe<Scalars['String']>;
  gateway_id?: InputMaybe<Scalars['Int']>;
  gateway_type?: InputMaybe<Scalars['String']>;
};


export type QueryGetGatewaysListOptionsArgs = {
  country_code?: InputMaybe<Scalars['String']>;
};


export type QueryGetHandoffByBookingIdArgs = {
  booking_id: Scalars['Int'];
};


export type QueryGetInfoVehicleByIdArgs = {
  vehicle_id: Scalars['Int'];
};


export type QueryGetLocationByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetLocationsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  owner_ids?: InputMaybe<Scalars['String']>;
};


export type QueryGetQuoteByIdArgs = {
  quote_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetQuoteServicesArgs = {
  quote_id: Scalars['String'];
};


export type QueryGetRegionsArgs = {
  countryCode: Scalars['String'];
};


export type QueryGetRentalByIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
  presentment_currency?: InputMaybe<Currency>;
  rentalId: Scalars['Int'];
};


export type QueryGetRentalClaimsArgs = {
  rental_id: Scalars['Int'];
};


export type QueryGetRentalInsuranceBundlesArgs = {
  delivery?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['String']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['Int'];
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetRentalItemByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetRentalServicesArgs = {
  rental_id: Scalars['Int'];
};


export type QueryGetReviewsArgs = {
  booking_id?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  excluded_from_rating?: InputMaybe<Scalars['Boolean']>;
  images?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  owner_slug?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  rental_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  renter_id?: InputMaybe<Scalars['Int']>;
  reviewer_id?: InputMaybe<Scalars['Int']>;
  score_gte?: InputMaybe<Scalars['Float']>;
  score_lte?: InputMaybe<Scalars['Float']>;
  scores?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ReviewSortOrder>;
  timestamp_gte?: InputMaybe<Scalars['String']>;
  timestamp_lte?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSnapsheetPolicyArgs = {
  datetimeOfLoss?: InputMaybe<Scalars['String']>;
  policyNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserBundlesArgs = {
  user_id: Scalars['Int'];
};


export type QueryGetUserByIdArgs = {
  userId: Scalars['Int'];
};


export type QueryGetUserBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetUserCardsArgs = {
  country?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  processor?: InputMaybe<Scalars['String']>;
  user_id: Scalars['Int'];
};


export type QueryGetUserRoleArgs = {
  account_id: Scalars['String'];
  user_id: Scalars['Int'];
};


export type QueryGetVehicleDataArgs = {
  Q?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  multi_source?: InputMaybe<Scalars['Boolean']>;
  trim?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryGetVehicleMakesArgs = {
  Q?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  multi_source?: InputMaybe<Scalars['Boolean']>;
  trim?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryGetVehicleModelsArgs = {
  Q?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  multi_source?: InputMaybe<Scalars['Boolean']>;
  trim?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryGetVehicleTrimsArgs = {
  Q?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  multi_source?: InputMaybe<Scalars['Boolean']>;
  trim?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryMessageByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryMessagesArgs = {
  conversationID?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  receiverID?: InputMaybe<Scalars['Int']>;
  senderID?: InputMaybe<Scalars['Int']>;
  sentiments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to?: InputMaybe<Scalars['String']>;
  userID?: InputMaybe<Scalars['Int']>;
};


export type QueryPayPalFinancingPresentmentArgs = {
  input?: InputMaybe<PayPalFinancingPresentmentInput>;
};


export type QueryPayPalFinancingPresentmentJsonArgs = {
  input?: InputMaybe<PayPalFinancingPresentmentInput>;
};


export type QueryReadFundIdForCardIdArgs = {
  card_id: Scalars['Int'];
};


export type QueryReadManyBundlesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryReadManyClaimsArgs = {
  booking_id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  processor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryReadManyCoachnetSubscriptionArgs = {
  coachnet_id?: InputMaybe<Scalars['Int']>;
  coachnet_subscription_id?: InputMaybe<Scalars['Int']>;
  expiration_date_gt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  next_payment_date_gt?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryReadManyCommLogsArgs = {
  conversation_id?: InputMaybe<Scalars['Int']>;
  receiver_id?: InputMaybe<Scalars['Int']>;
  sender_id: Scalars['Int'];
  service_type?: InputMaybe<Scalars['String']>;
};


export type QueryReadManyConsignedPayoutItemsArgs = {
  consigned_payout_id?: InputMaybe<Scalars['Int']>;
  consigned_payout_item_id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
};


export type QueryReadManyConsignedPayoutsArgs = {
  consigned_owner_id?: InputMaybe<Scalars['Int']>;
  consigned_payout_id?: InputMaybe<Scalars['Int']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
};


export type QueryReadManyCustomEmailsArgs = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  event?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryReadManyDiscountCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount_gte?: InputMaybe<Scalars['Float']>;
  amount_lte?: InputMaybe<Scalars['Float']>;
  amount_type?: InputMaybe<Scalars['String']>;
  apply_to_field?: InputMaybe<Scalars['String']>;
  apply_type?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  automatically_apply?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_applied?: InputMaybe<Scalars['String']>;
  from_gte?: InputMaybe<Scalars['String']>;
  from_lte?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  length_of_stay?: InputMaybe<Scalars['Int']>;
  length_of_stay_gte?: InputMaybe<Scalars['Int']>;
  length_of_stay_lte?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  to_gte?: InputMaybe<Scalars['String']>;
  to_lte?: InputMaybe<Scalars['String']>;
};


export type QueryReadManyEarnedCreditsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  user_id: Scalars['Int'];
};


export type QueryReadManyInfoVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  popular?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryReadManyRentalItemsArgs = {
  available_for_rental_id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryReadManyUserGatewaysArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  fund_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
  managed_accounts_only?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
};


export type QueryRetrieveFromSnapsheetArgs = {
  booking_id: Scalars['Int'];
};


export type QueryRetrieveManyFromSnapsheetArgs = {
  claim_party_id?: InputMaybe<Scalars['String']>;
  page_number?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  policy_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_since?: InputMaybe<Scalars['String']>;
};


export type QueryReviewArgs = {
  id: Scalars['Int'];
};


export type QuerySearchParksArgs = {
  domain?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QuerySearchPopularParksArgs = {
  domain?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRentalsArgs = {
  address?: InputMaybe<Scalars['String']>;
  auto_radius?: InputMaybe<Scalars['Boolean']>;
  bound_e_lng?: InputMaybe<Scalars['Float']>;
  bound_n_lat?: InputMaybe<Scalars['Float']>;
  bound_s_lat?: InputMaybe<Scalars['Float']>;
  bound_w_lng?: InputMaybe<Scalars['Float']>;
  cancel_policy?: InputMaybe<CancelPolicy>;
  currency?: InputMaybe<Scalars['String']>;
  date_from?: InputMaybe<Scalars['String']>;
  date_to?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  delivery_address?: InputMaybe<Scalars['String']>;
  delivery_radius?: InputMaybe<Scalars['Float']>;
  distance_unit?: InputMaybe<Scalars['String']>;
  exclude_rental_ids?: InputMaybe<Array<Scalars['Int']>>;
  exclude_rental_types?: InputMaybe<Array<RentalType>>;
  experiment?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<Scalars['String']>>;
  flexible_days?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  include_rental_ids?: InputMaybe<Array<Scalars['Int']>>;
  include_unavailable?: InputMaybe<Scalars['Boolean']>;
  instant_book?: InputMaybe<Scalars['Boolean']>;
  insurance_state?: InputMaybe<InsuranceState>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  last_published_gte?: InputMaybe<Scalars['String']>;
  last_published_lte?: InputMaybe<Scalars['String']>;
  length_between?: InputMaybe<Scalars['String']>;
  length_gte?: InputMaybe<Scalars['Int']>;
  length_lte?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  location_ids?: InputMaybe<Array<Scalars['Int']>>;
  near_lat?: InputMaybe<Scalars['Float']>;
  near_lng?: InputMaybe<Scalars['Float']>;
  near_rental_id?: InputMaybe<Scalars['Int']>;
  new_owners?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  only?: InputMaybe<OnlyFilter>;
  owner_type?: InputMaybe<OwnerType>;
  price_max?: InputMaybe<Scalars['Int']>;
  price_min?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  rental_styles?: InputMaybe<Array<RentalStyle>>;
  rental_types?: InputMaybe<Array<RentalType>>;
  requires_driver_verification?: InputMaybe<Scalars['Boolean']>;
  score_gt?: InputMaybe<Scalars['Float']>;
  sleeps?: InputMaybe<Scalars['Int']>;
  sleeps_adults?: InputMaybe<Scalars['Int']>;
  sleeps_kids?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortCriteria>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  trailer_weight_gte?: InputMaybe<Scalars['Int']>;
  trailer_weight_lte?: InputMaybe<Scalars['Int']>;
  unlimited_generator_hours?: InputMaybe<Scalars['Boolean']>;
  unlimited_miles?: InputMaybe<Scalars['Boolean']>;
  vehicle_make?: InputMaybe<Scalars['String']>;
  vehicle_model?: InputMaybe<Scalars['String']>;
  weight_unit?: InputMaybe<WeightUnit>;
  year_gte?: InputMaybe<Scalars['Int']>;
  year_lte?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSimilarToRentalArgs = {
  presentment_currency?: InputMaybe<Currency>;
  rentalId: Scalars['Int'];
};


export type QueryUserArgs = {
  user_id: Scalars['Int'];
};

export type Quote = {
  __typename?: 'Quote';
  addons?: Maybe<Array<BookingItem>>;
  bundle_id?: Maybe<Scalars['String']>;
  calculated_day_price?: Maybe<Scalars['Int']>;
  dealer_minimum_days?: Maybe<Scalars['Int']>;
  delivery?: Maybe<QuoteDelivery>;
  delivery_item?: Maybe<BookingItem>;
  discount_code?: Maybe<Scalars['String']>;
  discount_code_amount?: Maybe<Scalars['Int']>;
  discount_code_applied_to?: Maybe<Scalars['String']>;
  discount_code_message?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  estimated_generator_cost?: Maybe<Scalars['Int']>;
  estimated_mileage_cost?: Maybe<Scalars['Int']>;
  fees_total?: Maybe<Scalars['Int']>;
  final_payment_amount?: Maybe<Scalars['Int']>;
  final_payment_due_date?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  from_time?: Maybe<Scalars['Int']>;
  generator_item?: Maybe<BookingItem>;
  id?: Maybe<Scalars['String']>;
  insurance_bundle?: Maybe<BookingBundle>;
  is_request_less_than_minimum_days?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<BookingItem>>;
  locale_base_currency?: Maybe<Scalars['String']>;
  mileage_item?: Maybe<BookingItem>;
  offer_affirm?: Maybe<Scalars['Boolean']>;
  original_day_price?: Maybe<Scalars['Int']>;
  original_month_price?: Maybe<Scalars['Int']>;
  original_service_fee?: Maybe<Scalars['Int']>;
  original_week_price?: Maybe<Scalars['Int']>;
  outdoorsy_fee?: Maybe<Scalars['Int']>;
  owner_fee?: Maybe<Scalars['Int']>;
  owner_fees?: Maybe<Array<BookingItem>>;
  owner_integrations_fee?: Maybe<Scalars['Int']>;
  presentment_currency?: Maybe<Scalars['String']>;
  remainder_amount?: Maybe<Scalars['Int']>;
  remainder_due_date?: Maybe<Scalars['String']>;
  rental_amount?: Maybe<Scalars['Int']>;
  rental_amount_item?: Maybe<BookingItem>;
  rental_summary?: Maybe<RentalSummary>;
  renter_credits_applied?: Maybe<Scalars['Int']>;
  renter_reserve_amount?: Maybe<Scalars['Int']>;
  requested_duration?: Maybe<Scalars['Int']>;
  reserve_amount?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  security_deposit?: Maybe<Scalars['Int']>;
  service_fee?: Maybe<Scalars['Int']>;
  services?: Maybe<Array<Service>>;
  settlement_currency?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  tax_rates?: Maybe<Array<TaxRateTotalItem>>;
  to?: Maybe<Scalars['String']>;
  to_time?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  total_after_credits?: Maybe<Scalars['Int']>;
  use_day_price?: Maybe<Scalars['Boolean']>;
  use_day_pricing?: Maybe<Scalars['Boolean']>;
  use_system_tax_rates?: Maybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: Maybe<Scalars['Boolean']>;
  waiver_summary?: Maybe<WaiverSummary>;
  warning?: Maybe<QuoteWarning>;
};

export type QuoteDelivery = {
  __typename?: 'QuoteDelivery';
  comment?: Maybe<Scalars['String']>;
  estimated_distance?: Maybe<Scalars['Float']>;
  location?: Maybe<QuoteDeliveryLocation>;
  stationary?: Maybe<Scalars['Boolean']>;
};

export type QuoteDeliveryInput = {
  comment?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<QuoteDeliveryLocationInput>;
  stationary?: InputMaybe<Scalars['Boolean']>;
};

export type QuoteDeliveryLocation = {
  __typename?: 'QuoteDeliveryLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_etc?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type QuoteDeliveryLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_etc?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type QuoteRequestInput = {
  bundle_id?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<QuoteDeliveryInput>;
  discount_code?: InputMaybe<Scalars['String']>;
  estimated_generator_hours?: InputMaybe<Scalars['Float']>;
  estimated_miles?: InputMaybe<Scalars['Float']>;
  from?: InputMaybe<Scalars['String']>;
  from_time?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imported?: InputMaybe<Scalars['Boolean']>;
  include_coachnet?: InputMaybe<Scalars['Boolean']>;
  insurance?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ItemRequest>>;
  locale?: InputMaybe<Scalars['String']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  renter_id?: InputMaybe<Scalars['Int']>;
  reserve?: InputMaybe<Scalars['Boolean']>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  source?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  to_time?: InputMaybe<Scalars['Int']>;
};

export type QuoteWarning = {
  __typename?: 'QuoteWarning';
  message?: Maybe<Scalars['String']>;
};

export type ReadFundIdForCardIdResponse = {
  __typename?: 'ReadFundIDForCardIDResponse';
  payment_fund_id?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
};

export type ReadManyClaimResponse = {
  __typename?: 'ReadManyClaimResponse';
  claims?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageNumber?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  totalNumberOfResults?: Maybe<Scalars['Int']>;
};

export type ReadManyGatewaysResponse = {
  __typename?: 'ReadManyGatewaysResponse';
  gateways?: Maybe<Array<Maybe<PaymentProcessingInfo>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Region = {
  __typename?: 'Region';
  code: Scalars['String'];
  countryalpha2: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  maxlatitude: Scalars['Float'];
  maxlongitude: Scalars['Float'];
  minlatitude: Scalars['Float'];
  minlongitude: Scalars['Float'];
  name: Scalars['String'];
  names: Array<Maybe<Scalars['String']>>;
};

export type RegionsResponse = {
  __typename?: 'RegionsResponse';
  regions?: Maybe<Array<Region>>;
  response_status?: Maybe<ResponseStatus>;
};

export type Rental = {
  __typename?: 'Rental';
  active_options?: Maybe<ActiveOptions>;
  active_price?: Maybe<ActivePrice>;
  allow_insurance_for_external_lead?: Maybe<Scalars['String']>;
  available_insurance_products?: Maybe<Array<Maybe<Scalars['String']>>>;
  cancel_policy?: Maybe<Scalars['String']>;
  children_count?: Maybe<Scalars['Int']>;
  coachnet_ready?: Maybe<Scalars['Boolean']>;
  custom_insurance_text?: Maybe<Scalars['String']>;
  default_insurance_bundle_tier?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  delivery_usage_item?: Maybe<UsageBasedItem>;
  delivery_usage_item_id?: Maybe<Scalars['Int']>;
  deposit_percentage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_vehicle_type?: Maybe<Scalars['String']>;
  external?: Maybe<Scalars['Boolean']>;
  favorite?: Maybe<Scalars['Boolean']>;
  favorite_count?: Maybe<Scalars['Int']>;
  features?: Maybe<Features>;
  generator_usage_item?: Maybe<UsageBasedItem>;
  generator_usage_item_id?: Maybe<Scalars['Int']>;
  group_reviews_sum?: Maybe<Scalars['Int']>;
  group_score?: Maybe<Scalars['Int']>;
  group_score_count?: Maybe<Scalars['Int']>;
  home?: Maybe<RentalLocation>;
  id?: Maybe<Scalars['Int']>;
  images?: Maybe<Array<Maybe<Images>>>;
  inactive?: Maybe<Scalars['Boolean']>;
  instant_book?: Maybe<Scalars['Boolean']>;
  instant_book_leeway?: Maybe<Scalars['Int']>;
  insurance_asset_id?: Maybe<Scalars['String']>;
  insurance_coverage?: Maybe<Scalars['String']>;
  insurance_eligible?: Maybe<Scalars['Boolean']>;
  insurance_plan_id?: Maybe<InsurancePlanId>;
  insurance_state?: Maybe<Scalars['String']>;
  latest_review?: Maybe<LatestReview>;
  locale?: Maybe<RentalLocale>;
  mileage_usage_item?: Maybe<UsageBasedItem>;
  mileage_usage_item_id?: Maybe<Scalars['Int']>;
  minimum_days?: Maybe<Scalars['Int']>;
  minimum_deposit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer_delivery?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<User>;
  owner_id?: Maybe<Scalars['Int']>;
  owner_summary?: Maybe<OwnerSummary>;
  parent_id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  presentment_currency?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  primary_image_id?: Maybe<Scalars['Int']>;
  primary_image_url?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  require_insurance?: Maybe<Scalars['String']>;
  require_roadside?: Maybe<Scalars['Boolean']>;
  require_vin?: Maybe<Scalars['Boolean']>;
  response_status?: Maybe<ResponseStatus>;
  review_notes?: Maybe<Scalars['String']>;
  review_status?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  score_count?: Maybe<Scalars['Int']>;
  session_id?: Maybe<Scalars['String']>;
  settlement_currency?: Maybe<Scalars['String']>;
  sleeps?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  tax_rate_id?: Maybe<Scalars['Int']>;
  tax_rate_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  turnaround_days_after?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicle>;
  waived_insurance_text?: Maybe<Scalars['String']>;
};

export type RentalBundles = {
  __typename?: 'RentalBundles';
  bundle_features?: Maybe<Array<Maybe<RentalBundlesFeatures>>>;
  dealer_owned_renter?: Maybe<Scalars['Boolean']>;
  deductible?: Maybe<Scalars['Int']>;
  default_selection?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insurance_protection?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  price_per_day?: Maybe<Scalars['Int']>;
  property_damage?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['String']>;
  supported_types?: Maybe<Array<Maybe<Scalars['String']>>>;
  tier?: Maybe<Scalars['Int']>;
  total_price?: Maybe<Scalars['Int']>;
};

export type RentalBundlesFeatures = {
  __typename?: 'RentalBundlesFeatures';
  category?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<RentalBundlesFeaturesItems>>>;
};

export type RentalBundlesFeaturesItems = {
  __typename?: 'RentalBundlesFeaturesItems';
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type RentalBundlesResponse = {
  __typename?: 'RentalBundlesResponse';
  rentalBundles?: Maybe<Array<Maybe<RentalBundles>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type RentalClaimsResponse = {
  __typename?: 'RentalClaimsResponse';
  claims?: Maybe<Array<Maybe<Claim>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type RentalInput = {
  active_options?: InputMaybe<AttributesActiveOptionsInput>;
  active_price?: InputMaybe<ActivePriceInput>;
  allow_insurance_for_external_lead?: InputMaybe<Scalars['String']>;
  available_insurance_products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cancel_policy?: InputMaybe<Scalars['String']>;
  children_count?: InputMaybe<Scalars['Int']>;
  coachnet_ready?: InputMaybe<Scalars['Boolean']>;
  custom_insurance_text?: InputMaybe<Scalars['String']>;
  default_insurance_bundle_tier?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  delivery_usage_item?: InputMaybe<UsageBasedItemInput>;
  delivery_usage_item_id?: InputMaybe<Scalars['Int']>;
  deposit_percentage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_vehicle_type?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  favorite_count?: InputMaybe<Scalars['Int']>;
  features?: InputMaybe<FeaturesInput>;
  generator_usage_item?: InputMaybe<UsageBasedItemInput>;
  generator_usage_item_id?: InputMaybe<Scalars['Int']>;
  group_reviews_sum?: InputMaybe<Scalars['Int']>;
  group_score?: InputMaybe<Scalars['Int']>;
  group_score_count?: InputMaybe<Scalars['Int']>;
  home?: InputMaybe<RentalLocationInput>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<ImagesInput>>>;
  inactive?: InputMaybe<Scalars['Boolean']>;
  instant_book?: InputMaybe<Scalars['Boolean']>;
  instant_book_leeway?: InputMaybe<Scalars['Int']>;
  insurance_asset_id?: InputMaybe<Scalars['String']>;
  insurance_coverage?: InputMaybe<Scalars['String']>;
  insurance_eligible?: InputMaybe<Scalars['Boolean']>;
  insurance_plan_id?: InputMaybe<Scalars['String']>;
  insurance_state?: InputMaybe<Scalars['String']>;
  latest_review?: InputMaybe<LatestReviewInput>;
  locale?: InputMaybe<RentalLocaleInput>;
  mileage_usage_item?: InputMaybe<UsageBasedItemInput>;
  mileage_usage_item_id?: InputMaybe<Scalars['Int']>;
  minimum_days?: InputMaybe<Scalars['Int']>;
  minimum_deposit?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offer_delivery?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<UserInput>;
  owner_id?: InputMaybe<Scalars['Int']>;
  owner_summary?: InputMaybe<OwnerSummaryInput>;
  parent_id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<PriceInput>;
  primary_image_id?: InputMaybe<Scalars['Int']>;
  primary_image_url?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  require_insurance?: InputMaybe<Scalars['String']>;
  require_roadside?: InputMaybe<Scalars['Boolean']>;
  require_vin?: InputMaybe<Scalars['Boolean']>;
  review_notes?: InputMaybe<Scalars['String']>;
  review_status?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Int']>;
  score_count?: InputMaybe<Scalars['Int']>;
  session_id?: InputMaybe<Scalars['String']>;
  settlement_currency?: InputMaybe<Scalars['String']>;
  sleeps?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  turnaround_days_after?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleInput>;
  waived_insurance_text?: InputMaybe<Scalars['String']>;
};

export type RentalItem = {
  __typename?: 'RentalItem';
  applies_to_type?: Maybe<Array<Maybe<Scalars['String']>>>;
  available?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['Int']>;
  consigned_pay_pct?: Maybe<Scalars['Float']>;
  created?: Maybe<Scalars['String']>;
  daily?: Maybe<Scalars['Boolean']>;
  deferred?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  ledger_account_number?: Maybe<Scalars['Int']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']>;
  location_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  maximum_price?: Maybe<Scalars['Int']>;
  minimum_price?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
  percent_type?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  presentment_currency?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  rental?: Maybe<Rental>;
  rental_id?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  response_status?: Maybe<ResponseStatus>;
  settlement_currency?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Int']>;
  tax_rate_id?: Maybe<Scalars['Int']>;
  tax_rate_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  travelers?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']>;
};

export type RentalItemCopy = {
  count?: InputMaybe<Scalars['Int']>;
  rental_item_id?: InputMaybe<Scalars['Int']>;
};

export type RentalItemInput = {
  applies_to_type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['Int']>;
  consigned_pay_pct?: InputMaybe<Scalars['Float']>;
  created?: InputMaybe<Scalars['String']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  deferred?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  ledger_account_number?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['JSON']>;
  location_id?: InputMaybe<Scalars['Int']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maximum_price?: InputMaybe<Scalars['Int']>;
  minimum_price?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percent?: InputMaybe<Scalars['Float']>;
  percent_type?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  rental?: InputMaybe<Scalars['JSON']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  settlement_currency?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['Int']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  travelers?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['JSON']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type RentalItemRequestInput = {
  applies_to_type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['Int']>;
  consigned_pay_pct?: InputMaybe<Scalars['Float']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  deferred?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  ledger_account_number?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maximum_price?: InputMaybe<Scalars['Int']>;
  minimum_price?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  rental_id?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  settlement_currency?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['Int']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  travelers?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type RentalItemsResponse = {
  __typename?: 'RentalItemsResponse';
  rentalItems?: Maybe<Array<RentalItem>>;
  response_status?: Maybe<ResponseStatus>;
};

export type RentalLocale = {
  __typename?: 'RentalLocale';
  base_currency?: Maybe<Scalars['String']>;
  distance_unit?: Maybe<Scalars['String']>;
  length_unit?: Maybe<Scalars['String']>;
  liquid_unit?: Maybe<Scalars['String']>;
  weight_unit?: Maybe<Scalars['String']>;
};

export type RentalLocaleInput = {
  base_currency?: InputMaybe<Scalars['String']>;
  distance_unit?: InputMaybe<Scalars['String']>;
  length_unit?: InputMaybe<Scalars['String']>;
  liquid_unit?: InputMaybe<Scalars['String']>;
  weight_unit?: InputMaybe<Scalars['String']>;
};

export type RentalLocation = {
  __typename?: 'RentalLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type RentalLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type RentalSearch = {
  __typename?: 'RentalSearch';
  active_options?: Maybe<AttributesActiveOptions>;
  active_price?: Maybe<ActivePrice>;
  availability_set?: Maybe<Scalars['Boolean']>;
  average_ratings?: Maybe<AttributesAverageRatings>;
  average_reviews?: Maybe<AttributesAverageReviews>;
  base_price?: Maybe<BasePrice>;
  blend_logic_source?: Maybe<Scalars['String']>;
  cancel_policy?: Maybe<Scalars['String']>;
  cancel_policy_combo_bookings?: Maybe<Scalars['String']>;
  cancel_text?: Maybe<Scalars['String']>;
  children_count?: Maybe<Scalars['Int']>;
  coachnet_ready?: Maybe<Scalars['Boolean']>;
  coachnet_required?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  current_location_id?: Maybe<Scalars['Int']>;
  custom_insurance_text?: Maybe<Scalars['String']>;
  dealer?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  delivery_radius?: Maybe<Scalars['Int']>;
  delivery_radius_miles?: Maybe<Scalars['Int']>;
  delivery_radius_unit?: Maybe<Scalars['String']>;
  delivery_usage_item?: Maybe<UsageBasedItem>;
  delivery_usage_item_id?: Maybe<Scalars['Int']>;
  deposit_percentage?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  description_included?: Maybe<Scalars['Boolean']>;
  description_other?: Maybe<Scalars['String']>;
  description_recommendations?: Maybe<Scalars['String']>;
  display_vehicle_type?: Maybe<Scalars['String']>;
  external?: Maybe<Scalars['Boolean']>;
  favorite?: Maybe<Scalars['Boolean']>;
  favorite_count?: Maybe<Scalars['Int']>;
  filtered_description?: Maybe<Scalars['String']>;
  filtered_name?: Maybe<Scalars['String']>;
  first_published?: Maybe<Scalars['String']>;
  generator_usage_item?: Maybe<UsageBasedItem>;
  generator_usage_item_id?: Maybe<Scalars['Int']>;
  group_on_map?: Maybe<Scalars['Boolean']>;
  group_reviews_num?: Maybe<Scalars['Int']>;
  group_reviews_score?: Maybe<Scalars['Int']>;
  group_score?: Maybe<Scalars['Int']>;
  has_been_published?: Maybe<Scalars['Boolean']>;
  has_checkout_questions?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  home?: Maybe<RentalLocation>;
  house_rules?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  images?: Maybe<Array<Maybe<Images>>>;
  instant_book?: Maybe<Scalars['Boolean']>;
  instant_book_leeway?: Maybe<Scalars['Int']>;
  insurance_coverage?: Maybe<Scalars['String']>;
  insurance_eligible?: Maybe<Scalars['Boolean']>;
  insurance_renter_adjustable?: Maybe<Scalars['Boolean']>;
  insurance_state?: Maybe<Scalars['String']>;
  last_published?: Maybe<Scalars['String']>;
  locale?: Maybe<RentalLocale>;
  location?: Maybe<RentalLocation>;
  low_price_per_day?: Maybe<Scalars['Int']>;
  low_price_per_month?: Maybe<Scalars['Int']>;
  low_price_per_week?: Maybe<Scalars['Int']>;
  mileage_usage_item?: Maybe<UsageBasedItem>;
  mileage_usage_item_id?: Maybe<Scalars['Int']>;
  minimum_days?: Maybe<Scalars['Int']>;
  minimum_deposit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  original_url?: Maybe<Scalars['String']>;
  owner?: Maybe<Owner>;
  owner_score?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  presentment_currency?: Maybe<Scalars['String']>;
  price_per_day?: Maybe<Scalars['Int']>;
  price_per_month?: Maybe<Scalars['Int']>;
  price_per_week?: Maybe<Scalars['Int']>;
  primary_image_url?: Maybe<Scalars['String']>;
  pro?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  rental_price_usage_item_id?: Maybe<Scalars['Int']>;
  rental_score?: Maybe<Scalars['Float']>;
  request_less_than_minimum_days?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  reviews_num?: Maybe<Scalars['Int']>;
  same_sort_types?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Float']>;
  score_count?: Maybe<Scalars['Int']>;
  seatbelts?: Maybe<Scalars['Int']>;
  security_deposit?: Maybe<Scalars['Int']>;
  settlement_currency?: Maybe<Scalars['String']>;
  sleeps?: Maybe<Scalars['Int']>;
  sleeps_adults?: Maybe<Scalars['Int']>;
  sleeps_kids?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  smart_photo_score?: Maybe<Scalars['Int']>;
  sort_score?: Maybe<Scalars['Float']>;
  summary?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<AttributesTag>>>;
  type?: Maybe<Scalars['String']>;
  unavailable?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
  use_day_pricing?: Maybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: Maybe<Scalars['Boolean']>;
  vehicle_amps?: Maybe<Scalars['Int']>;
  vehicle_box_length?: Maybe<Scalars['Int']>;
  vehicle_class?: Maybe<Scalars['String']>;
  vehicle_dry_weight?: Maybe<Scalars['Int']>;
  vehicle_gvwr?: Maybe<Scalars['Int']>;
  vehicle_height?: Maybe<Scalars['Float']>;
  vehicle_length?: Maybe<Scalars['Float']>;
  vehicle_length_with_hitch?: Maybe<Scalars['Int']>;
  vehicle_license_plate_state?: Maybe<Scalars['String']>;
  vehicle_make?: Maybe<Scalars['String']>;
  vehicle_model?: Maybe<Scalars['String']>;
  vehicle_width?: Maybe<Scalars['Int']>;
  vehicle_year?: Maybe<Scalars['Int']>;
};

export type RentalSearchInput = {
  active_options?: InputMaybe<AttributesActiveOptionsInput>;
  active_price?: InputMaybe<ActivePriceInput>;
  availability_set?: InputMaybe<Scalars['Boolean']>;
  average_ratings?: InputMaybe<AttributesAverageRatingsInput>;
  average_reviews?: InputMaybe<AttributesAverageReviewsInput>;
  base_price?: InputMaybe<BasePriceInput>;
  blend_logic_source?: InputMaybe<Scalars['String']>;
  cancel_policy?: InputMaybe<Scalars['String']>;
  cancel_policy_combo_bookings?: InputMaybe<Scalars['String']>;
  cancel_text?: InputMaybe<Scalars['String']>;
  children_count?: InputMaybe<Scalars['Int']>;
  coachnet_ready?: InputMaybe<Scalars['Boolean']>;
  coachnet_required?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['String']>;
  current_location_id?: InputMaybe<Scalars['Int']>;
  custom_insurance_text?: InputMaybe<Scalars['String']>;
  dealer?: InputMaybe<Scalars['Boolean']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
  delivery_radius?: InputMaybe<Scalars['Int']>;
  delivery_radius_miles?: InputMaybe<Scalars['Int']>;
  delivery_radius_unit?: InputMaybe<Scalars['String']>;
  delivery_usage_item_id?: InputMaybe<Scalars['Int']>;
  deposit_percentage?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  description_included?: InputMaybe<Scalars['Boolean']>;
  description_other?: InputMaybe<Scalars['String']>;
  description_recommendations?: InputMaybe<Scalars['String']>;
  display_vehicle_type?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  favorite_count?: InputMaybe<Scalars['Int']>;
  filtered_description?: InputMaybe<Scalars['String']>;
  filtered_name?: InputMaybe<Scalars['String']>;
  first_published?: InputMaybe<Scalars['String']>;
  generator_usage_item?: InputMaybe<UsageBasedItemInput>;
  generator_usage_item_id?: InputMaybe<Scalars['Int']>;
  group_on_map?: InputMaybe<Scalars['Boolean']>;
  group_reviews_num?: InputMaybe<Scalars['Int']>;
  group_reviews_score?: InputMaybe<Scalars['Int']>;
  group_score?: InputMaybe<Scalars['Int']>;
  has_been_published?: InputMaybe<Scalars['Boolean']>;
  has_checkout_questions?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  home?: InputMaybe<RentalLocationInput>;
  house_rules?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<ImagesInput>>>;
  instant_book?: InputMaybe<Scalars['Boolean']>;
  instant_book_leeway?: InputMaybe<Scalars['Int']>;
  insurance_coverage?: InputMaybe<Scalars['String']>;
  insurance_eligible?: InputMaybe<Scalars['Boolean']>;
  insurance_renter_adjustable?: InputMaybe<Scalars['Boolean']>;
  insurance_state?: InputMaybe<Scalars['String']>;
  last_published?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<RentalLocaleInput>;
  location?: InputMaybe<RentalLocationInput>;
  low_price_per_day?: InputMaybe<Scalars['Int']>;
  low_price_per_month?: InputMaybe<Scalars['Int']>;
  low_price_per_week?: InputMaybe<Scalars['Int']>;
  mileage_usage_item?: InputMaybe<UsageBasedItemInput>;
  mileage_usage_item_id?: InputMaybe<Scalars['Int']>;
  minimum_days?: InputMaybe<Scalars['Int']>;
  minimum_deposit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  original_url?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<OwnerInput>;
  owner_score?: InputMaybe<Scalars['Float']>;
  owner_user_id?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  presentment_currency?: InputMaybe<Scalars['String']>;
  price_per_day?: InputMaybe<Scalars['Int']>;
  price_per_month?: InputMaybe<Scalars['Int']>;
  price_per_week?: InputMaybe<Scalars['Int']>;
  primary_image_url?: InputMaybe<Scalars['String']>;
  pro?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  rental_price_usage_item_id?: InputMaybe<Scalars['Int']>;
  rental_score?: InputMaybe<Scalars['Float']>;
  request_less_than_minimum_days?: InputMaybe<Scalars['Int']>;
  reviews_num?: InputMaybe<Scalars['Int']>;
  same_sort_types?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['Float']>;
  score_count?: InputMaybe<Scalars['Int']>;
  seatbelts?: InputMaybe<Scalars['Int']>;
  security_deposit?: InputMaybe<Scalars['Int']>;
  settlement_currency?: InputMaybe<Scalars['String']>;
  sleeps?: InputMaybe<Scalars['Int']>;
  sleeps_adults?: InputMaybe<Scalars['Int']>;
  sleeps_kids?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  smart_photo_score?: InputMaybe<Scalars['Int']>;
  sort_score?: InputMaybe<Scalars['Float']>;
  summary?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<AttributesTagInput>>>;
  type?: InputMaybe<Scalars['String']>;
  unavailable?: InputMaybe<Scalars['Boolean']>;
  updated?: InputMaybe<Scalars['String']>;
  use_day_pricing?: InputMaybe<Scalars['Boolean']>;
  use_tax_inclusive_pricing?: InputMaybe<Scalars['Boolean']>;
  vehicle_amps?: InputMaybe<Scalars['Int']>;
  vehicle_box_length?: InputMaybe<Scalars['Int']>;
  vehicle_class?: InputMaybe<Scalars['String']>;
  vehicle_dry_weight?: InputMaybe<Scalars['Int']>;
  vehicle_gvwr?: InputMaybe<Scalars['Int']>;
  vehicle_height?: InputMaybe<Scalars['Float']>;
  vehicle_length?: InputMaybe<Scalars['Float']>;
  vehicle_length_with_hitch?: InputMaybe<Scalars['Int']>;
  vehicle_license_plate_state?: InputMaybe<Scalars['String']>;
  vehicle_make?: InputMaybe<Scalars['String']>;
  vehicle_model?: InputMaybe<Scalars['String']>;
  vehicle_width?: InputMaybe<Scalars['Int']>;
  vehicle_year?: InputMaybe<Scalars['Int']>;
};

export enum RentalStyle {
  Drive = 'DRIVE',
  Tow = 'TOW'
}

export type RentalSummary = {
  __typename?: 'RentalSummary';
  display_type?: Maybe<Scalars['String']>;
  formatted_length?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  internal_id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primary_image_url?: Maybe<Scalars['String']>;
  sleeps?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stay_summary?: Maybe<StayRentalSummary>;
  style?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RentalSummaryInput = {
  display_type?: InputMaybe<Scalars['String']>;
  formatted_length?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  internal_id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  primary_image_url?: InputMaybe<Scalars['String']>;
  sleeps?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type RentalTag = {
  __typename?: 'RentalTag';
  Position?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  usage_by_rental_count?: Maybe<Scalars['Int']>;
};

export enum RentalType {
  CamperVan = 'CAMPER_VAN',
  ClassA = 'CLASS_A',
  ClassB = 'CLASS_B',
  ClassC = 'CLASS_C',
  FifthWheel = 'FIFTH_WHEEL',
  FoldingTrailer = 'FOLDING_TRAILER',
  ToyHauler = 'TOY_HAULER',
  Trailer = 'TRAILER',
  TruckCamper = 'TRUCK_CAMPER',
  UtilityTrailer = 'UTILITY_TRAILER'
}

export type RentalsSearch = {
  __typename?: 'RentalsSearch';
  meta?: Maybe<RentalsSearchMeta>;
  rentals?: Maybe<Array<Maybe<RentalSearch>>>;
  response_status?: Maybe<ResponseStatus>;
};

export type RentalsSearchMeta = {
  __typename?: 'RentalsSearchMeta';
  total?: Maybe<Scalars['Int']>;
};

export type RenterReviewInput = {
  booking_id: Scalars['Int'];
  communication_score?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  user_id: Scalars['Int'];
};

export type RenterSummary = {
  __typename?: 'RenterSummary';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
};

export type RenterSummaryInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
};

export type ReserveItem = {
  __typename?: 'ReserveItem';
  amount?: Maybe<Scalars['String']>;
  costCategory?: Maybe<Scalars['String']>;
  costType?: Maybe<Scalars['String']>;
  exposureId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Note>;
  reserveMethod?: Maybe<Scalars['String']>;
};

export type Response = {
  code: Scalars['Int'];
  headers?: Maybe<Scalars['JSON']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ResponseStatus = Status & {
  __typename?: 'ResponseStatus';
  code: Scalars['Int'];
  headers?: Maybe<Scalars['JSON']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Review = {
  __typename?: 'Review';
  booking?: Maybe<Booking>;
  booking_id?: Maybe<Scalars['Int']>;
  booking_summary?: Maybe<BookingSummary>;
  can_edit?: Maybe<Scalars['Boolean']>;
  can_edit_until?: Maybe<Scalars['String']>;
  cleanliness_score?: Maybe<Scalars['Float']>;
  communication_score?: Maybe<Scalars['Float']>;
  deleted?: Maybe<Scalars['String']>;
  exclude_from_rating?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  imported?: Maybe<Scalars['Boolean']>;
  listing_score?: Maybe<Scalars['Float']>;
  mechanical_score?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<ReviewOwner>;
  owner_can_respond?: Maybe<Scalars['Boolean']>;
  owner_response?: Maybe<OwnerResponse>;
  published?: Maybe<Scalars['Boolean']>;
  rental?: Maybe<Rental>;
  rental_id?: Maybe<Scalars['Int']>;
  rental_summary?: Maybe<RentalSummary>;
  rental_tags?: Maybe<Array<Maybe<RentalTag>>>;
  response_status?: Maybe<ResponseStatus>;
  review_images?: Maybe<Array<Maybe<ReviewImage>>>;
  reviewer?: Maybe<Reviewer>;
  reviewer_id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Float']>;
  source_page?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  text?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']>;
  user_recommend?: Maybe<Scalars['Boolean']>;
  value_score?: Maybe<Scalars['Float']>;
};

export type ReviewImage = {
  __typename?: 'ReviewImage';
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  rental_id?: Maybe<Scalars['String']>;
  review_id?: Maybe<Scalars['String']>;
  reviewed?: Maybe<Scalars['Boolean']>;
  reviewed_by?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ReviewOwner = {
  __typename?: 'ReviewOwner';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
};

export type ReviewOwnerResponseInput = {
  text?: InputMaybe<Scalars['String']>;
};

export enum ReviewSortOrder {
  Id = 'ID',
  IdDesc = 'ID_DESC',
  Score = 'SCORE',
  ScoreDesc = 'SCORE_DESC',
  Timestamp = 'TIMESTAMP',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export type Reviewer = {
  __typename?: 'Reviewer';
  avatar_url?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
};

export type ReviewsSearch = {
  __typename?: 'ReviewsSearch';
  response_status?: Maybe<ResponseStatus>;
  reviews?: Maybe<Array<Maybe<Review>>>;
};

export type RiskDriver = {
  __typename?: 'RiskDriver';
  coverType?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  driverType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseIssuingCountry?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<Scalars['String']>;
  mainDriver?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  penaltyPoints?: Maybe<Scalars['Int']>;
  prefix?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  temporary?: Maybe<Scalars['Boolean']>;
};

export type RiskVehicle = {
  __typename?: 'RiskVehicle';
  affiliation?: Maybe<Scalars['String']>;
  certDriving?: Maybe<Scalars['String']>;
  certUse?: Maybe<Scalars['String']>;
  classOfUse?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  registration?: Maybe<Scalars['String']>;
  temporary?: Maybe<Scalars['Boolean']>;
  temporaryPremium?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type RiskVehicleLocation = {
  __typename?: 'RiskVehicleLocation';
  address?: Maybe<ClaimAddress>;
  locationType?: Maybe<Scalars['String']>;
};

export type RoamlyWeatherQuote = {
  __typename?: 'RoamlyWeatherQuote';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  plain_language?: Maybe<PlainLanguage>;
  price?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  support_email?: Maybe<Scalars['String']>;
  support_phone?: Maybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  active: Scalars['Boolean'];
  created?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  owner_user_id: Scalars['Int'];
  permissions?: Maybe<Array<RolePermission>>;
  updated?: Maybe<Scalars['String']>;
};

export type RoleInput = {
  active: Scalars['Boolean'];
  created?: InputMaybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  owner_user_id: Scalars['Int'];
  permissions?: InputMaybe<Array<RolePermissionInput>>;
  updated?: InputMaybe<Scalars['String']>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  can_create: Scalars['Boolean'];
  can_delete: Scalars['Boolean'];
  can_read: Scalars['Boolean'];
  can_update: Scalars['Boolean'];
  created?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  name: Scalars['String'];
  permission_id: Scalars['Int'];
  role_id: Scalars['Int'];
  updated?: Maybe<Scalars['String']>;
};

export type RolePermissionInput = {
  can_create: Scalars['Boolean'];
  can_delete: Scalars['Boolean'];
  can_read: Scalars['Boolean'];
  can_update: Scalars['Boolean'];
  created?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  name: Scalars['String'];
  permission_id: Scalars['Int'];
  role_id: Scalars['Int'];
  updated?: InputMaybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  booking_id?: Maybe<Scalars['Int']>;
  bundle_id?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  charge_to?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  daily?: Maybe<Scalars['Boolean']>;
  dealer_flat_split?: Maybe<Scalars['Int']>;
  dealer_percent_split?: Maybe<Scalars['Int']>;
  dealer_split_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_reference_id?: Maybe<Scalars['String']>;
  fee_locked?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  is_taxable?: Maybe<Scalars['Boolean']>;
  last_service_log?: Maybe<LastServiceLog>;
  lock_on_booking_status?: Maybe<Scalars['String']>;
  minimum_price?: Maybe<Scalars['Int']>;
  missing_fields?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payable_to?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Int']>;
  percent_type?: Maybe<Scalars['String']>;
  policy_start_date?: Maybe<Scalars['String']>;
  premium_amount?: Maybe<Scalars['Int']>;
  premium_total?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  revision?: Maybe<Scalars['Int']>;
  service_data?: Maybe<ServiceData>;
  service_id?: Maybe<Scalars['Int']>;
  tax_amount?: Maybe<Scalars['Int']>;
  tax_rates?: Maybe<Array<BookingTaxRate>>;
  total?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type ServiceData = {
  __typename?: 'ServiceData';
  bundle_rule_id?: Maybe<Scalars['String']>;
  deductible?: Maybe<Scalars['Int']>;
  missing?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ServiceDataInput = {
  bundle_rule_id?: InputMaybe<Scalars['String']>;
  deductible?: InputMaybe<Scalars['Int']>;
  missing?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ServiceFeatures = {
  __typename?: 'ServiceFeatures';
  features?: Maybe<Array<Maybe<FeaturesDescription>>>;
};

export type ServiceInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  charge_to?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  dealer_flat_split?: InputMaybe<Scalars['Int']>;
  dealer_percent_split?: InputMaybe<Scalars['Int']>;
  dealer_split_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_reference_id?: InputMaybe<Scalars['String']>;
  fee_locked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_taxable?: InputMaybe<Scalars['Boolean']>;
  last_service_log?: InputMaybe<LastServiceLogInput>;
  lock_on_booking_status?: InputMaybe<Scalars['String']>;
  minimum_price?: InputMaybe<Scalars['Int']>;
  missing_fields?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payable_to?: InputMaybe<Scalars['String']>;
  percent?: InputMaybe<Scalars['Int']>;
  percent_type?: InputMaybe<Scalars['String']>;
  policy_start_date?: InputMaybe<Scalars['String']>;
  premium_amount?: InputMaybe<Scalars['Int']>;
  premium_total?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  revision?: InputMaybe<Scalars['Int']>;
  service_data?: InputMaybe<ServiceDataInput>;
  service_id?: InputMaybe<Scalars['Int']>;
  tax_amount?: InputMaybe<Scalars['Int']>;
  tax_rates?: InputMaybe<Array<BookingTaxRateInput>>;
  total?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type ServiceIntegration = {
  __typename?: 'ServiceIntegration';
  allow_dealer_premium?: Maybe<Scalars['Boolean']>;
  allow_dealer_to_require?: Maybe<Scalars['Boolean']>;
  allow_owner_premium?: Maybe<Scalars['Boolean']>;
  booking_id?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  charge_to?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  current_data?: Maybe<CurrentDatum>;
  dealer?: Maybe<Scalars['Boolean']>;
  dealer_flat_split?: Maybe<Scalars['Int']>;
  dealer_percent?: Maybe<Scalars['Float']>;
  dealer_percent_split?: Maybe<Scalars['Float']>;
  dealer_percent_type?: Maybe<Scalars['String']>;
  dealer_price?: Maybe<Scalars['Int']>;
  dealer_price_type?: Maybe<Scalars['String']>;
  dealer_qualifies?: Maybe<Scalars['Boolean']>;
  dealer_split_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<ServiceFeatures>;
  id?: Maybe<Scalars['Int']>;
  is_taxable?: Maybe<Scalars['Boolean']>;
  minimum_vehicle_year?: Maybe<Scalars['Int']>;
  missing_fields?: Maybe<MissingFields>;
  name?: Maybe<Scalars['String']>;
  owner_percent?: Maybe<Scalars['Float']>;
  owner_percent_type?: Maybe<Scalars['String']>;
  owner_price?: Maybe<Scalars['Int']>;
  owner_price_type?: Maybe<Scalars['String']>;
  qualified?: Maybe<Scalars['Boolean']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  renter_region_exclusions?: Maybe<Array<Maybe<Scalars['String']>>>;
  required_fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  roamly_weather_quote?: Maybe<RoamlyWeatherQuote>;
  slug?: Maybe<Scalars['String']>;
  support_phone?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['Int']>;
  tax_rate_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  total?: Maybe<Scalars['Int']>;
  user_disabled?: Maybe<Scalars['Boolean']>;
  user_premium?: Maybe<Scalars['Int']>;
  user_required?: Maybe<Scalars['Boolean']>;
  vehicle_types?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SetPercentUptakeInput = {
  bundle_id?: InputMaybe<Scalars['String']>;
  percent_uptake_drivable?: InputMaybe<Scalars['Float']>;
  percent_uptake_towable?: InputMaybe<Scalars['Float']>;
};

export type SignData = {
  __typename?: 'SignData';
  expires_at?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
  sign_url?: Maybe<Scalars['String']>;
};

export type Social = {
  __typename?: 'Social';
  count: Scalars['String'];
  link: Scalars['String'];
  rating: Scalars['String'];
  site: Scalars['String'];
};

export type SocialInput = {
  count: Scalars['String'];
  link: Scalars['String'];
  rating: Scalars['String'];
  site: Scalars['String'];
};

export type SoonestTripId = {
  __typename?: 'SoonestTripId';
  booking_id?: Maybe<Scalars['Int']>;
  response_status?: Maybe<ResponseStatus>;
};

export enum SortCriteria {
  Distance = 'DISTANCE',
  DistanceDesc = 'DISTANCE_DESC',
  NumReviews = 'NUM_REVIEWS',
  NumReviewsDesc = 'NUM_REVIEWS_DESC',
  Position = 'POSITION',
  PositionDesc = 'POSITION_DESC',
  Price = 'PRICE',
  PriceDesc = 'PRICE_DESC',
  Rating = 'RATING',
  RatingDesc = 'RATING_DESC',
  Seatbelts = 'SEATBELTS',
  SeatbeltsDesc = 'SEATBELTS_DESC',
  Sleeps = 'SLEEPS',
  SleepsDesc = 'SLEEPS_DESC'
}

export type SpecialHours = {
  __typename?: 'SpecialHours';
  created?: Maybe<Scalars['String']>;
  created_from_id?: Maybe<Scalars['Int']>;
  dropoff?: Maybe<LocationAvailabilityInterval>;
  end_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  pickup?: Maybe<LocationAvailabilityInterval>;
  repeats?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
  weekdays?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Status = {
  code: Scalars['Int'];
  headers?: Maybe<Scalars['JSON']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type StayRentalSummary = {
  __typename?: 'StayRentalSummary';
  baths?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  beds?: Maybe<Scalars['Int']>;
  check_in_type?: Maybe<Scalars['String']>;
  display_stay_type?: Maybe<Scalars['String']>;
  location_description?: Maybe<Scalars['String']>;
  max_parking_spaces?: Maybe<Scalars['Int']>;
  parking_onsite?: Maybe<Scalars['Boolean']>;
  rental_id?: Maybe<Scalars['Int']>;
  sleeps?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type SubCharge = {
  __typename?: 'SubCharge';
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  subscription_name?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  allow_for_review?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_user_id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type TaxRateItem = {
  __typename?: 'TaxRateItem';
  description?: Maybe<Scalars['String']>;
  original_tax_rate_id?: Maybe<Scalars['Int']>;
  tax_amount?: Maybe<Scalars['Int']>;
  tax_name?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

export type TaxRateTotalItem = {
  __typename?: 'TaxRateTotalItem';
  amount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  rates?: Maybe<Array<TaxRateItem>>;
};

export type Tiers = {
  __typename?: 'Tiers';
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
  minimum_fee?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  tax_amount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
  usage_based_item_id?: Maybe<Scalars['Int']>;
};

export type TiersInput = {
  created?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  maximum?: InputMaybe<Scalars['Int']>;
  minimum_fee?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  tax_amount?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['String']>;
  usage_based_item_id?: InputMaybe<Scalars['Int']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  campaign: Scalars['String'];
  content: Scalars['String'];
  intent: Scalars['String'];
  medium: Scalars['String'];
  source: Scalars['String'];
  term: Scalars['String'];
};

export type TrackingInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  intent?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

export type Transactions = {
  __typename?: 'Transactions';
  actual_deposit_date?: Maybe<Scalars['String']>;
  adjustment?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Int']>;
  booking_id?: Maybe<Scalars['Int']>;
  brand?: Maybe<Scalars['String']>;
  can_refund?: Maybe<Scalars['Boolean']>;
  can_retry?: Maybe<Scalars['Boolean']>;
  cc_fee?: Maybe<Scalars['Int']>;
  charged?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  deposit_date?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['Boolean']>;
  display_charge_type?: Maybe<Scalars['String']>;
  display_type?: Maybe<Scalars['String']>;
  dispute_reason?: Maybe<Scalars['String']>;
  dispute_status?: Maybe<Scalars['String']>;
  disputed?: Maybe<Scalars['Boolean']>;
  expected_deposit_date?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['Boolean']>;
  fx_fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_refund?: Maybe<Scalars['Boolean']>;
  last_four?: Maybe<Scalars['String']>;
  original_charge_id?: Maybe<Scalars['String']>;
  our_fee?: Maybe<Scalars['Int']>;
  outdoorsy_fee?: Maybe<Scalars['Int']>;
  owner_fee?: Maybe<Scalars['Int']>;
  owner_integrations_fee?: Maybe<Scalars['String']>;
  payment_meta?: Maybe<Scalars['String']>;
  payment_processor?: Maybe<PaymentProcessorWithId>;
  payment_source?: Maybe<Scalars['String']>;
  recipient_id?: Maybe<Scalars['Int']>;
  refund_source?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  refunded_cc_fee?: Maybe<Scalars['Int']>;
  refunded_fee?: Maybe<Scalars['Int']>;
  refunded_fx_fee?: Maybe<Scalars['Int']>;
  refunded_outdoorsy_fee?: Maybe<Scalars['Int']>;
  refunded_owner_fee?: Maybe<Scalars['Int']>;
  refunded_owner_integrations_fee?: Maybe<Scalars['String']>;
  refunded_service_fee?: Maybe<Scalars['Int']>;
  service_fee?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TransactionsInput = {
  actual_deposit_date?: InputMaybe<Scalars['String']>;
  adjustment?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Int']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  brand?: InputMaybe<Scalars['String']>;
  can_refund?: InputMaybe<Scalars['Boolean']>;
  can_retry?: InputMaybe<Scalars['Boolean']>;
  cc_fee?: InputMaybe<Scalars['Int']>;
  charged?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  deposit_date?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['Boolean']>;
  display_charge_type?: InputMaybe<Scalars['String']>;
  display_type?: InputMaybe<Scalars['String']>;
  dispute_reason?: InputMaybe<Scalars['String']>;
  dispute_status?: InputMaybe<Scalars['String']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  expected_deposit_date?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  fx_fee?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_refund?: InputMaybe<Scalars['Boolean']>;
  last_four?: InputMaybe<Scalars['String']>;
  original_charge_id?: InputMaybe<Scalars['String']>;
  our_fee?: InputMaybe<Scalars['Int']>;
  outdoorsy_fee?: InputMaybe<Scalars['Int']>;
  owner_fee?: InputMaybe<Scalars['Int']>;
  owner_integrations_fee?: InputMaybe<Scalars['String']>;
  payment_meta?: InputMaybe<Scalars['String']>;
  payment_processor?: InputMaybe<PaymentProcessorWithIdInput>;
  payment_source?: InputMaybe<Scalars['String']>;
  recipient_id?: InputMaybe<Scalars['Int']>;
  refund_source?: InputMaybe<Scalars['String']>;
  refunded?: InputMaybe<Scalars['Int']>;
  refunded_cc_fee?: InputMaybe<Scalars['Int']>;
  refunded_fee?: InputMaybe<Scalars['Int']>;
  refunded_fx_fee?: InputMaybe<Scalars['Int']>;
  refunded_outdoorsy_fee?: InputMaybe<Scalars['Int']>;
  refunded_owner_fee?: InputMaybe<Scalars['Int']>;
  refunded_owner_integrations_fee?: InputMaybe<Scalars['String']>;
  refunded_service_fee?: InputMaybe<Scalars['Int']>;
  service_fee?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UnionResponse = PaymentProcessingInfo | User;

export type UpdateAccountRequest = {
  customer_bcc_email?: InputMaybe<Scalars['String']>;
};

export type UpdateFileInput = {
  auto_include?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  exif_created?: InputMaybe<Scalars['String']>;
  exif_data?: InputMaybe<Scalars['JSON']>;
  include_esign?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  shared?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateLocationInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  availability?: InputMaybe<Scalars['JSON']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  custom_insurance_text?: InputMaybe<Scalars['String']>;
  eligible_for_system_tax_rates?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  locale?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  opt_out_marketplace_taxes?: InputMaybe<Scalars['Boolean']>;
  payment_processing_info_id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  special_hours?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  state?: InputMaybe<Scalars['String']>;
  state_tax_id?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_etc?: InputMaybe<Scalars['String']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tax_split_eligible?: InputMaybe<Scalars['Boolean']>;
  waived_insurance_text?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateRentalReviewInput = {
  booking_id: Scalars['Int'];
  cleanliness_score?: InputMaybe<Scalars['Float']>;
  communication_score?: InputMaybe<Scalars['Float']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  listing_score?: InputMaybe<Scalars['Float']>;
  mechanical_score?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<InputMaybe<UpdateReviewTagInput>>>;
  text?: InputMaybe<Scalars['String']>;
  user_recommend?: InputMaybe<Scalars['Boolean']>;
  value_score?: InputMaybe<Scalars['Float']>;
};

export type UpdateReviewTagInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type UpdateRoleRequest = {
  account_id?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updated?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type UpdateSubscriptionInput = {
  coachnet_id?: InputMaybe<Scalars['Int']>;
};

export type UsageBasedItem = {
  __typename?: 'UsageBasedItem';
  archived?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  fee_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  included?: Maybe<Scalars['Int']>;
  included_period?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  single_tier?: Maybe<Scalars['Boolean']>;
  tax_amount?: Maybe<Scalars['Int']>;
  tax_rate_id?: Maybe<Scalars['Int']>;
  tax_rate_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  tiers?: Maybe<Array<Maybe<Tiers>>>;
  unit?: Maybe<Scalars['String']>;
  unlimited?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
};

export type UsageBasedItemInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['String']>;
  fee_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  included?: InputMaybe<Scalars['Int']>;
  included_period?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  single_tier?: InputMaybe<Scalars['Boolean']>;
  tax_amount?: InputMaybe<Scalars['Int']>;
  tax_rate_id?: InputMaybe<Scalars['Int']>;
  tax_rate_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tiers?: InputMaybe<Array<InputMaybe<TiersInput>>>;
  unit?: InputMaybe<Scalars['String']>;
  unlimited?: InputMaybe<Scalars['Boolean']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  accept_percent?: Maybe<Scalars['Float']>;
  account_id?: Maybe<Scalars['String']>;
  addon_fee_percentage?: Maybe<Scalars['Float']>;
  admin?: Maybe<Scalars['Boolean']>;
  admin_level?: Maybe<Scalars['Int']>;
  api_key?: Maybe<Scalars['String']>;
  approved_drivers?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  average_response_time?: Maybe<Scalars['Float']>;
  bank_country?: Maybe<Scalars['String']>;
  cash_credits?: Maybe<Scalars['Int']>;
  cc_fee_percentage?: Maybe<Scalars['Float']>;
  completed_bookings?: Maybe<Scalars['Int']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Int']>;
  dealer?: Maybe<Scalars['Boolean']>;
  deposits_disabled?: Maybe<Scalars['Boolean']>;
  driver_checks_enabled?: Maybe<Scalars['Boolean']>;
  drivers?: Maybe<Array<Maybe<Drivers>>>;
  earned_credits?: Maybe<Array<EarnedCredit>>;
  employee?: Maybe<Scalars['Boolean']>;
  esign_enabled?: Maybe<Scalars['Boolean']>;
  force_reconnect_bank?: Maybe<Scalars['Boolean']>;
  fraud_review_complete?: Maybe<Scalars['Boolean']>;
  gps_fee?: Maybe<Scalars['Int']>;
  group_on_map?: Maybe<Scalars['Boolean']>;
  guest?: Maybe<Scalars['Boolean']>;
  has_connected_gateway?: Maybe<Scalars['Boolean']>;
  has_setup_intent_enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  impersonated?: Maybe<Scalars['Boolean']>;
  import_id?: Maybe<Scalars['String']>;
  isAuthenticated?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<RentalItem>>;
  metadata?: Maybe<Metadata>;
  missing_fields?: Maybe<Array<Scalars['String']>>;
  offers_delivery?: Maybe<Scalars['Boolean']>;
  owned_by_id?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['Boolean']>;
  owner_fee_percentage?: Maybe<Scalars['Float']>;
  owner_score?: Maybe<Scalars['Int']>;
  owner_score_count?: Maybe<Scalars['Int']>;
  partner_app_id?: Maybe<Scalars['String']>;
  partner_id?: Maybe<Scalars['String']>;
  payment_processing_info?: Maybe<Array<Maybe<PaymentProcessingInfo>>>;
  pending_email?: Maybe<Scalars['String']>;
  pro?: Maybe<Scalars['Boolean']>;
  pro_status?: Maybe<ProStatus>;
  profile?: Maybe<Profile>;
  reconnect_bank?: Maybe<Scalars['Boolean']>;
  referral_code?: Maybe<Scalars['String']>;
  referred_by_id?: Maybe<Scalars['Int']>;
  referred_owner_paid?: Maybe<Scalars['Boolean']>;
  referred_owner_payout_amount?: Maybe<Scalars['Int']>;
  referred_renter_paid?: Maybe<Scalars['Boolean']>;
  referred_renter_payout_amount?: Maybe<Scalars['Int']>;
  renter?: Maybe<Scalars['Boolean']>;
  renter_fee_percentage?: Maybe<Scalars['Float']>;
  response_percent?: Maybe<Scalars['Float']>;
  response_status?: Maybe<ResponseStatus>;
  roadside_missing?: Maybe<Array<Scalars['String']>>;
  role?: Maybe<Role>;
  score?: Maybe<Scalars['Float']>;
  score_count?: Maybe<Scalars['Int']>;
  search_token?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  signup_source?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  time_to_first_action?: Maybe<Scalars['Int']>;
  total_bookings?: Maybe<Scalars['Int']>;
  tracking?: Maybe<Tracking>;
  use_fees_increase?: Maybe<Scalars['Boolean']>;
  use_insurance_bundles?: Maybe<Scalars['Boolean']>;
  verifications?: Maybe<Verifications>;
};

export type UserAuthResponse = {
  __typename?: 'UserAuthResponse';
  account_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  response_status?: Maybe<ResponseStatus>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type UserCard = {
  __typename?: 'UserCard';
  brand?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last_four?: Maybe<Scalars['String']>;
  latest_setup_intent_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  payment_processor?: Maybe<PaymentProcessor>;
  response_status?: Maybe<ResponseStatus>;
  stripe_token?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export type UserCardInput = {
  brand?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  exp_month?: InputMaybe<Scalars['Int']>;
  exp_year?: InputMaybe<Scalars['Int']>;
  last_four?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  payment_processor?: InputMaybe<PaymentProcessorInput>;
  stripe_token?: InputMaybe<Scalars['String']>;
};

export type UserCreateRequest = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  intent?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  signup_source?: InputMaybe<Scalars['String']>;
};

export type UserInput = {
  accept_percent?: InputMaybe<Scalars['Float']>;
  account_id?: InputMaybe<Scalars['String']>;
  addon_fee_percentage?: InputMaybe<Scalars['Float']>;
  address?: InputMaybe<AddressInput>;
  admin?: InputMaybe<Scalars['Boolean']>;
  admin_level?: InputMaybe<Scalars['Int']>;
  api_key?: InputMaybe<Scalars['String']>;
  approved_drivers?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  average_response_time?: InputMaybe<Scalars['Float']>;
  bank_country?: InputMaybe<Scalars['String']>;
  cash_credits?: InputMaybe<Scalars['Int']>;
  cc_fee_percentage?: InputMaybe<Scalars['Float']>;
  completed_bookings?: InputMaybe<Scalars['Int']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['String']>;
  credits?: InputMaybe<Scalars['Int']>;
  dealer?: InputMaybe<Scalars['Boolean']>;
  deposits_disabled?: InputMaybe<Scalars['Boolean']>;
  driver_checks_enabled?: InputMaybe<Scalars['Boolean']>;
  drivers?: InputMaybe<Array<InputMaybe<DriversInput>>>;
  earned_credits?: InputMaybe<Array<EarnedCreditInput>>;
  email?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  esign_enabled?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  force_reconnect_bank?: InputMaybe<Scalars['Boolean']>;
  fraud_review_complete?: InputMaybe<Scalars['Boolean']>;
  gps_fee?: InputMaybe<Scalars['Int']>;
  group_on_map?: InputMaybe<Scalars['Boolean']>;
  guest?: InputMaybe<Scalars['Boolean']>;
  has_connected_gateway?: InputMaybe<Scalars['Boolean']>;
  has_setup_intent_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  impersonated?: InputMaybe<Scalars['Boolean']>;
  import_id?: InputMaybe<Scalars['String']>;
  isAuthenticated?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<RentalItemInput>>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<MetadataInput>;
  missing_fields?: InputMaybe<Array<Scalars['String']>>;
  offers_delivery?: InputMaybe<Scalars['Boolean']>;
  owned_by_id?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['Boolean']>;
  owner_fee_percentage?: InputMaybe<Scalars['Float']>;
  owner_score?: InputMaybe<Scalars['Int']>;
  owner_score_count?: InputMaybe<Scalars['Int']>;
  partner_app_id?: InputMaybe<Scalars['String']>;
  partner_id?: InputMaybe<Scalars['String']>;
  payment_processing_info?: InputMaybe<Array<InputMaybe<PaymentProcessingInfoInput>>>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pro?: InputMaybe<Scalars['Boolean']>;
  pro_status?: InputMaybe<ProStatusInput>;
  profile?: InputMaybe<ProfileInput>;
  reconnect_bank?: InputMaybe<Scalars['Boolean']>;
  referral_code?: InputMaybe<Scalars['String']>;
  referred_by_id?: InputMaybe<Scalars['Int']>;
  referred_owner_paid?: InputMaybe<Scalars['Boolean']>;
  referred_owner_payout_amount?: InputMaybe<Scalars['Int']>;
  referred_renter_paid?: InputMaybe<Scalars['Boolean']>;
  referred_renter_payout_amount?: InputMaybe<Scalars['Int']>;
  renter?: InputMaybe<Scalars['Boolean']>;
  renter_fee_percentage?: InputMaybe<Scalars['Float']>;
  response_percent?: InputMaybe<Scalars['Float']>;
  roadside_missing?: InputMaybe<Array<Scalars['String']>>;
  role?: InputMaybe<RoleInput>;
  score?: InputMaybe<Scalars['Float']>;
  score_count?: InputMaybe<Scalars['Int']>;
  search_token?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  signup_source?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  time_to_first_action?: InputMaybe<Scalars['Int']>;
  total_bookings?: InputMaybe<Scalars['Int']>;
  tracking?: InputMaybe<TrackingInput>;
  use_fees_increase?: InputMaybe<Scalars['Boolean']>;
  use_insurance_bundles?: InputMaybe<Scalars['Boolean']>;
  verifications?: InputMaybe<VerificationsInput>;
};

export type UserLocale = {
  __typename?: 'UserLocale';
  base_currency: Scalars['String'];
  date_format: Scalars['String'];
  distance_unit: Scalars['String'];
  language: Scalars['String'];
  length_unit: Scalars['String'];
  liquid_unit: Scalars['String'];
  time_format: Scalars['String'];
  timezone: Scalars['String'];
  weight_unit: Scalars['String'];
};

export type UserLocaleInput = {
  base_currency: Scalars['String'];
  date_format: Scalars['String'];
  distance_unit: Scalars['String'];
  language: Scalars['String'];
  length_unit: Scalars['String'];
  liquid_unit: Scalars['String'];
  time_format: Scalars['String'];
  timezone: Scalars['String'];
  weight_unit: Scalars['String'];
};

export type UserSearch = {
  __typename?: 'UserSearch';
  response_status?: Maybe<ResponseStatus>;
  user?: Maybe<UserSearchData>;
};

export type UserSearchAttributes = {
  __typename?: 'UserSearchAttributes';
  avatar_url?: Maybe<Scalars['String']>;
  average_response_time?: Maybe<Scalars['Int']>;
  business_description?: Maybe<Scalars['String']>;
  business_name?: Maybe<Scalars['String']>;
  business_website?: Maybe<Scalars['String']>;
  cancel_policy?: Maybe<Scalars['String']>;
  cancel_policy_combo_bookings?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  dealer?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  filtered_business_description?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  locale_base_currency?: Maybe<Scalars['String']>;
  locale_language?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  mast_image_url?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Boolean']>;
  owner_reviews_count?: Maybe<Scalars['Int']>;
  owner_score?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Boolean']>;
  response_percent?: Maybe<Scalars['Float']>;
  reviews_count?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  social?: Maybe<Array<Maybe<UserSearchSocialProfile>>>;
  years_owned?: Maybe<Scalars['Int']>;
  years_r_ving?: Maybe<Scalars['Int']>;
};

export type UserSearchData = {
  __typename?: 'UserSearchData';
  attributes?: Maybe<UserSearchAttributes>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserSearchSocialProfile = {
  __typename?: 'UserSearchSocialProfile';
  count?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  site?: Maybe<Scalars['String']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  length?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type VehicleInfo = {
  __typename?: 'VehicleInfo';
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  engine_power?: Maybe<Scalars['Int']>;
  fuel_tank_capacity?: Maybe<Scalars['Float']>;
  fuel_type?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  length?: Maybe<Scalars['Float']>;
  make?: Maybe<Scalars['String']>;
  mode_of_drive?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  original_type?: Maybe<Scalars['String']>;
  popular?: Maybe<Scalars['Boolean']>;
  response_status?: Maybe<ResponseStatus>;
  seats?: Maybe<Scalars['Int']>;
  sleep_space?: Maybe<Scalars['Int']>;
  sleeps?: Maybe<Scalars['Int']>;
  transmission?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type VehicleInfoDetailsResponse = {
  __typename?: 'VehicleInfoDetailsResponse';
  Q?: Maybe<Scalars['String']>;
  bodystyle?: Maybe<Array<Maybe<Scalars['String']>>>;
  country?: Maybe<Scalars['String']>;
  len?: Maybe<Array<Maybe<Scalars['String']>>>;
  make?: Maybe<Scalars['String']>;
  makes?: Maybe<Array<Maybe<Scalars['String']>>>;
  model?: Maybe<Scalars['String']>;
  models?: Maybe<Array<Maybe<Scalars['String']>>>;
  response_status?: Maybe<ResponseStatus>;
  source?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  trims?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type VehicleInfoInput = {
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  engine_power?: InputMaybe<Scalars['Int']>;
  fuel_tank_capacity?: InputMaybe<Scalars['Float']>;
  fuel_type?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  length?: InputMaybe<Scalars['Float']>;
  make?: InputMaybe<Scalars['String']>;
  mode_of_drive?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  original_type?: InputMaybe<Scalars['String']>;
  popular?: InputMaybe<Scalars['Boolean']>;
  seats?: InputMaybe<Scalars['Int']>;
  sleep_space?: InputMaybe<Scalars['Int']>;
  sleeps?: InputMaybe<Scalars['Int']>;
  transmission?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type VehicleInput = {
  length?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  unit_of_measure?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type VehicleRef = {
  __typename?: 'VehicleRef';
  vehicleId?: Maybe<Scalars['String']>;
};

export type VehiclesResponse = {
  __typename?: 'VehiclesResponse';
  response_status?: Maybe<ResponseStatus>;
  vehicles?: Maybe<Array<Maybe<VehicleInfo>>>;
};

export type Verifications = {
  __typename?: 'Verifications';
  email: Scalars['Boolean'];
  has_sent_message_without_phone_verified: Scalars['Boolean'];
  phone: Scalars['Boolean'];
};

export type VerificationsInput = {
  email: Scalars['Boolean'];
  has_sent_message_without_phone_verified: Scalars['Boolean'];
  phone: Scalars['Boolean'];
};

export type WaiverSummary = {
  __typename?: 'WaiverSummary';
  description?: Maybe<Scalars['String']>;
  owner_completed?: Maybe<Scalars['Boolean']>;
  renter_completed?: Maybe<Scalars['Boolean']>;
};

export type WaiverSummaryInput = {
  description?: InputMaybe<Scalars['String']>;
  owner_completed?: InputMaybe<Scalars['Boolean']>;
  renter_completed?: InputMaybe<Scalars['Boolean']>;
};

export enum WeightUnit {
  Kg = 'KG',
  Lbs = 'LBS'
}

export type WriteFundRequest = {
  api_key?: InputMaybe<Scalars['String']>;
  auth_mode?: InputMaybe<Scalars['String']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  gateway_type?: InputMaybe<Scalars['String']>;
};

export type AvailabilityQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
  rentalId: Scalars['Int'];
  ownerId?: InputMaybe<Scalars['Int']>;
  overrideProtections?: InputMaybe<Scalars['Boolean']>;
  includeChildren?: InputMaybe<Scalars['Boolean']>;
  bookingId?: InputMaybe<Scalars['Int']>;
}>;


export type AvailabilityQuery = { __typename?: 'Query', getAvailability?: { __typename?: 'AvailabilityResponse', availability?: Array<{ __typename?: 'Availability', from?: string | null, next_available?: string | null, rental_id?: number | null, to?: string | null, turnaround_days?: number | null } | null> | null } | null };

export type ChangeBookingStatusMutationVariables = Exact<{
  bookingId: Scalars['Int'];
  changeBookingStatusInput: ChangeBookingStatusInput;
}>;


export type ChangeBookingStatusMutation = { __typename?: 'Mutation', changeBookingStatus?: { __typename?: 'Booking', id?: number | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type UpdateBookingMutationVariables = Exact<{
  bookingId: Scalars['Int'];
  input: BookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking?: { __typename?: 'Booking', id?: number | null, to?: string | null, from?: string | null, total?: number | null, total_after_credits?: number | null, trip_credits_disabled?: boolean | null, can_apply_credits?: boolean | null, rental_charge_card_id?: number | null, remainder_due_date?: string | null, reserve_amount?: number | null, reserve_amount_after_credits?: number | null, renter_credits_applied?: number | null, security_deposit?: number | null, security_deposit_due_date?: string | null, rental_id?: number | null, instant_book?: boolean | null, original_day_price?: number | null, initial_duration?: number | null, presentment_currency?: string | null, calculated_day_price?: number | null, offer_paypal_pay_later?: boolean | null, has_setup_intent_enabled?: boolean | null, from_time?: number | null, to_time?: number | null, bundle_id?: string | null, service_fee?: number | null, subtotal?: number | null, delivery_usage_item_id?: string | null, discount_code?: string | null, discount_code_amount?: number | null, duration?: number | null, tax?: number | null, status?: string | null, updated_stamp?: string | null, addons?: Array<{ __typename?: 'BookingItem', name?: string | null, count?: number | null, parent_item_id?: number | null, id?: number | null, daily?: boolean | null, price?: number | null, total?: number | null } | null> | null, pickup?: { __typename?: 'Pickup', delivery?: boolean | null } | null, checkout_questions?: Array<{ __typename?: 'CheckoutQuestion', help?: string | null, id: number, label?: string | null, required?: boolean | null, style?: string | null, type?: string | null, value?: any | null, choices?: Array<{ __typename?: 'Choice', value: string }> | null } | null> | null, locale?: { __typename?: 'Locale', base_currency?: string | null } | null, delivery_item?: { __typename?: 'BookingItem', price?: number | null } | null, insurance_bundle?: { __typename?: 'BookingBundle', total_price?: number | null, owner_id?: number | null, name?: string | null } | null, owner_fees?: Array<{ __typename?: 'BookingItem', total?: number | null }> | null, rental_amount_item?: { __typename?: 'BookingItem', total?: number | null } | null, rental_summary?: { __typename?: 'RentalSummary', id?: number | null, sleeps?: number | null } | null, services?: Array<{ __typename?: 'Service', category?: string | null }> | null, waiver_summary?: { __typename?: 'WaiverSummary', renter_completed?: boolean | null, description?: string | null, owner_completed?: boolean | null } | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number, headers?: any | null } | null } | null };

export type CreateBookingMutationVariables = Exact<{
  input: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename?: 'Booking', id?: number | null, to?: string | null, from?: string | null, total?: number | null, total_after_credits?: number | null, trip_credits_disabled?: boolean | null, can_apply_credits?: boolean | null, rental_charge_card_id?: number | null, remainder_due_date?: string | null, reserve_amount?: number | null, reserve_amount_after_credits?: number | null, renter_credits_applied?: number | null, security_deposit?: number | null, security_deposit_due_date?: string | null, rental_id?: number | null, instant_book?: boolean | null, original_day_price?: number | null, initial_duration?: number | null, presentment_currency?: string | null, calculated_day_price?: number | null, offer_paypal_pay_later?: boolean | null, has_setup_intent_enabled?: boolean | null, from_time?: number | null, to_time?: number | null, bundle_id?: string | null, service_fee?: number | null, subtotal?: number | null, delivery_usage_item_id?: string | null, discount_code?: string | null, discount_code_amount?: number | null, duration?: number | null, tax?: number | null, status?: string | null, updated_stamp?: string | null, addons?: Array<{ __typename?: 'BookingItem', name?: string | null, count?: number | null, parent_item_id?: number | null, id?: number | null, daily?: boolean | null, price?: number | null, total?: number | null } | null> | null, pickup?: { __typename?: 'Pickup', delivery?: boolean | null } | null, checkout_questions?: Array<{ __typename?: 'CheckoutQuestion', help?: string | null, id: number, label?: string | null, required?: boolean | null, style?: string | null, type?: string | null, value?: any | null, choices?: Array<{ __typename?: 'Choice', value: string }> | null } | null> | null, locale?: { __typename?: 'Locale', base_currency?: string | null } | null, delivery_item?: { __typename?: 'BookingItem', price?: number | null } | null, insurance_bundle?: { __typename?: 'BookingBundle', total_price?: number | null, owner_id?: number | null, name?: string | null } | null, owner_fees?: Array<{ __typename?: 'BookingItem', total?: number | null }> | null, rental_amount_item?: { __typename?: 'BookingItem', total?: number | null } | null, rental_summary?: { __typename?: 'RentalSummary', id?: number | null, sleeps?: number | null } | null, services?: Array<{ __typename?: 'Service', category?: string | null }> | null, waiver_summary?: { __typename?: 'WaiverSummary', renter_completed?: boolean | null, description?: string | null, owner_completed?: boolean | null } | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number, headers?: any | null } | null } | null };

export type GetBookingQueryVariables = Exact<{
  bookingId: Scalars['Int'];
}>;


export type GetBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id?: number | null, to?: string | null, from?: string | null, total?: number | null, total_after_credits?: number | null, trip_credits_disabled?: boolean | null, can_apply_credits?: boolean | null, rental_charge_card_id?: number | null, remainder_due_date?: string | null, reserve_amount?: number | null, reserve_amount_after_credits?: number | null, renter_credits_applied?: number | null, security_deposit?: number | null, security_deposit_due_date?: string | null, rental_id?: number | null, instant_book?: boolean | null, original_day_price?: number | null, initial_duration?: number | null, presentment_currency?: string | null, calculated_day_price?: number | null, offer_paypal_pay_later?: boolean | null, has_setup_intent_enabled?: boolean | null, from_time?: number | null, to_time?: number | null, bundle_id?: string | null, service_fee?: number | null, subtotal?: number | null, delivery_usage_item_id?: string | null, discount_code?: string | null, discount_code_amount?: number | null, duration?: number | null, tax?: number | null, status?: string | null, updated_stamp?: string | null, checkout_questions?: Array<{ __typename?: 'CheckoutQuestion', id: number, help?: string | null, label?: string | null, required?: boolean | null, style?: string | null, type?: string | null, value?: any | null, choices?: Array<{ __typename?: 'Choice', value: string }> | null } | null> | null, addons?: Array<{ __typename?: 'BookingItem', name?: string | null, count?: number | null, parent_item_id?: number | null, id?: number | null, daily?: boolean | null, price?: number | null, total?: number | null } | null> | null, pickup?: { __typename?: 'Pickup', delivery?: boolean | null } | null, locale?: { __typename?: 'Locale', base_currency?: string | null } | null, delivery_item?: { __typename?: 'BookingItem', price?: number | null } | null, insurance_bundle?: { __typename?: 'BookingBundle', total_price?: number | null, owner_id?: number | null, name?: string | null } | null, owner_fees?: Array<{ __typename?: 'BookingItem', total?: number | null }> | null, rental_amount_item?: { __typename?: 'BookingItem', total?: number | null } | null, rental_summary?: { __typename?: 'RentalSummary', id?: number | null, sleeps?: number | null } | null, services?: Array<{ __typename?: 'Service', category?: string | null }> | null, waiver_summary?: { __typename?: 'WaiverSummary', renter_completed?: boolean | null, description?: string | null, owner_completed?: boolean | null } | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number, headers?: any | null } | null } | null };

export type GetSoonestTripIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSoonestTripIdQuery = { __typename?: 'Query', getSoonestTripId?: { __typename?: 'SoonestTripId', booking_id?: number | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type BookingPartsFragment = { __typename?: 'Booking', id?: number | null, to?: string | null, from?: string | null, total?: number | null, total_after_credits?: number | null, trip_credits_disabled?: boolean | null, can_apply_credits?: boolean | null, rental_charge_card_id?: number | null, remainder_due_date?: string | null, reserve_amount?: number | null, reserve_amount_after_credits?: number | null, renter_credits_applied?: number | null, security_deposit?: number | null, security_deposit_due_date?: string | null, rental_id?: number | null, instant_book?: boolean | null, original_day_price?: number | null, initial_duration?: number | null, presentment_currency?: string | null, calculated_day_price?: number | null, offer_paypal_pay_later?: boolean | null, has_setup_intent_enabled?: boolean | null, from_time?: number | null, to_time?: number | null, bundle_id?: string | null, service_fee?: number | null, subtotal?: number | null, delivery_usage_item_id?: string | null, discount_code?: string | null, discount_code_amount?: number | null, duration?: number | null, tax?: number | null, status?: string | null, updated_stamp?: string | null, addons?: Array<{ __typename?: 'BookingItem', name?: string | null, count?: number | null, parent_item_id?: number | null, id?: number | null, daily?: boolean | null, price?: number | null, total?: number | null } | null> | null, pickup?: { __typename?: 'Pickup', delivery?: boolean | null } | null, checkout_questions?: Array<{ __typename?: 'CheckoutQuestion', help?: string | null, id: number, label?: string | null, required?: boolean | null, style?: string | null, type?: string | null, value?: any | null, choices?: Array<{ __typename?: 'Choice', value: string }> | null } | null> | null, locale?: { __typename?: 'Locale', base_currency?: string | null } | null, delivery_item?: { __typename?: 'BookingItem', price?: number | null } | null, insurance_bundle?: { __typename?: 'BookingBundle', total_price?: number | null, owner_id?: number | null, name?: string | null } | null, owner_fees?: Array<{ __typename?: 'BookingItem', total?: number | null }> | null, rental_amount_item?: { __typename?: 'BookingItem', total?: number | null } | null, rental_summary?: { __typename?: 'RentalSummary', id?: number | null, sleeps?: number | null } | null, services?: Array<{ __typename?: 'Service', category?: string | null }> | null, waiver_summary?: { __typename?: 'WaiverSummary', renter_completed?: boolean | null, description?: string | null, owner_completed?: boolean | null } | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number, headers?: any | null } | null };

export type CreateBookingDeliveryProposalMutationVariables = Exact<{
  input: CreateBookingDeliveryProposalInput;
}>;


export type CreateBookingDeliveryProposalMutation = { __typename?: 'Mutation', createBookingDeliveryProposal: { __typename?: 'BookingDeliveryProposal', details?: { __typename?: 'BookingDeliveryProposalDetails', estimated_distance?: number | null, delivery_amount?: number | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } };

export type GetUserCardsQueryVariables = Exact<{
  userId: Scalars['Int'];
  country?: InputMaybe<Scalars['String']>;
}>;


export type GetUserCardsQuery = { __typename?: 'Query', getUserCards?: { __typename?: 'CardsResponse', cards?: Array<{ __typename?: 'UserCard', id?: number | null, owner_id?: number | null, brand?: string | null, last_four?: string | null, exp_month?: number | null, exp_year?: number | null, default?: boolean | null, created?: string | null, updated?: string | null, payment_processor?: { __typename?: 'PaymentProcessor', id?: number | null, name?: string | null, country?: string | null } | null } | null> | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type CreateCardMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: UserCardInput;
}>;


export type CreateCardMutation = { __typename?: 'Mutation', createCard?: { __typename?: 'UserCard', id?: number | null, owner_id?: number | null, brand?: string | null, last_four?: string | null, exp_month?: number | null, exp_year?: number | null, default?: boolean | null, created?: string | null, updated?: string | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null, payment_processor?: { __typename?: 'PaymentProcessor', id?: number | null, name?: string | null, country?: string | null } | null } | null };

export type PatchCardMutationVariables = Exact<{
  userId: Scalars['Int'];
  cardId: Scalars['Int'];
  input: UserCardInput;
}>;


export type PatchCardMutation = { __typename?: 'Mutation', patchCard?: { __typename?: 'UserCard', id?: number | null, owner_id?: number | null, brand?: string | null, last_four?: string | null, exp_month?: number | null, exp_year?: number | null, default?: boolean | null, created?: string | null, updated?: string | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null, payment_processor?: { __typename?: 'PaymentProcessor', id?: number | null, name?: string | null, country?: string | null } | null } | null };

export type UserCardPartsFragment = { __typename?: 'UserCard', id?: number | null, owner_id?: number | null, brand?: string | null, last_four?: string | null, exp_month?: number | null, exp_year?: number | null, default?: boolean | null, created?: string | null, updated?: string | null, payment_processor?: { __typename?: 'PaymentProcessor', id?: number | null, name?: string | null, country?: string | null } | null };

export type GetCheckoutStepsQueryVariables = Exact<{
  bookingId: Scalars['Int'];
}>;


export type GetCheckoutStepsQuery = { __typename?: 'Query', getCheckoutSteps?: { __typename?: 'CheckoutSteps', id?: number | null, route?: string | null, readonly_insurance?: boolean | null, imminent_departure?: boolean | null, steps?: Array<{ __typename?: 'CheckoutStep', status: string, order: number, name: string }> | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number } | null } | null };

export type UpdateCheckoutStepsMutationVariables = Exact<{
  bookingId: Scalars['Int'];
  checkoutSteps: CheckoutStepsInput;
}>;


export type UpdateCheckoutStepsMutation = { __typename?: 'Mutation', updateCheckoutSteps?: { __typename?: 'CheckoutSteps', id?: number | null, imminent_departure?: boolean | null, readonly_insurance?: boolean | null, route?: string | null, steps?: Array<{ __typename?: 'CheckoutStep', order: number, status: string, name: string }> | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number } | null } | null };

export type CreateFilesMutationVariables = Exact<{
  fileInputs: Array<CreateFileInput> | CreateFileInput;
}>;


export type CreateFilesMutation = { __typename?: 'Mutation', createFiles: Array<{ __typename?: 'File', id?: number | null, name?: string | null, url?: string | null, created?: string | null, updated?: string | null }> };

export type CreateFileMutationVariables = Exact<{
  fileInput: CreateFileInput;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile?: { __typename?: 'File', id?: number | null, name?: string | null, url?: string | null, created?: string | null, updated?: string | null } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile?: { __typename?: 'DeleteFileResponse', response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type GetHandoffByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['Int'];
}>;


export type GetHandoffByBookingIdQuery = { __typename?: 'Query', getHandoffByBookingId?: { __typename?: 'HandoffResponse', handoff?: { __typename?: 'Handoff', id: string, booking_id?: string | null, departure_complete?: boolean | null, return_complete?: boolean | null, owner_departure_complete?: boolean | null, owner_return_complete?: boolean | null, renter_departure_complete?: boolean | null, renter_return_complete?: boolean | null, owner_departure_started?: boolean | null, owner_return_started?: boolean | null, renter_departure_started?: boolean | null, renter_return_started?: boolean | null, owner_acknowledged_rental_agreement?: boolean | null, owner_acknowledged_departure_form?: boolean | null, renter_acknowledged_rental_agreement?: boolean | null, renter_acknowledged_departure_form?: boolean | null, return_files: Array<{ __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null }>, departure_files: Array<{ __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null }> } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type UpdateHandoffMutationVariables = Exact<{
  handoffInput: HandoffInput;
}>;


export type UpdateHandoffMutation = { __typename?: 'Mutation', updateHandoff?: { __typename?: 'HandoffResponse', handoff?: { __typename?: 'Handoff', id: string, booking_id?: string | null, departure_complete?: boolean | null, return_complete?: boolean | null, owner_departure_complete?: boolean | null, owner_return_complete?: boolean | null, renter_departure_complete?: boolean | null, renter_return_complete?: boolean | null, owner_departure_started?: boolean | null, owner_return_started?: boolean | null, renter_departure_started?: boolean | null, renter_return_started?: boolean | null, owner_acknowledged_rental_agreement?: boolean | null, owner_acknowledged_departure_form?: boolean | null, renter_acknowledged_rental_agreement?: boolean | null, renter_acknowledged_departure_form?: boolean | null, return_files: Array<{ __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null }>, departure_files: Array<{ __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null }> } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type HandoffResPartsFragment = { __typename?: 'HandoffResponse', handoff?: { __typename?: 'Handoff', id: string, booking_id?: string | null, departure_complete?: boolean | null, return_complete?: boolean | null, owner_departure_complete?: boolean | null, owner_return_complete?: boolean | null, renter_departure_complete?: boolean | null, renter_return_complete?: boolean | null, owner_departure_started?: boolean | null, owner_return_started?: boolean | null, renter_departure_started?: boolean | null, renter_return_started?: boolean | null, owner_acknowledged_rental_agreement?: boolean | null, owner_acknowledged_departure_form?: boolean | null, renter_acknowledged_rental_agreement?: boolean | null, renter_acknowledged_departure_form?: boolean | null, return_files: Array<{ __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null }>, departure_files: Array<{ __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null }> } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null };

export type HandoffFilePartsFragment = { __typename?: 'HandoffFile', id: number, name?: string | null, url: string, owner_submitted?: boolean | null, renter_submitted?: boolean | null, admin_submitted?: boolean | null, created?: string | null, updated?: string | null };

export type GetLocationByIdQueryVariables = Exact<{
  currentLocationId?: InputMaybe<Scalars['Int']>;
}>;


export type GetLocationByIdQuery = { __typename?: 'Query', getLocationById?: { __typename?: 'Location', id?: number | null, response_status?: { __typename?: 'ResponseStatus', success: boolean, code: number, message: string } | null, availability?: { __typename?: 'LocationAvailability', days?: { __typename?: 'LocationAvailabilityDays', sunday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null, monday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null, tuesday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null, wednesday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null, thursday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null, friday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null, saturday?: { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null } | null } | null } | null } | null };

export type LocationAvailabilityPartsFragment = { __typename?: 'LocationAvailabilityDay', dropoff?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null, pickup?: { __typename?: 'LocationAvailabilityInterval', start_time?: number | null, end_time?: number | null, unavailable?: boolean | null } | null };

export type CreateClientTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateClientTokenMutation = { __typename?: 'Mutation', createClientToken?: { __typename?: 'CreateClientTokenPayload', clientToken?: string | null, clientMutationId?: string | null } | null };

export type CreateQuoteDeliveryProposalMutationVariables = Exact<{
  quoteRequest: QuoteRequestInput;
}>;


export type CreateQuoteDeliveryProposalMutation = { __typename?: 'Mutation', createQuote?: { __typename?: 'Quote', delivery_item?: { __typename?: 'BookingItem', price?: number | null } | null, delivery?: { __typename?: 'QuoteDelivery', estimated_distance?: number | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type GetQuoteByIdQueryVariables = Exact<{
  quoteId?: InputMaybe<Scalars['String']>;
}>;


export type GetQuoteByIdQuery = { __typename?: 'Query', getQuoteById?: { __typename?: 'Quote', id?: string | null, to?: string | null, from?: string | null, discount_code?: string | null, is_request_less_than_minimum_days?: boolean | null, rental_summary?: { __typename?: 'RentalSummary', id?: number | null } | null, waiver_summary?: { __typename?: 'WaiverSummary', owner_completed?: boolean | null, renter_completed?: boolean | null, description?: string | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type GetRentalInsuranceBundlesQueryVariables = Exact<{
  rentalId: Scalars['Int'];
  presentmentCurrency?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRentalInsuranceBundlesQuery = { __typename?: 'Query', getRentalInsuranceBundles?: { __typename?: 'RentalBundlesResponse', rentalBundles?: Array<{ __typename?: 'RentalBundles', dealer_owned_renter?: boolean | null, deductible?: number | null, default_selection?: boolean | null, delivery?: boolean | null, description?: string | null, id?: string | null, insurance_protection?: string | null, name?: string | null, note?: string | null, price_per_day?: number | null, property_damage?: string | null, subtext?: string | null, supported_types?: Array<string | null> | null, tier?: number | null, total_price?: number | null, bundle_features?: Array<{ __typename?: 'RentalBundlesFeatures', category?: string | null, items?: Array<{ __typename?: 'RentalBundlesFeaturesItems', name?: string | null, position?: number | null, type?: string | null } | null> | null } | null> | null } | null> | null, response_status?: { __typename?: 'ResponseStatus', message: string, success: boolean, code: number } | null } | null };

export type SearchPopularParksQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
}>;


export type SearchPopularParksQuery = { __typename?: 'Query', searchPopularParks?: { __typename?: 'ParksSearch', parks?: Array<{ __typename?: 'ParkSearchResult', locale?: string | null, metadata?: any | null, id?: number | null } | null> | null } | null };

export type GetRentalByIdQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['Int'];
}>;


export type GetRentalByIdQuery = { __typename?: 'Query', getRentalById?: { __typename?: 'RentalSearch', id?: number | null, slug?: string | null, has_checkout_questions?: boolean | null, current_location_id?: number | null, presentment_currency?: string | null, settlement_currency?: string | null, instant_book?: boolean | null, owner?: { __typename?: 'Owner', created?: string | null, slug?: string | null, id?: number | null, first_name?: string | null, last_name?: string | null, business_name?: string | null, avatar_url?: string | null, dealer?: boolean | null, description?: string | null, business_description?: string | null, average_response_time?: number | null, bank_country?: string | null, country?: string | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type GetRentalServicesQueryVariables = Exact<{
  rentalId: Scalars['Int'];
}>;


export type GetRentalServicesQuery = { __typename?: 'Query', getRentalServices: { __typename?: 'PremiumServicesResponse', services?: Array<{ __typename?: 'ServiceIntegration', id?: number | null, category?: string | null, total?: number | null, roamly_weather_quote?: { __typename?: 'RoamlyWeatherQuote', plain_language?: { __typename?: 'PlainLanguage', details?: { __typename?: 'PlainLanguageDetails', summary_tiers?: Array<string | null> | null } | null } | null } | null }> | null } };

export type GetBookingServicesQueryVariables = Exact<{
  bookingId: Scalars['Int'];
}>;


export type GetBookingServicesQuery = { __typename?: 'Query', getBookingServices: { __typename?: 'PremiumServicesResponse', services?: Array<{ __typename?: 'ServiceIntegration', id?: number | null, category?: string | null, total?: number | null, roamly_weather_quote?: { __typename?: 'RoamlyWeatherQuote', plain_language?: { __typename?: 'PlainLanguage', details?: { __typename?: 'PlainLanguageDetails', summary_tiers?: Array<string | null> | null } | null } | null } | null }> | null } };

export type GetQuoteServicesQueryVariables = Exact<{
  quoteId: Scalars['String'];
}>;


export type GetQuoteServicesQuery = { __typename?: 'Query', getQuoteServices: { __typename?: 'PremiumServicesResponse', services?: Array<{ __typename?: 'ServiceIntegration', id?: number | null, category?: string | null, total?: number | null, roamly_weather_quote?: { __typename?: 'RoamlyWeatherQuote', plain_language?: { __typename?: 'PlainLanguage', details?: { __typename?: 'PlainLanguageDetails', summary_tiers?: Array<string | null> | null } | null } | null } | null }> | null } };

export type ServicesResPartsFragment = { __typename?: 'PremiumServicesResponse', services?: Array<{ __typename?: 'ServiceIntegration', id?: number | null, category?: string | null, total?: number | null, roamly_weather_quote?: { __typename?: 'RoamlyWeatherQuote', plain_language?: { __typename?: 'PlainLanguage', details?: { __typename?: 'PlainLanguageDetails', summary_tiers?: Array<string | null> | null } | null } | null } | null }> | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', getCountries?: { __typename?: 'CountriesResponse', countries?: Array<{ __typename?: 'Country', code: string, name: string }> | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type RegionsQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type RegionsQuery = { __typename?: 'Query', getRegions?: { __typename?: 'RegionsResponse', regions?: Array<{ __typename?: 'Region', code: string, name: string }> | null, response_status?: { __typename?: 'ResponseStatus', code: number, success: boolean, message: string } | null } | null };

export type GetCancellationPolicyQueryVariables = Exact<{
  input?: InputMaybe<CancellationPolicyInput>;
}>;


export type GetCancellationPolicyQuery = { __typename?: 'Query', getCancellationPolicy?: { __typename?: 'CancellationPolicy', policy_v2?: { __typename?: 'CancellationPolicyV2', markdown?: string | null, title?: string | null } | null, policy?: { __typename?: 'PolicyV1', free_cancel_message?: string | null } | null, payment_policy?: { __typename?: 'PaymentPolicy', refundable_message?: string | null, refundable_note?: string | null, name?: string | null, details?: { __typename?: 'CancelContent', title?: string | null, list_items?: Array<string | null> | null } | null } | null } | null };

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: number | null, isAuthenticated?: boolean | null, guest?: boolean | null, owner?: boolean | null, created?: string | null, credits?: number | null, profile?: { __typename?: 'Profile', first_name: string, gender?: string | null, last_name: string, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, county?: string | null, state?: string | null, street?: string | null, street_etc?: string | null, zip?: string | null } | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, message: string, success: boolean } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['Int'];
  userInput: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id?: number | null, isAuthenticated?: boolean | null, guest?: boolean | null, owner?: boolean | null, created?: string | null, credits?: number | null, profile?: { __typename?: 'Profile', first_name: string, gender?: string | null, last_name: string, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, county?: string | null, state?: string | null, street?: string | null, street_etc?: string | null, zip?: string | null } | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, message: string, success: boolean } | null } | null };

export type UserPartsFragment = { __typename?: 'User', id?: number | null, isAuthenticated?: boolean | null, guest?: boolean | null, owner?: boolean | null, created?: string | null, credits?: number | null, profile?: { __typename?: 'Profile', first_name: string, gender?: string | null, last_name: string, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, county?: string | null, state?: string | null, street?: string | null, street_etc?: string | null, zip?: string | null } | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, message: string, success: boolean } | null };

export type MiniMeQueryVariables = Exact<{ [key: string]: never; }>;


export type MiniMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id?: number | null, isAuthenticated?: boolean | null, guest?: boolean | null, owner?: boolean | null, created?: string | null, credits?: number | null, profile?: { __typename?: 'Profile', first_name: string, gender?: string | null, last_name: string, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, county?: string | null, state?: string | null, street?: string | null, street_etc?: string | null, zip?: string | null } | null } | null, response_status?: { __typename?: 'ResponseStatus', code: number, message: string, success: boolean } | null } | null };

export const BookingPartsFragmentDoc = gql`
    fragment BookingParts on Booking {
  addons {
    name
    count
    parent_item_id
    id
    daily
    price
    total
  }
  id
  to
  from
  total
  total_after_credits
  trip_credits_disabled
  can_apply_credits
  rental_charge_card_id
  remainder_due_date
  reserve_amount
  reserve_amount_after_credits
  renter_credits_applied
  security_deposit
  security_deposit_due_date
  pickup {
    delivery
  }
  rental_id
  instant_book
  original_day_price
  initial_duration
  presentment_currency
  calculated_day_price
  offer_paypal_pay_later
  has_setup_intent_enabled
  from_time
  to_time
  checkout_questions {
    choices {
      value
    }
    help
    id
    label
    required
    style
    type
    value
  }
  locale {
    base_currency
  }
  bundle_id
  delivery_item {
    price
  }
  insurance_bundle {
    total_price
    owner_id
    name
  }
  owner_fees {
    total
  }
  rental_amount_item {
    total
  }
  rental_summary {
    id
    sleeps
  }
  service_fee
  services {
    category
  }
  subtotal
  waiver_summary {
    renter_completed
    description
    owner_completed
  }
  delivery_usage_item_id
  discount_code
  discount_code_amount
  duration
  tax
  status
  updated_stamp
  response_status {
    message
    success
    code
    headers
  }
}
    `;
export const UserCardPartsFragmentDoc = gql`
    fragment UserCardParts on UserCard {
  id
  owner_id
  brand
  last_four
  exp_month
  exp_year
  default
  created
  updated
  payment_processor {
    id
    name
    country
  }
}
    `;
export const HandoffFilePartsFragmentDoc = gql`
    fragment HandoffFileParts on HandoffFile {
  id
  name
  url
  owner_submitted
  renter_submitted
  admin_submitted
  created
  updated
}
    `;
export const HandoffResPartsFragmentDoc = gql`
    fragment HandoffResParts on HandoffResponse {
  handoff {
    id
    booking_id
    departure_complete
    return_complete
    owner_departure_complete
    owner_return_complete
    renter_departure_complete
    renter_return_complete
    owner_departure_started
    owner_return_started
    renter_departure_started
    renter_return_started
    owner_acknowledged_rental_agreement
    owner_acknowledged_departure_form
    renter_acknowledged_rental_agreement
    renter_acknowledged_departure_form
    return_files {
      ...HandoffFileParts
    }
    departure_files {
      ...HandoffFileParts
    }
  }
  response_status {
    code
    success
    message
  }
}
    ${HandoffFilePartsFragmentDoc}`;
export const LocationAvailabilityPartsFragmentDoc = gql`
    fragment LocationAvailabilityParts on LocationAvailabilityDay {
  dropoff {
    start_time
    end_time
    unavailable
  }
  pickup {
    start_time
    end_time
    unavailable
  }
}
    `;
export const ServicesResPartsFragmentDoc = gql`
    fragment ServicesResParts on PremiumServicesResponse {
  services {
    id
    category
    total
    roamly_weather_quote {
      plain_language {
        details {
          summary_tiers
        }
      }
    }
  }
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on User {
  id
  isAuthenticated
  guest
  owner
  created
  credits
  profile {
    first_name
    gender
    last_name
    phone
    email
    address {
      city
      country
      county
      state
      street
      street_etc
      zip
    }
  }
  response_status {
    code
    message
    success
  }
}
    `;
export const AvailabilityDocument = gql`
    query Availability($from: String!, $to: String!, $rentalId: Int!, $ownerId: Int, $overrideProtections: Boolean, $includeChildren: Boolean, $bookingId: Int) {
  getAvailability(
    from: $from
    to: $to
    rental_id: $rentalId
    owner_id: $ownerId
    override_protections: $overrideProtections
    include_children: $includeChildren
    booking_id: $bookingId
  ) {
    availability {
      from
      next_available
      rental_id
      to
      turnaround_days
    }
  }
}
    `;

/**
 * __useAvailabilityQuery__
 *
 * To run a query within a React component, call `useAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      rentalId: // value for 'rentalId'
 *      ownerId: // value for 'ownerId'
 *      overrideProtections: // value for 'overrideProtections'
 *      includeChildren: // value for 'includeChildren'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityQuery, AvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, options);
      }
export function useAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityQuery, AvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, options);
        }
export type AvailabilityQueryHookResult = ReturnType<typeof useAvailabilityQuery>;
export type AvailabilityLazyQueryHookResult = ReturnType<typeof useAvailabilityLazyQuery>;
export type AvailabilityQueryResult = Apollo.QueryResult<AvailabilityQuery, AvailabilityQueryVariables>;
export const ChangeBookingStatusDocument = gql`
    mutation ChangeBookingStatus($bookingId: Int!, $changeBookingStatusInput: ChangeBookingStatusInput!) {
  changeBookingStatus(booking_id: $bookingId, input: $changeBookingStatusInput) {
    id
    response_status {
      code
      success
      message
    }
  }
}
    `;
export type ChangeBookingStatusMutationFn = Apollo.MutationFunction<ChangeBookingStatusMutation, ChangeBookingStatusMutationVariables>;

/**
 * __useChangeBookingStatusMutation__
 *
 * To run a mutation, you first call `useChangeBookingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBookingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBookingStatusMutation, { data, loading, error }] = useChangeBookingStatusMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      changeBookingStatusInput: // value for 'changeBookingStatusInput'
 *   },
 * });
 */
export function useChangeBookingStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeBookingStatusMutation, ChangeBookingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeBookingStatusMutation, ChangeBookingStatusMutationVariables>(ChangeBookingStatusDocument, options);
      }
export type ChangeBookingStatusMutationHookResult = ReturnType<typeof useChangeBookingStatusMutation>;
export type ChangeBookingStatusMutationResult = Apollo.MutationResult<ChangeBookingStatusMutation>;
export type ChangeBookingStatusMutationOptions = Apollo.BaseMutationOptions<ChangeBookingStatusMutation, ChangeBookingStatusMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($bookingId: Int!, $input: BookingInput!) {
  updateBooking(booking_id: $bookingId, input: $input) {
    ...BookingParts
  }
}
    ${BookingPartsFragmentDoc}`;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($input: CreateBookingInput!) {
  createBooking(input: $input) {
    ...BookingParts
  }
}
    ${BookingPartsFragmentDoc}`;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const GetBookingDocument = gql`
    query GetBooking($bookingId: Int!) {
  booking(id: $bookingId) {
    ...BookingParts
    checkout_questions {
      id
    }
  }
}
    ${BookingPartsFragmentDoc}`;

/**
 * __useGetBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
      }
export function useGetBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export type GetBookingQueryHookResult = ReturnType<typeof useGetBookingQuery>;
export type GetBookingLazyQueryHookResult = ReturnType<typeof useGetBookingLazyQuery>;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const GetSoonestTripIdDocument = gql`
    query GetSoonestTripId {
  getSoonestTripId {
    booking_id
    response_status {
      code
      success
      message
    }
  }
}
    `;

/**
 * __useGetSoonestTripIdQuery__
 *
 * To run a query within a React component, call `useGetSoonestTripIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoonestTripIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoonestTripIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSoonestTripIdQuery(baseOptions?: Apollo.QueryHookOptions<GetSoonestTripIdQuery, GetSoonestTripIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoonestTripIdQuery, GetSoonestTripIdQueryVariables>(GetSoonestTripIdDocument, options);
      }
export function useGetSoonestTripIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoonestTripIdQuery, GetSoonestTripIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoonestTripIdQuery, GetSoonestTripIdQueryVariables>(GetSoonestTripIdDocument, options);
        }
export type GetSoonestTripIdQueryHookResult = ReturnType<typeof useGetSoonestTripIdQuery>;
export type GetSoonestTripIdLazyQueryHookResult = ReturnType<typeof useGetSoonestTripIdLazyQuery>;
export type GetSoonestTripIdQueryResult = Apollo.QueryResult<GetSoonestTripIdQuery, GetSoonestTripIdQueryVariables>;
export const CreateBookingDeliveryProposalDocument = gql`
    mutation CreateBookingDeliveryProposal($input: CreateBookingDeliveryProposalInput!) {
  createBookingDeliveryProposal(input: $input) {
    details {
      estimated_distance
      delivery_amount
    }
    response_status {
      code
      success
      message
    }
  }
}
    `;
export type CreateBookingDeliveryProposalMutationFn = Apollo.MutationFunction<CreateBookingDeliveryProposalMutation, CreateBookingDeliveryProposalMutationVariables>;

/**
 * __useCreateBookingDeliveryProposalMutation__
 *
 * To run a mutation, you first call `useCreateBookingDeliveryProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingDeliveryProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingDeliveryProposalMutation, { data, loading, error }] = useCreateBookingDeliveryProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingDeliveryProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingDeliveryProposalMutation, CreateBookingDeliveryProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingDeliveryProposalMutation, CreateBookingDeliveryProposalMutationVariables>(CreateBookingDeliveryProposalDocument, options);
      }
export type CreateBookingDeliveryProposalMutationHookResult = ReturnType<typeof useCreateBookingDeliveryProposalMutation>;
export type CreateBookingDeliveryProposalMutationResult = Apollo.MutationResult<CreateBookingDeliveryProposalMutation>;
export type CreateBookingDeliveryProposalMutationOptions = Apollo.BaseMutationOptions<CreateBookingDeliveryProposalMutation, CreateBookingDeliveryProposalMutationVariables>;
export const GetUserCardsDocument = gql`
    query GetUserCards($userId: Int!, $country: String) {
  getUserCards(user_id: $userId, country: $country) {
    cards {
      ...UserCardParts
    }
    response_status {
      code
      success
      message
    }
  }
}
    ${UserCardPartsFragmentDoc}`;

/**
 * __useGetUserCardsQuery__
 *
 * To run a query within a React component, call `useGetUserCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCardsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetUserCardsQuery(baseOptions: Apollo.QueryHookOptions<GetUserCardsQuery, GetUserCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCardsQuery, GetUserCardsQueryVariables>(GetUserCardsDocument, options);
      }
export function useGetUserCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCardsQuery, GetUserCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCardsQuery, GetUserCardsQueryVariables>(GetUserCardsDocument, options);
        }
export type GetUserCardsQueryHookResult = ReturnType<typeof useGetUserCardsQuery>;
export type GetUserCardsLazyQueryHookResult = ReturnType<typeof useGetUserCardsLazyQuery>;
export type GetUserCardsQueryResult = Apollo.QueryResult<GetUserCardsQuery, GetUserCardsQueryVariables>;
export const CreateCardDocument = gql`
    mutation CreateCard($userId: Int!, $input: UserCardInput!) {
  createCard(user_id: $userId, input: $input) {
    ...UserCardParts
    response_status {
      code
      success
      message
    }
  }
}
    ${UserCardPartsFragmentDoc}`;
export type CreateCardMutationFn = Apollo.MutationFunction<CreateCardMutation, CreateCardMutationVariables>;

/**
 * __useCreateCardMutation__
 *
 * To run a mutation, you first call `useCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardMutation, { data, loading, error }] = useCreateCardMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardMutation, CreateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardMutation, CreateCardMutationVariables>(CreateCardDocument, options);
      }
export type CreateCardMutationHookResult = ReturnType<typeof useCreateCardMutation>;
export type CreateCardMutationResult = Apollo.MutationResult<CreateCardMutation>;
export type CreateCardMutationOptions = Apollo.BaseMutationOptions<CreateCardMutation, CreateCardMutationVariables>;
export const PatchCardDocument = gql`
    mutation PatchCard($userId: Int!, $cardId: Int!, $input: UserCardInput!) {
  patchCard(user_id: $userId, card_id: $cardId, input: $input) {
    ...UserCardParts
    response_status {
      code
      success
      message
    }
  }
}
    ${UserCardPartsFragmentDoc}`;
export type PatchCardMutationFn = Apollo.MutationFunction<PatchCardMutation, PatchCardMutationVariables>;

/**
 * __usePatchCardMutation__
 *
 * To run a mutation, you first call `usePatchCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchCardMutation, { data, loading, error }] = usePatchCardMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      cardId: // value for 'cardId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchCardMutation(baseOptions?: Apollo.MutationHookOptions<PatchCardMutation, PatchCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchCardMutation, PatchCardMutationVariables>(PatchCardDocument, options);
      }
export type PatchCardMutationHookResult = ReturnType<typeof usePatchCardMutation>;
export type PatchCardMutationResult = Apollo.MutationResult<PatchCardMutation>;
export type PatchCardMutationOptions = Apollo.BaseMutationOptions<PatchCardMutation, PatchCardMutationVariables>;
export const GetCheckoutStepsDocument = gql`
    query GetCheckoutSteps($bookingId: Int!) {
  getCheckoutSteps(booking_id: $bookingId) {
    steps {
      status
      order
      name
    }
    id
    route
    readonly_insurance
    imminent_departure
    response_status {
      message
      success
      code
    }
  }
}
    `;

/**
 * __useGetCheckoutStepsQuery__
 *
 * To run a query within a React component, call `useGetCheckoutStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutStepsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetCheckoutStepsQuery(baseOptions: Apollo.QueryHookOptions<GetCheckoutStepsQuery, GetCheckoutStepsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutStepsQuery, GetCheckoutStepsQueryVariables>(GetCheckoutStepsDocument, options);
      }
export function useGetCheckoutStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutStepsQuery, GetCheckoutStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutStepsQuery, GetCheckoutStepsQueryVariables>(GetCheckoutStepsDocument, options);
        }
export type GetCheckoutStepsQueryHookResult = ReturnType<typeof useGetCheckoutStepsQuery>;
export type GetCheckoutStepsLazyQueryHookResult = ReturnType<typeof useGetCheckoutStepsLazyQuery>;
export type GetCheckoutStepsQueryResult = Apollo.QueryResult<GetCheckoutStepsQuery, GetCheckoutStepsQueryVariables>;
export const UpdateCheckoutStepsDocument = gql`
    mutation UpdateCheckoutSteps($bookingId: Int!, $checkoutSteps: CheckoutStepsInput!) {
  updateCheckoutSteps(booking_id: $bookingId, checkout_steps: $checkoutSteps) {
    id
    imminent_departure
    readonly_insurance
    route
    steps {
      order
      status
      name
    }
    response_status {
      message
      success
      code
    }
  }
}
    `;
export type UpdateCheckoutStepsMutationFn = Apollo.MutationFunction<UpdateCheckoutStepsMutation, UpdateCheckoutStepsMutationVariables>;

/**
 * __useUpdateCheckoutStepsMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutStepsMutation, { data, loading, error }] = useUpdateCheckoutStepsMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      checkoutSteps: // value for 'checkoutSteps'
 *   },
 * });
 */
export function useUpdateCheckoutStepsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutStepsMutation, UpdateCheckoutStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutStepsMutation, UpdateCheckoutStepsMutationVariables>(UpdateCheckoutStepsDocument, options);
      }
export type UpdateCheckoutStepsMutationHookResult = ReturnType<typeof useUpdateCheckoutStepsMutation>;
export type UpdateCheckoutStepsMutationResult = Apollo.MutationResult<UpdateCheckoutStepsMutation>;
export type UpdateCheckoutStepsMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutStepsMutation, UpdateCheckoutStepsMutationVariables>;
export const CreateFilesDocument = gql`
    mutation CreateFiles($fileInputs: [CreateFileInput!]!) {
  createFiles(file_inputs: $fileInputs) {
    id
    name
    url
    created
    updated
  }
}
    `;
export type CreateFilesMutationFn = Apollo.MutationFunction<CreateFilesMutation, CreateFilesMutationVariables>;

/**
 * __useCreateFilesMutation__
 *
 * To run a mutation, you first call `useCreateFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilesMutation, { data, loading, error }] = useCreateFilesMutation({
 *   variables: {
 *      fileInputs: // value for 'fileInputs'
 *   },
 * });
 */
export function useCreateFilesMutation(baseOptions?: Apollo.MutationHookOptions<CreateFilesMutation, CreateFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFilesMutation, CreateFilesMutationVariables>(CreateFilesDocument, options);
      }
export type CreateFilesMutationHookResult = ReturnType<typeof useCreateFilesMutation>;
export type CreateFilesMutationResult = Apollo.MutationResult<CreateFilesMutation>;
export type CreateFilesMutationOptions = Apollo.BaseMutationOptions<CreateFilesMutation, CreateFilesMutationVariables>;
export const CreateFileDocument = gql`
    mutation CreateFile($fileInput: CreateFileInput!) {
  createFile(file_input: $fileInput) {
    id
    name
    url
    created
    updated
  }
}
    `;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      fileInput: // value for 'fileInput'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($id: Int!) {
  deleteFile(id: $id) {
    response_status {
      code
      success
      message
    }
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const GetHandoffByBookingIdDocument = gql`
    query GetHandoffByBookingId($bookingId: Int!) {
  getHandoffByBookingId(booking_id: $bookingId) {
    ...HandoffResParts
  }
}
    ${HandoffResPartsFragmentDoc}`;

/**
 * __useGetHandoffByBookingIdQuery__
 *
 * To run a query within a React component, call `useGetHandoffByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoffByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoffByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetHandoffByBookingIdQuery(baseOptions: Apollo.QueryHookOptions<GetHandoffByBookingIdQuery, GetHandoffByBookingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandoffByBookingIdQuery, GetHandoffByBookingIdQueryVariables>(GetHandoffByBookingIdDocument, options);
      }
export function useGetHandoffByBookingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandoffByBookingIdQuery, GetHandoffByBookingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandoffByBookingIdQuery, GetHandoffByBookingIdQueryVariables>(GetHandoffByBookingIdDocument, options);
        }
export type GetHandoffByBookingIdQueryHookResult = ReturnType<typeof useGetHandoffByBookingIdQuery>;
export type GetHandoffByBookingIdLazyQueryHookResult = ReturnType<typeof useGetHandoffByBookingIdLazyQuery>;
export type GetHandoffByBookingIdQueryResult = Apollo.QueryResult<GetHandoffByBookingIdQuery, GetHandoffByBookingIdQueryVariables>;
export const UpdateHandoffDocument = gql`
    mutation UpdateHandoff($handoffInput: HandoffInput!) {
  updateHandoff(handoff_input: $handoffInput) {
    ...HandoffResParts
  }
}
    ${HandoffResPartsFragmentDoc}`;
export type UpdateHandoffMutationFn = Apollo.MutationFunction<UpdateHandoffMutation, UpdateHandoffMutationVariables>;

/**
 * __useUpdateHandoffMutation__
 *
 * To run a mutation, you first call `useUpdateHandoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHandoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHandoffMutation, { data, loading, error }] = useUpdateHandoffMutation({
 *   variables: {
 *      handoffInput: // value for 'handoffInput'
 *   },
 * });
 */
export function useUpdateHandoffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHandoffMutation, UpdateHandoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHandoffMutation, UpdateHandoffMutationVariables>(UpdateHandoffDocument, options);
      }
export type UpdateHandoffMutationHookResult = ReturnType<typeof useUpdateHandoffMutation>;
export type UpdateHandoffMutationResult = Apollo.MutationResult<UpdateHandoffMutation>;
export type UpdateHandoffMutationOptions = Apollo.BaseMutationOptions<UpdateHandoffMutation, UpdateHandoffMutationVariables>;
export const GetLocationByIdDocument = gql`
    query GetLocationById($currentLocationId: Int) {
  getLocationById(id: $currentLocationId) {
    id
    response_status {
      success
      code
      message
    }
    availability {
      days {
        sunday {
          ...LocationAvailabilityParts
        }
        monday {
          ...LocationAvailabilityParts
        }
        tuesday {
          ...LocationAvailabilityParts
        }
        wednesday {
          ...LocationAvailabilityParts
        }
        thursday {
          ...LocationAvailabilityParts
        }
        friday {
          ...LocationAvailabilityParts
        }
        saturday {
          ...LocationAvailabilityParts
        }
      }
    }
  }
}
    ${LocationAvailabilityPartsFragmentDoc}`;

/**
 * __useGetLocationByIdQuery__
 *
 * To run a query within a React component, call `useGetLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByIdQuery({
 *   variables: {
 *      currentLocationId: // value for 'currentLocationId'
 *   },
 * });
 */
export function useGetLocationByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
      }
export function useGetLocationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
        }
export type GetLocationByIdQueryHookResult = ReturnType<typeof useGetLocationByIdQuery>;
export type GetLocationByIdLazyQueryHookResult = ReturnType<typeof useGetLocationByIdLazyQuery>;
export type GetLocationByIdQueryResult = Apollo.QueryResult<GetLocationByIdQuery, GetLocationByIdQueryVariables>;
export const CreateClientTokenDocument = gql`
    mutation CreateClientToken {
  createClientToken {
    clientToken
    clientMutationId
  }
}
    `;
export type CreateClientTokenMutationFn = Apollo.MutationFunction<CreateClientTokenMutation, CreateClientTokenMutationVariables>;

/**
 * __useCreateClientTokenMutation__
 *
 * To run a mutation, you first call `useCreateClientTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientTokenMutation, { data, loading, error }] = useCreateClientTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateClientTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientTokenMutation, CreateClientTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientTokenMutation, CreateClientTokenMutationVariables>(CreateClientTokenDocument, options);
      }
export type CreateClientTokenMutationHookResult = ReturnType<typeof useCreateClientTokenMutation>;
export type CreateClientTokenMutationResult = Apollo.MutationResult<CreateClientTokenMutation>;
export type CreateClientTokenMutationOptions = Apollo.BaseMutationOptions<CreateClientTokenMutation, CreateClientTokenMutationVariables>;
export const CreateQuoteDeliveryProposalDocument = gql`
    mutation CreateQuoteDeliveryProposal($quoteRequest: QuoteRequestInput!) {
  createQuote(quote_request: $quoteRequest) {
    delivery_item {
      price
    }
    delivery {
      estimated_distance
    }
    response_status {
      code
      success
      message
    }
  }
}
    `;
export type CreateQuoteDeliveryProposalMutationFn = Apollo.MutationFunction<CreateQuoteDeliveryProposalMutation, CreateQuoteDeliveryProposalMutationVariables>;

/**
 * __useCreateQuoteDeliveryProposalMutation__
 *
 * To run a mutation, you first call `useCreateQuoteDeliveryProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteDeliveryProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteDeliveryProposalMutation, { data, loading, error }] = useCreateQuoteDeliveryProposalMutation({
 *   variables: {
 *      quoteRequest: // value for 'quoteRequest'
 *   },
 * });
 */
export function useCreateQuoteDeliveryProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteDeliveryProposalMutation, CreateQuoteDeliveryProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteDeliveryProposalMutation, CreateQuoteDeliveryProposalMutationVariables>(CreateQuoteDeliveryProposalDocument, options);
      }
export type CreateQuoteDeliveryProposalMutationHookResult = ReturnType<typeof useCreateQuoteDeliveryProposalMutation>;
export type CreateQuoteDeliveryProposalMutationResult = Apollo.MutationResult<CreateQuoteDeliveryProposalMutation>;
export type CreateQuoteDeliveryProposalMutationOptions = Apollo.BaseMutationOptions<CreateQuoteDeliveryProposalMutation, CreateQuoteDeliveryProposalMutationVariables>;
export const GetQuoteByIdDocument = gql`
    query GetQuoteById($quoteId: String) {
  getQuoteById(quote_id: $quoteId) {
    id
    to
    from
    discount_code
    rental_summary {
      id
    }
    waiver_summary {
      owner_completed
      renter_completed
      description
    }
    is_request_less_than_minimum_days
    response_status {
      code
      success
      message
    }
  }
}
    `;

/**
 * __useGetQuoteByIdQuery__
 *
 * To run a query within a React component, call `useGetQuoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteByIdQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetQuoteByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteByIdQuery, GetQuoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteByIdQuery, GetQuoteByIdQueryVariables>(GetQuoteByIdDocument, options);
      }
export function useGetQuoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteByIdQuery, GetQuoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteByIdQuery, GetQuoteByIdQueryVariables>(GetQuoteByIdDocument, options);
        }
export type GetQuoteByIdQueryHookResult = ReturnType<typeof useGetQuoteByIdQuery>;
export type GetQuoteByIdLazyQueryHookResult = ReturnType<typeof useGetQuoteByIdLazyQuery>;
export type GetQuoteByIdQueryResult = Apollo.QueryResult<GetQuoteByIdQuery, GetQuoteByIdQueryVariables>;
export const GetRentalInsuranceBundlesDocument = gql`
    query GetRentalInsuranceBundles($rentalId: Int!, $presentmentCurrency: String, $from: String, $to: String, $delivery: Boolean) {
  getRentalInsuranceBundles(
    rentalId: $rentalId
    presentment_currency: $presentmentCurrency
    from: $from
    to: $to
    delivery: $delivery
  ) {
    rentalBundles {
      bundle_features {
        category
        items {
          name
          position
          type
        }
      }
      dealer_owned_renter
      deductible
      default_selection
      delivery
      description
      id
      insurance_protection
      name
      note
      price_per_day
      property_damage
      subtext
      supported_types
      tier
      total_price
    }
    response_status {
      message
      success
      code
    }
  }
}
    `;

/**
 * __useGetRentalInsuranceBundlesQuery__
 *
 * To run a query within a React component, call `useGetRentalInsuranceBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalInsuranceBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalInsuranceBundlesQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      presentmentCurrency: // value for 'presentmentCurrency'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useGetRentalInsuranceBundlesQuery(baseOptions: Apollo.QueryHookOptions<GetRentalInsuranceBundlesQuery, GetRentalInsuranceBundlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalInsuranceBundlesQuery, GetRentalInsuranceBundlesQueryVariables>(GetRentalInsuranceBundlesDocument, options);
      }
export function useGetRentalInsuranceBundlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalInsuranceBundlesQuery, GetRentalInsuranceBundlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalInsuranceBundlesQuery, GetRentalInsuranceBundlesQueryVariables>(GetRentalInsuranceBundlesDocument, options);
        }
export type GetRentalInsuranceBundlesQueryHookResult = ReturnType<typeof useGetRentalInsuranceBundlesQuery>;
export type GetRentalInsuranceBundlesLazyQueryHookResult = ReturnType<typeof useGetRentalInsuranceBundlesLazyQuery>;
export type GetRentalInsuranceBundlesQueryResult = Apollo.QueryResult<GetRentalInsuranceBundlesQuery, GetRentalInsuranceBundlesQueryVariables>;
export const SearchPopularParksDocument = gql`
    query SearchPopularParks($lat: Float, $lon: Float) {
  searchPopularParks(lat: $lat, lon: $lon) {
    parks {
      locale
      metadata
      id
    }
  }
}
    `;

/**
 * __useSearchPopularParksQuery__
 *
 * To run a query within a React component, call `useSearchPopularParksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPopularParksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPopularParksQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lon: // value for 'lon'
 *   },
 * });
 */
export function useSearchPopularParksQuery(baseOptions?: Apollo.QueryHookOptions<SearchPopularParksQuery, SearchPopularParksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPopularParksQuery, SearchPopularParksQueryVariables>(SearchPopularParksDocument, options);
      }
export function useSearchPopularParksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPopularParksQuery, SearchPopularParksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPopularParksQuery, SearchPopularParksQueryVariables>(SearchPopularParksDocument, options);
        }
export type SearchPopularParksQueryHookResult = ReturnType<typeof useSearchPopularParksQuery>;
export type SearchPopularParksLazyQueryHookResult = ReturnType<typeof useSearchPopularParksLazyQuery>;
export type SearchPopularParksQueryResult = Apollo.QueryResult<SearchPopularParksQuery, SearchPopularParksQueryVariables>;
export const GetRentalByIdDocument = gql`
    query GetRentalById($locale: String, $rentalId: Int!) {
  getRentalById(locale: $locale, rentalId: $rentalId) {
    id
    slug
    has_checkout_questions
    owner {
      created
      slug
      id
      first_name
      last_name
      business_name
      avatar_url
      dealer
      description
      business_description
      average_response_time
      bank_country
      country
    }
    current_location_id
    presentment_currency
    settlement_currency
    instant_book
    response_status {
      code
      success
      message
    }
  }
}
    `;

/**
 * __useGetRentalByIdQuery__
 *
 * To run a query within a React component, call `useGetRentalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      rentalId: // value for 'rentalId'
 *   },
 * });
 */
export function useGetRentalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRentalByIdQuery, GetRentalByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalByIdQuery, GetRentalByIdQueryVariables>(GetRentalByIdDocument, options);
      }
export function useGetRentalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalByIdQuery, GetRentalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalByIdQuery, GetRentalByIdQueryVariables>(GetRentalByIdDocument, options);
        }
export type GetRentalByIdQueryHookResult = ReturnType<typeof useGetRentalByIdQuery>;
export type GetRentalByIdLazyQueryHookResult = ReturnType<typeof useGetRentalByIdLazyQuery>;
export type GetRentalByIdQueryResult = Apollo.QueryResult<GetRentalByIdQuery, GetRentalByIdQueryVariables>;
export const GetRentalServicesDocument = gql`
    query GetRentalServices($rentalId: Int!) {
  getRentalServices(rental_id: $rentalId) {
    ...ServicesResParts
  }
}
    ${ServicesResPartsFragmentDoc}`;

/**
 * __useGetRentalServicesQuery__
 *
 * To run a query within a React component, call `useGetRentalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalServicesQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *   },
 * });
 */
export function useGetRentalServicesQuery(baseOptions: Apollo.QueryHookOptions<GetRentalServicesQuery, GetRentalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalServicesQuery, GetRentalServicesQueryVariables>(GetRentalServicesDocument, options);
      }
export function useGetRentalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalServicesQuery, GetRentalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalServicesQuery, GetRentalServicesQueryVariables>(GetRentalServicesDocument, options);
        }
export type GetRentalServicesQueryHookResult = ReturnType<typeof useGetRentalServicesQuery>;
export type GetRentalServicesLazyQueryHookResult = ReturnType<typeof useGetRentalServicesLazyQuery>;
export type GetRentalServicesQueryResult = Apollo.QueryResult<GetRentalServicesQuery, GetRentalServicesQueryVariables>;
export const GetBookingServicesDocument = gql`
    query GetBookingServices($bookingId: Int!) {
  getBookingServices(booking_id: $bookingId) {
    ...ServicesResParts
  }
}
    ${ServicesResPartsFragmentDoc}`;

/**
 * __useGetBookingServicesQuery__
 *
 * To run a query within a React component, call `useGetBookingServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingServicesQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingServicesQuery(baseOptions: Apollo.QueryHookOptions<GetBookingServicesQuery, GetBookingServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingServicesQuery, GetBookingServicesQueryVariables>(GetBookingServicesDocument, options);
      }
export function useGetBookingServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingServicesQuery, GetBookingServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingServicesQuery, GetBookingServicesQueryVariables>(GetBookingServicesDocument, options);
        }
export type GetBookingServicesQueryHookResult = ReturnType<typeof useGetBookingServicesQuery>;
export type GetBookingServicesLazyQueryHookResult = ReturnType<typeof useGetBookingServicesLazyQuery>;
export type GetBookingServicesQueryResult = Apollo.QueryResult<GetBookingServicesQuery, GetBookingServicesQueryVariables>;
export const GetQuoteServicesDocument = gql`
    query GetQuoteServices($quoteId: String!) {
  getQuoteServices(quote_id: $quoteId) {
    ...ServicesResParts
  }
}
    ${ServicesResPartsFragmentDoc}`;

/**
 * __useGetQuoteServicesQuery__
 *
 * To run a query within a React component, call `useGetQuoteServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteServicesQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetQuoteServicesQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteServicesQuery, GetQuoteServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteServicesQuery, GetQuoteServicesQueryVariables>(GetQuoteServicesDocument, options);
      }
export function useGetQuoteServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteServicesQuery, GetQuoteServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteServicesQuery, GetQuoteServicesQueryVariables>(GetQuoteServicesDocument, options);
        }
export type GetQuoteServicesQueryHookResult = ReturnType<typeof useGetQuoteServicesQuery>;
export type GetQuoteServicesLazyQueryHookResult = ReturnType<typeof useGetQuoteServicesLazyQuery>;
export type GetQuoteServicesQueryResult = Apollo.QueryResult<GetQuoteServicesQuery, GetQuoteServicesQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  getCountries {
    countries {
      code
      name
    }
    response_status {
      code
      success
      message
    }
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const RegionsDocument = gql`
    query Regions($countryCode: String!) {
  getRegions(countryCode: $countryCode) {
    regions {
      code
      name
    }
    response_status {
      code
      success
      message
    }
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useRegionsQuery(baseOptions: Apollo.QueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsQueryResult = Apollo.QueryResult<RegionsQuery, RegionsQueryVariables>;
export const GetCancellationPolicyDocument = gql`
    query GetCancellationPolicy($input: CancellationPolicyInput) {
  getCancellationPolicy(input: $input) {
    policy_v2 {
      markdown
      title
    }
    policy {
      free_cancel_message
    }
    payment_policy {
      details {
        title
        list_items
      }
      refundable_message
      refundable_note
      name
    }
  }
}
    `;

/**
 * __useGetCancellationPolicyQuery__
 *
 * To run a query within a React component, call `useGetCancellationPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCancellationPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>(GetCancellationPolicyDocument, options);
      }
export function useGetCancellationPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>(GetCancellationPolicyDocument, options);
        }
export type GetCancellationPolicyQueryHookResult = ReturnType<typeof useGetCancellationPolicyQuery>;
export type GetCancellationPolicyLazyQueryHookResult = ReturnType<typeof useGetCancellationPolicyLazyQuery>;
export type GetCancellationPolicyQueryResult = Apollo.QueryResult<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($userId: Int!) {
  user(user_id: $userId) {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: Int!, $userInput: UserInput!) {
  updateUser(user_id: $userId, input: $userInput) {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const MiniMeDocument = gql`
    query MiniMe {
  me {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useMiniMeQuery__
 *
 * To run a query within a React component, call `useMiniMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiniMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiniMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMiniMeQuery(baseOptions?: Apollo.QueryHookOptions<MiniMeQuery, MiniMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MiniMeQuery, MiniMeQueryVariables>(MiniMeDocument, options);
      }
export function useMiniMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MiniMeQuery, MiniMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MiniMeQuery, MiniMeQueryVariables>(MiniMeDocument, options);
        }
export type MiniMeQueryHookResult = ReturnType<typeof useMiniMeQuery>;
export type MiniMeLazyQueryHookResult = ReturnType<typeof useMiniMeLazyQuery>;
export type MiniMeQueryResult = Apollo.QueryResult<MiniMeQuery, MiniMeQueryVariables>;